// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/back-to-home.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/lx-card_plane.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/lx-card_arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/patternBG.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/home_banner.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../images/envelope-regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/x-twitter.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/facebook.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../images/linkedin-in.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../images/whatsapp.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gVXBsb2FkZWQgdG86IFNWRyBSZXBvLCB3d3cuc3ZncmVwby5jb20sIEdlbmVyYXRvcjogU1ZHIFJlcG8gTWl4ZXIgVG9vbHMgLS0+CjxzdmcgZmlsbD0iIzAwMDAwMCIgd2lkdGg9IjgwMHB4IiBoZWlnaHQ9IjgwMHB4IiB2aWV3Qm94PSIwIDAgMzIgMzIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjx0aXRsZT5zaGFyZS1ub2RlczwvdGl0bGU+DQo8cGF0aCBkPSJNMjYgMjEuMjVjLTEuNTgxIDAuMDAzLTIuOTgxIDAuNzgxLTMuODM5IDEuOTc0bC0wLjAxMCAwLjAxNC0xMS42NDItNS44MjFjMC4xNTItMC40MjIgMC4yNC0wLjkwOSAwLjI0LTEuNDE3cy0wLjA4OC0wLjk5NS0wLjI0OS0xLjQ0N2wwLjAwOSAwLjAzMCAxMS42NDItNS44MmMwLjg3IDEuMTkgMi4yNjEgMS45NTMgMy44MzEgMS45NTMgMi42MTQgMCA0LjczMy0yLjExOSA0LjczMy00LjczM3MtMi4xMTktNC43MzMtNC43MzMtNC43MzNjLTIuNjE0IDAtNC43MzMgMi4xMTktNC43MzMgNC43MzMgMCAwLjAwNiAwIDAuMDEyIDAgMC4wMTh2LTAuMDAxYzAuMDA3IDAuNTA5IDAuMDk1IDAuOTk1IDAuMjUgMS40NDlsLTAuMDEwLTAuMDMzLTExLjY0MiA1LjgyMWMtMC44NzItMS4yMDktMi4yNzctMS45ODctMy44NjQtMS45ODctMi42MjMgMC00Ljc1IDIuMTI3LTQuNzUgNC43NXMyLjEyNyA0Ljc1IDQuNzUgNC43NWMxLjU4NyAwIDIuOTkyLTAuNzc4IDMuODU1LTEuOTc0bDAuMDEwLTAuMDE0IDExLjY0MiA1LjgyMWMtMC4xNDYgMC40MjItMC4yMzMgMC45MDgtMC4yNCAxLjQxNGwtMCAwLjAwM2MwIDIuNjIzIDIuMTI3IDQuNzUgNC43NSA0Ljc1czQuNzUtMi4xMjcgNC43NS00Ljc1YzAtMi42MjMtMi4xMjctNC43NS00Ljc1LTQuNzV2MHpNMjYgMi43NWMxLjc5NSAwIDMuMjUgMS40NTUgMy4yNSAzLjI1cy0xLjQ1NSAzLjI1LTMuMjUgMy4yNWMtMS43OTUgMC0zLjI1LTEuNDU1LTMuMjUtMy4yNXYwYzAuMDAyLTEuNzk0IDEuNDU2LTMuMjQ4IDMuMjUtMy4yNWgwek02IDE5LjI1Yy0xLjc5NSAwLTMuMjUtMS40NTUtMy4yNS0zLjI1czEuNDU1LTMuMjUgMy4yNS0zLjI1YzEuNzk1IDAgMy4yNSAxLjQ1NSAzLjI1IDMuMjV2MGMtMC4wMDIgMS43OTQtMS40NTYgMy4yNDgtMy4yNSAzLjI1aC0wek0yNiAyOS4yNWMtMS43OTUgMC0zLjI1LTEuNDU1LTMuMjUtMy4yNXMxLjQ1NS0zLjI1IDMuMjUtMy4yNWMxLjc5NSAwIDMuMjUgMS40NTUgMy4yNSAzLjI1djBjLTAuMDAxIDEuNzk0LTEuNDU2IDMuMjQ5LTMuMjUgMy4yNWgtMHoiPjwvcGF0aD4NCjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27><path d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../images/web-banner-04.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../images/web-banner-02.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../images/web-banner-06.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../images/lx-hint.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../images/mobile_banner_01.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../images/mobile_banner_02.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../images/mobile_banner_03.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
a,
a:focus,
a:hover,
a:visited,
a:link {
  outline: 0 !important;
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
font,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td {
  background: rgba(0, 0, 0, 0);
  border: 0;
  margin: 0;
  padding: 0;
  vertical-align: baseline;
  outline: none;
  list-style: none;
  -ms-text-shadow: none;
  text-shadow: none;
}

body.active-BW {
  -webkit-filter: grayscale(100%) brightness(95%) contrast(120%);
  -o-filter: grayscale(100%) brightness(95%) contrast(120%);
  -ms-filter: grayscale(100%) brightness(95%) contrast(120%);
  -moz-filter: grayscale(100%) brightness(95%) contrast(120%);
  filter: grayscale(100%) brightness(95%) contrast(120%);
}

.banner-img-cont img{
  height: 17rem !important;
}

.black-white {
  cursor: pointer;
}

body {
  font-family: "Ping AR + LT";
  overflow-x: hidden;
  direction: rtl;
  overflow-y: scroll;
  position: relative;
  background: #E5E7EA;
}

html {
  position: relative;
  min-height: 100%;
}

body {
  text-align: right;
}

footer {
  width: 100%;
}

@-webkit-keyframes spinAround {
  from {
    -webkit-transform: rotate(360deg);
  }

  to {
    -webkit-transform: rotate(0deg);
  }
}

@keyframes spinAround {
  from {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }

  to {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}

.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: none !important;
  animation-fill-mode: none !important;
}

* {
  padding: 0;
  margin: 0;
}

button {
  cursor: pointer;
}

a:hover,
a:visited,
a:link,
a:active {
  text-decoration: none;
}

ul,
p {
  margin: 0px;
  padding: 0px;
}

body {
  color: #595959;
  font-size: 0.9rem;
  padding: 0 !important;
  overflow-y: auto !important;
}

h1 {
  color: #00004E;
  font-size: 1.8em;
  font-weight: bold;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

h1 span {
  color: #9d9d9d;
  font-weight: normal;
  font-size: 1.2rem;
  -webkit-margin-start: 0.5rem;
  margin-inline-start: 0.5rem;
}

.icon {
  width: 100%;
  height: 100%;
}

a {
  text-decoration: none;
}

.welcome-hero {
  background-color: #00BF00;
  padding: 50px 0;
}

.welcome-hero h1 {
  font-size: 2rem;
  font-weight: bold;
  color: #fff;
  margin-bottom: 2rem;
}

.welcome-hero p {
  color: #fff;
  font-size: 1.2rem;
}

.introduction-video {
  padding: 50px 0;  
  position: relative;
  background-color: #F5F6F8;
  z-index: 2;
}

.introduction-video h1 {
  font-size: 2rem;
  font-weight: bold;
  color: #00BF00;
  margin-bottom: 2rem;
  width: 100%;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: start;
}

.introduction-video p {
  font-size: 1.8rem;
  color:#00004E;
  font-weight: 400;
}

.introduction-video .video-container {
  width: 100%;
  margin: 0 auto;
  aspect-ratio: 16/9;
}

.calc-container {
  background-color: #E5E7EA;
  padding: 50px 0 0 0;
  position: relative;
  z-index: 2;
}

.calc-container h1 {
  font-size: 1.75rem;
    font-weight: 700;
    color: white;
    margin-bottom: 2rem;
    width: 100%;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: center;
    text-align: center;
}

.calc-container p {
  font-size: 1.2rem;
}

.calc-container .video-container {
  width: 100%;
  margin: 0 auto;
  aspect-ratio: 16/9;
}

.calc-container .container-area {
  background-color: #00004E !important;
}

/* Style the tab */
.tab {
  overflow: hidden;
  border: 1px solid #ccc;
  background-color: #F3F4F5;
  width: fit-content;
  border-radius: 2rem;
  align-items: center;
  display: flex;
  padding: 0.2rem;
  min-width: 20.5rem;
}

/* Style the buttons inside the tab */
.tab button {
  background-color: inherit;
  float: left;
  border: none;
  outline: none;
  cursor: pointer;
  transition: 0.3s;
  color: #00004e;
  font-weight: 700;
  font-size: 1rem;
  font-weight: 500;
  border-radius: 2rem;
  padding: 0.5rem 1rem;
  min-width: 10rem;
}

/* Change background color of buttons on hover */
.tab button:hover {
  color: #00BF00;
}

/* Create an active/current tablink class */
.tab button.active {
  background-color: #00BF00;
  border-radius: 2rem;
  padding: 0.5rem 1rem;
  min-width: 10rem;
  color: #00004e;
  font-weight: 700;
  font-size: 1rem;
}

/* Style the tab content */
.tabcontent {
  display: none;
}
/* Show the default tab content */
#Individuals_journey {
  /* display: flex; */
}
#business_journey {
    /* display: none; */
    background: #fff;
    border-radius: 2rem;
    padding: 1rem;
}

.journies-section {
  padding: 50px 0 0 0;
  position: relative;
  flex-direction: column;
  margin-top: -10rem;  
  z-index: 2;
  display: flex;
  gap: 1rem;
}

.journies-section h1 {
  position: relative;
  font-size: 1.7em;
  font-weight: bold;
  color: #00BF00;
  margin-bottom: 2rem;
}

.journies-section p {
  position: relative;
  font-size: 1.2rem;
}

.welcome-icon {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  max-width: 30px;
  -webkit-margin-start: 5px;
  margin-inline-start: 5px;
}

.done-icon {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  max-width: 20px;
  margin-top: 5px;
  -webkit-margin-start: 5px;
  margin-inline-start: 5px;
}

.celebrate-icon {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  max-width: 70px;
  margin-top: 5px;
  -webkit-margin-start: 10px;
  margin-inline-start: 10px;
}

.jssocials {
  position: fixed;
  bottom: 150px;
  inset-inline-end: 20px;
  z-index: 9999;
}

.jssocials .jssocials-shares {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin: 0;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.jssocials .jssocials-shares .jssocials-share {
  margin: 0.3rem 0;
}

.jssocials-share-link {
  border-radius: 50%;
}

.jssocials-share-twitter .jssocials-share-link {
  background: #f4f6f8;
  color: #1e1d1d;
}

.jssocials-share-twitter .jssocials-share-link:hover {
  background: #000;
  color: #fff;
}

.jssocials-share-email .jssocials-share-link {
  background: #f4f6f8;
  color: #1e1d1d;
}

.jssocials-share-email .jssocials-share-link:hover {
  background: #0064FF;
  color: #fff;
}

.jssocials-share-facebook .jssocials-share-link {
  background: #f4f6f8;
  color: #1e1d1d;
}

.jssocials-share-facebook .jssocials-share-link:hover {
  background: #334157;
  color: #fff;
}

.jssocials-share-linkedin .jssocials-share-link {
  background: #f4f6f8;
  color: #1e1d1d;
}

.jssocials-share-linkedin .jssocials-share-link:hover {
  background: #0064FF;
  color: #fff;
}

.jssocials-share-whatsapp .jssocials-share-link {
  background: #f4f6f8;
  color: #1e1d1d;
}

.jssocials-share-whatsapp .jssocials-share-link:hover {
  background: #00BF00;
  color: #fff;
}

a {
  color: #00BF00;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

a:hover {
  color: #00BF00;
}

a:focus {
  color: #00BF00;
}

a:active {
  color: #00BF00;
}

.calc-btn-row{
  width: 100%;
  display: flex;
  justify-content: center;
}

.align-sidebar {
  color: rgba(128, 128, 128, 0.3);
  height: 100%;
  left: 0;
  line-height: 2;
  margin: 0;
  position: absolute;
  top: 0;
  -webkit-transform: rotate(-30deg);
  transform: rotate(-30deg);
  -webkit-transform-origin: 0 100%;
  transform-origin: 0 100%;
  width: 250%;
  word-spacing: 20px;
  z-index: 1;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

video,
iframe {
  position: relative;
  z-index: 2;
  border-radius: 15px;
}

.align-sidebar-container {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 1;
  top: 0;
  left: 0;
  display: block;
}

.popup-card {
  max-width: 350px;
  width: 100%;
  
}
@media (max-width: 990px){
    .popup-card.business-popup-card{
      margin: 3rem 0 0 0 !important;
    .card-thumb {
      width: 300px !important ;
      height: 183px !important;
      }
    }
    .popup-card.businessJourney-image{
      display: flex !important;
      justify-content: center !important;
      .card-thumb {
        width: 267px !important;
    
      }
    }

    #business_journey {
      .business_journey_section{
      .article-card .start-journey{
        max-width: 100%;
        width: 70%;
      }
    }
    }
    }

@media (max-width: 600px){
  .card-thumb {
    width: 267px !important;
  }
  .popup-card{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .popup-card.business-popup-card {
    display: flex !important;
    justify-content: center !important;
  .card-thumb {
    width: 267px !important;

  }
}
.card-thumb {
  width: 161px !important;
}
ul.paddingJourney{
  padding: 0.5rem !important;
  }
  ol.paddingJourney{
    padding: 0.5rem !important;
    }
.accordion.businessJourney .accordion-body{
  ul{
  padding: 0rem !important;
  }
  ol{
    padding: 0rem !important;
    }
}
.popup-card.businessJourney-image{
  display: flex !important;
  justify-content: center !important;
  .card-thumb {
    width: 161px !important;
  }
}
.accordion.businessJourney .accordion-body{
  padding: 1rem 1.5rem !important;
}

#business_journey {
  height: 30rem !important;
  .business_journey_section{
    height: 27rem !important;
    .journies-section h1{
      align-items: center;
      font-size: 1.2em !important;
    }
  .popup-card.business-popup-card{
    margin: 3rem 0 0 0;
  .card-thumb {
    width: 300px !important;
    height: 183px !important;
    }
  }
  .article-card .start-journey{
    max-width: 100% !important;
    width: 70% !important;
  }
}

.businessjourney4{
  align-items: center;
  justify-content: center !important;
  height: 23rem !important;
  .business-card-top{
    height: 10rem !important;

    .jur-button-cont{
    height: 0rem;
    position: relative;
    width: 80%;
    right: unset;
    align-items: center;
    justify-content: center;
    display: flex !important;
    margin: auto;
    top: 8.8rem !important;
    z-index: 2;    

  }
  }
}
}
}
.popup-card .card-thumb {
  width: 350px;
  height: 220px;
  border-radius: 0.5rem;
  overflow: hidden;
  position: relative;
  border: 2px solid #334157;
}

.popup-card .card-thumb img {
  max-width: 100%;
  min-height: 100%;
}

.popup-card .card-thumb .card-play {
  width: 40px;
  height: 40px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  border-radius: 50px;
  background-color: #00BF00;
  color: #fff;
  position: absolute;
  z-index: 1;
  top: 50%;
  margin-top: -20px;
  left: 50%;
  margin-left: -20px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.popup-card button {
  border: 0 none;
  border-radius: 0.5rem;
  overflow: hidden;
}

.popup-card h3 {
  font-size: 1.2rem;
  color: #333371;
  font-weight: bold;
  text-align: center;
  margin-top: 8px;
}

.popup-card:last-of-type {
  -webkit-margin-end: 0;
  margin-inline-end: 0;
}

.modal-title {
  color: #333371;
}



.main-heading {
  color: #33CC33;
  font-weight: bold;
  font-size: 1rem;
  text-align: right;
  width: 100%;
}

header .top-bar {
  width: 100%;
  height: 52px;
  background-color: #00004E;
}

header nav {
  background-color: #fff;
  padding: 0;
  -webkit-box-shadow: 0 8px 12px 0px rgba(0, 0, 0, 0.1);
  box-shadow: 0 8px 12px 0px rgba(0, 0, 0, 0.1);
}

header nav .navbar-brand {
  padding: 0px;
}

header nav .navbar-brand img {
  width: 100%;
  max-height: 5rem;
}
header nav .navbar-brand .logo-desktop {
  display: inline-block;
  width: 8rem;
}
header nav .navbar-brand .logo-mobile {
  display: none;
}

header .welcome-message {
  color: #fff;
  background-color: #00BF00;
  font-weight: bold;
  padding: 0.8rem 0;
  text-align: center;
  font-size: 1.2rem;
}

.mobile-header {
  display: none;
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  z-index: 999;
  height: 65px;
  padding-inline-start: 20px;
  padding-inline-end: 20px;
  padding-top: 15px;
}

.mobile-header .backHome {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 40px;
  height: 40px;
  color: #1e1d1d;
  /* background: #00004E; */
  text-align: center;
  font-size: 22px;
  border-radius: 50%;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 1px solid #00BF00;
}

.mobile-header .backHome .home-mask {
  background: #1e1d1d;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center no-repeat;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center no-repeat;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}

.mobile-header .backHome:hover .home-mask {
  background-color: #334157;
}

.mobile-header .navbar-toggler {
  background-color: #00BF00;
  width: 40px;
  height: 40px;
  border-radius: 50px;
  position: relative;
  right: 0;
}


.mobile-header .navbar-toggler::before {
  content: "";
  width: 20px;
  height: 2px;
  border-radius: 3px;
  position: absolute;
  top: 13px;
  right: 10px;
  background-color: #00004E;
}

.mobile-header .navbar-toggler::after {
  content: "";
  width: 20px;
  height: 2px;
  border-radius: 3px;
  position: absolute;
  top: auto;
  bottom: 13px;
  right: 10px;
  background-color: #00004E
}

.mobile-header .navbar-toggler .navbar-toggler-icon {
  width: 20px;
  height: 2px;
  border-radius: 3px;
  position: absolute;
  top: 19px;
  right: 10px;
  background-color: #00004E;
}

@media screen and (max-width: 991px) {
  .mobile-header {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }

  .temp-height{
    width: 33.96375rem;
  }
  .my_top_section {
    align-items: center;
}
}

.offcanvas-header .btn-close {
  top: 10px;
  left: 10px;
  position: absolute;
  z-index: 99999;
  -webkit-filter: none;
  filter: none;
}

.offcanvas-header .btn-close:focus {
  -webkit-box-shadow: 0 8px 12px -13px rgba(0, 0, 0, 0);
  box-shadow: 0 8px 12px -13px rgba(0, 0, 0, 0);
}

.backWebsite {
  background-color: #00BF00;
  color: #00004E;
  padding: 0.5rem 1.2rem;
  border-radius: 10px;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  font-weight: bold;
}

.backWebsite:hover {
  background-color: #80DF80;
  color: #00004E;
}

.backWebsite:focus {
  background-color: #BFEFBF;
  color: #00004E;
}

footer .footer-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  width: 100%;
  padding: 1rem 0;
  margin-top: 1rem;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

footer .brand-logo {
  -webkit-margin-end: 0.5rem;
  margin-inline-end: 0.5rem;
}

footer .brand-logo img {
  width: 140px;
  max-height: 60px;
}

.article-card {
  border-radius: 16px 16px 26px 26px;
  overflow: hidden;
  /* height: 94%; */
  border: 1px solid #D8DBDD;

  padding-bottom: 0.75rem;
}
.journey1{
  background-color:#00BF00;
}
.journey4{
  background-color: #A37DFC; 
}
.journey3{
  background-color:#00004E ; 
}
.businessjourney4{
  background-color: #00004E;
  height: 18rem ;
  display: flex;
  justify-content: space-between;
}
.business-card-top{
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;

}
#business_journey {
  .business_journey_section{
  .article-card .start-journey{
    max-width: 50% ;
  }
  .business-card-top{
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: space-between;
    .info-cards{
      .info-card{
        margin: 2rem 1rem;
       .info-hint2{
        font-size: 1.875em;
        padding-bottom: 0.75rem;
        text-align: right;
        width: 90%;
        }
        .info-hint3 {
          font-size: 1.2rem;
          text-align: right;
      }
      }
    }
  
  }
  img {
    transform: translateX(4%) translatey(11%);
    pointer-events: none;
    height: 17rem;
  }
  .popup-card.business-popup-card{
    max-width: 312px;
    display: flex !important;
    justify-content: center !important;

    .card-thumb {
      width: 320px !important;
      height: 200px !important;
    }
  }
}
}
.banner-cont{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.banner-img-cont{
  width: fit-content;
  display: inline-block;
  text-align: left;
}
.article-card figure {
  position: relative;
  width: 100%;
  /* overflow: hidden; */
  display: block;
  min-height: 12.318125rem;
  margin-bottom: 0;
}

.article-card figure img {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  /* width: 90%; */
  pointer-events: none;
  object-fit: contain;
  bottom: -6rem;
}

.article-card time {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-bottom: 1px solid #f4f4f4;
  padding: 0.5rem 0.75rem;
  color: #9d9d9d;
}

.article-card time img {
  margin-left: 0.25rem;
  margin-top: 0.15rem;
}

.article-card h2 {
  color: #00122D;
  font-size: 1rem;
  font-weight: bold;
  margin-top: 1.75rem;
  margin-bottom: 1.18rem;
  width: fit-content;
  background: rgba(191, 239, 191, 0.5);
  padding: 0.5rem 1.5rem 0.5rem 1rem;
  border-radius: 5px;
}



.article-card .start-journey {
      /* width: calc(100% - 1.5rem); */
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      background-color: #00BF00;
      padding: 1rem;
      /* padding-right: 1.68rem; */
      bottom: 1rem;
      margin-left: 1rem;
      margin-right: 1rem;
      border-radius: 5rem;
      min-height: 3.25rem;
      color: #00004E;
}

.article-card .start-journey:hover {
    color: #00004E;
}

.article-card .start-journey:focus {
  border: 3px solid #00BF00;
  color: #00BF00;
}

.article-card .start-journey .icon-container {
  width: 32px;
  height: 32px;
  background-color: #fff;
  border-radius: 50%;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 32px;
  flex: 0 0 32px;
  padding: 3px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.article-card .start-journey .icon-container .icon {
  background: #00BF00;
}

.article-card .start-journey .icon-container .plane-mask {
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center center no-repeat;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center center no-repeat;
}

.article-card .start-journey .start-journey-text {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  /* -webkit-padding-end: 2.5rem;
  padding-inline-end: 2.5rem; */
  
  position: relative;
}

.article-card .start-journey .start-journey-text h6 {
  font-size: 1.2rem;
  margin-bottom: 0.2rem;
}

.article-card .start-journey .start-journey-text .icon-container {
  background-color: rgba(0, 0, 0, 0);
  position: absolute;
  left: 0.5rem;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.article-card .start-journey .start-journey-text .icon {
  background: #00004E;
  margin-top: 0.2rem;
}

.article-card .start-journey .start-journey-text .arrow-mask {
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center center no-repeat;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center center no-repeat;
}

.journeys {
  padding-top: 32px;
  padding-bottom: 40px;
  position: relative;
  z-index: 2;
  padding-right: 0rem;
  padding-left: 0rem;
}

@media (min-width: 576px) {
  .journeys {
    padding-right: 2rem;
    padding-left: 2rem;
  }
}


.journeys a {
  margin: 0 1rem;
}

.journeys a:hover .article-card {
  -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}

.journeys a:hover .article-card .start-journey {
  background-color: #00BF00;
}

.journeys a:hover .article-card .start-journey .start-journey-text .icon-container {
  left: 0;
}

.journeys a:first-of-type {
  margin-right: 0;
}

.journeys .swiper-button-prev:after,
.journeys.swiper-rtl .swiper-button-next:after {
  font-size: 0.8rem;
  color: #9d9d9d;
}

.journeys .swiper-button-next:after,
.journeys.swiper-rtl .swiper-button-prev:after {
  font-size: 0.8rem;
  color: #9d9d9d;
}

.journeys .swiper-button-next,
.journeys.swiper-rtl .swiper-button-prev {
  right: auto;
  left: 50%;
  margin-left: 5px;
}

.journeys .swiper-button-prev,
.journeys.swiper-rtl .swiper-button-next {
  left: 50%;
  margin-left: -45px;
  right: auto;
}

.journeys .swiper-button-next,
.journeys .swiper-button-prev {
  top: auto;
  background: #fff;
  border: 1px solid #00BF00;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  bottom: 0px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.journeys .swiper-button-next:hover,
.journeys .swiper-button-prev:hover {
  background-color: #00BF00;
}

.journeys .swiper-button-next:hover::after,
.journeys .swiper-button-prev:hover::after {
  color: #fff;
}

@media screen and (max-width: 500px) {
  .journeys {
    padding-top: 110px;
  }
}

@media screen and (max-width: 330px) {
  .journeys {
    padding-top: 130px;
  }
}




.journey-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
}

@media screen and (min-width: 1024px) {
  .journey-container {
    -webkit-padding-start: 320px;
    padding-inline-start: 320px;
  }

  .journey-container .navbar-toggler {
    display: none;
  }

  .journey-container .offcanvas {
    position: fixed;
    visibility: visible;
    -webkit-transform: none;
    transform: none;
    height: 100vh;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    min-width: 320px;
    max-width: 320px;
  }

  .journey-container .offcanvas .btn-close {
    display: none;
  }

}
@media screen and (max-width: 1024px) {
  .banner-img-cont img{
    height: 17.5rem !important;
  }
  .business-journey-cover {
    img {
      max-width: 400px ;
    }
    h1,.welcome-business{
      font-size: 1.5rem;    
    }

  }
}
.journey-container .offcanvas {
  background-color: #fff !important;
}

.journey-container .offcanvas-header {
  padding: 0 30px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-height: 115px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-shadow: 0 8px 12px -13px rgba(0, 0, 0, 0.6);
  box-shadow: 0 8px 12px -13px rgba(0, 0, 0, 0.6);
}

.journey-container .offcanvas-header p {
  color: #9d9d9d;
  font-size: 1rem;
}

.journey-container .offcanvas-header h3 {
  font-size: 1.2rem;
  color: #00BF00;
  font-weight: bold;
}

.journey-container .offcanvas-body {
  padding: 20px 30px;
  padding-left: 20px;
}

.journey-container .offcanvas-body .navbar-nav .nav-item {
  position: relative;
}

.journey-container .offcanvas-body .navbar-nav .nav-item .nav-link {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 1rem 0.5rem;
  padding-right: 1rem;
  font-size: 1.2rem;
  position: relative;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.journey-container .offcanvas-body .navbar-nav .nav-item .nav-link span {
  display: none;
}

.journey-container .offcanvas-body .navbar-nav .nav-item .nav-link::before {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 50px;
  background-color: #c3c4c9;
  position: absolute;
  right: -5px;
  top: 50%;
  margin-top: -2px;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  z-index: 3;
}

.journey-container .offcanvas-body .navbar-nav .nav-item .nav-link::after {
  content: "";
  width: 2px;
  height: 100%;
  position: absolute;
  bottom: 0;
  right: 0;
  background-color: #c3c4c9;
  z-index: 1;
}

.journey-container .offcanvas-body .navbar-nav .nav-item .nav-link:hover {
  color: #00BF00;
}

.journey-container .offcanvas-body .navbar-nav .nav-item .nav-link:hover::before {
  background-color: #00BF00;
}

.journey-container .offcanvas-body .navbar-nav .nav-item .nav-link.visited {
  color: #00004E;
}

.journey-container .offcanvas-body .navbar-nav .nav-item .nav-link.visited::before {
  background-color: #00BF00;
}

.journey-container .offcanvas-body .navbar-nav .nav-item .nav-link.active {
  color: #0064FF;
  background-color: #BFEFBF;
}

.journey-container .offcanvas-body .navbar-nav .nav-item .nav-link.active span {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 10px;
  position: absolute;
  background-color: #00BF00;
  top: 50%;
  margin-top: -6px;
  right: -8px;
  z-index: 2;
}

.journey-container .offcanvas-body .navbar-nav .nav-item .nav-link.active::before {
  background-color: #fff;
  width: 6px;
  height: 6px;
  right: -3px;
  margin-top: -1px;
}

.journey-container .journey-page-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  width: calc(100% - 320px);
}

.journey-container .journey-page-content .pageContent {
  width: 100%;
}

.journey-container .journey-page-content .pageContent .swiper-slide {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  overflow-x: hidden;
}

.journey-container .journey-page-content .pageContent .swiper-slide .journey-default-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.journey-container .journey-page-content .swiper-button-next,
.journey-container .journey-page-content .swiper-button-prev {
  top: 0;
  background: #fff;
  border: 1px solid #00BF00;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  bottom: 50px;
  top: auto;
  left: 20px;
  right: auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: fixed;
}


.swiper-button-prev:hover {
  border: 1px solid #00BF00 !important;
  color: #00BF00 !important;
}
.journey-container .journey-page-content .swiper-button-next:hover{
  background: #80DF80;
}

.journey-container .journey-page-content .swiper-button-next:hover::after,
.journey-container .journey-page-content .swiper-button-prev:hover::after {
  color: #00004E;
}

.journey-container .journey-page-content .swiper-button-prev {
  bottom: 100px;
}

.journey-container .journey-page-content .swiper-button-next {
  background-color: #00BF00;
}

.journey-container .journey-page-content .swiper-button-prev:after,
.journey-container .journey-page-content .swiper-button-next:after {
  font-size: 0.8rem;
  color: #00004E;
}



.journey-container .journey-page-content .swiper-button-next:after {
  color: #00004E;
}

.journey-container .journey-page-content .backHome {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: fixed;
  width: 44px;
  height: 44px;
  color: #1e1d1d;
  background: #f4f6f8;
  text-align: center;
  font-size: 22px;
  border-radius: 50%;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  left: 20px;
  top: 30px;
  z-index: 1021;
  border: 1px solid #333371;
}

.journey-container .journey-page-content .backHome .home-mask {
  position: absolute;
  background: #00004E;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  top: 0;
  left: 0;
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center no-repeat;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center no-repeat;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}

.journey-container .journey-page-content .backHome:hover .home-mask {
  background-color: #334157;
}

@media screen and (max-width: 992px) {
  .journey-container .journey-page-content .backHome {
    display: none;
  }
}

.journey-container .journey-page-content header {
  -webkit-padding-start: 20px;
  padding-inline-start: 20px;
  -webkit-padding-end: 70px;
  padding-inline-end: 70px;
  margin-bottom: 30px;
}

.journey-container .journey-page-content header h3 {
  font-size: 1.8rem;
  color: #00004E;
  padding: 22px 0 7px;
  font-weight: bold;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.journey-container .journey-page-content header h3 .done-icon {
  max-width: 35px;
}

@media screen and (max-width: 991px) {
  .journey-container .journey-page-content header {
    padding-top: 65px;
  }
  .article-card{
    height: 28.505625rem;
  }
  /* .businessjourney4{
    height: 15rem !important;
  } */

}
@media screen and (max-width: 991px) and (min-width: 426) {
  .article-card{
    border: 1px solid #FF0020
  }  
}
.journey-cover.businessJourneyCover {
  background: none !important;
  .newsletter-business{
    /* -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    border-radius: 20px;
    background-color: white;
    padding: 3rem 2rem 2rem; */

        padding: 80px;
        background-color: #fff;
        border-radius: 10px;
        padding: 80px;
        max-width: 55%;
        width: 45%;        
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    a{
      img{
        width: 100px;
        max-width: 100px;
        -webkit-box-shadow: none;
        box-shadow: none;
        border-radius: unset;
        background-color: unset;
      }
    }
  }
}
.journey-cover {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center center;
  background-size: cover;
  width: 100%;
  min-height: 100vh;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  text-align: center;
}

.journey-cover img {
  max-width: 200px;
  -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  border-radius: 20px;
  background-color: white;
}

.journey-cover h1 {
  font-size: 1.5rem;
  font-weight: bold;
  color: #00004E;
  margin-top: 2rem;
  margin-bottom: 1rem;
  line-height: 1.5;
  padding-inline-start: 65px;
  padding-inline-end: 65px;
}
.journey-cover h1.welcomebusiness {
  font-size: 1.5rem;
  font-weight: bold;
  color: #00004E;
  margin-top: 2rem;
  margin-bottom: 1rem;
  line-height: 1.5;
  padding-inline-start: 65px;
  padding-inline-end: 65px;
}
.journey-cover p {
  color: #fff;
}

.business-journey-cover {
  width: 100%;
  min-height: 100vh;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  text-align: center;
}
.business-journey-cover h1 {
  font-size: 1.8rem;
  font-weight: bold;
  color: #00004E;
  /* margin-top: 2rem; */
  margin-bottom: 1rem;
  line-height: 1.5;
  padding-inline-start: 65px;
  padding-inline-end: 65px;
}
.business-journey-cover h1.welcome-business {
  font-size: 1.7rem;
  font-weight: bold;
  color: #00004E;
  margin-top: 2rem;
  line-height: 1.5;
  padding-inline-start: 65px;
  padding-inline-end: 65px;
}

.calc-btn:disabled{
  background-color: #E5E7EA !important;
  border-radius: 0.5rem !important;
  stroke: #808896 !important;
  color: #808896 !important;
  font-weight: 700 !important;
  font-size: 1rem !important;
  width: 100% !important;
  min-width: 100% !important;

}

.calc-btn{
  background-color: #00BF00 !important;
  border-radius: 0.5rem !important;
  stroke: #00004E !important;
  color: #00004E !important;
  font-weight: 600 !important;
  font-size: 1rem !important;
  width: 40% !important;
  /* min-width: 100% !important; */

  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  height: 100% !important ;
  margin: 0 !important;
}

.calc-btn:hover{
  background-color: #80DF80 !important;
}
.calc-btn:focus{
  background-color: #BFEFBF !important;
}

.hint {
  padding: 0.2rem;
  color: #303030;
  -webkit-padding-end: 30px;
  padding-inline-end: 30px;
  background: rgba(254, 208, 47, 0.0509803922);
  border: 1px solid #00BF00;
  border-radius: 50px;
  line-height: 31px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 0.85rem;
  font-weight: bold;
}

.hint .hint-ico {
  width: 40px;
  height: 34px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.hint .hint-ico img {
  width: 24px;
}

.inner-page-content {
  -webkit-padding-start: 20px;
  padding-inline-start: 20px;
  -webkit-padding-end: 70px;
  padding-inline-end: 70px;
  padding-bottom: 70px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  min-height: calc(100vh - 140px);
  position: relative;
  z-index: 2;
}

.icon-card {
  text-align: center;
  padding: 130px 25px 30px;
  max-width: 370px;
  width: 100%;
  margin: 0 auto;
  position: relative;
  min-height: 250px;
  cursor: pointer;
  -webkit-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
}

.icon-card .image {
  margin: auto auto 20px;
  width: 80px;
  height: 80px;
  border: 2.375px solid #E5E7EA;
  -webkit-transition: 0.5s ease-in-out;
  transition: 0.5s ease-in-out;
  position: absolute;
  top: 70px;
  inset-inline-start: 50%;
  -webkit-transform: translate(50%, -50%);
  transform: translate(50%, -50%);
  border-radius: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 13px;
}

.icon-card .image img {
  max-width: 100%;
  max-height: 80px;
}

.icon-card h1 {
  font-weight: bold;
  font-size: 1.5rem;
  margin-top: 0;
  margin-bottom: 30px;
  -webkit-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.icon-card .desc {
  display: none;
  opacity: 0;
  padding: 0;
  font-size: 1.2rem;
  line-height: 1.5;
  -webkit-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
  -webkit-transform: translate3d(0, 10%, 0);
  transform: translate3d(0, 10%, 0);
  overflow: hidden;
}

.icon-card .desc a {
  color: #fff;
  text-decoration: none;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  position: relative;
  padding-bottom: 5px;
}

.icon-card .desc a::after {
  content: "";
  width: 100%;
  height: 2px;
  background-color: #fff;
  position: absolute;
  bottom: 4px;
  right: 0;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  display: inline-block;
}

.icon-card .desc a:hover {
  color: #00BF00;
  text-decoration: none;
}

.icon-card .desc a:hover::after {
  background-color: #00BF00;
}

.icon-card .desc a:focus {
  color: #00BF00;
  text-decoration: underline;
}

.icon-card .desc a:focus::after {
  background-color: #00BF00;
}

.icon-card .tips {
  color: #808896;
  height: auto;
  font-size: 0.9rem;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.icon-card .tips .hand {
  -webkit-transform: rotate(-25deg);
  transform: rotate(-25deg);
  -webkit-margin-end: 5px;
  margin-inline-end: 5px;
}

.icon-card .flip-card {
  background-color: rgba(0, 0, 0, 0);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-perspective: 1000px;
  perspective: 1000px;
  z-index: -1;
}

.icon-card .flip-card .flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  -webkit-transition: -webkit-transform 0.6s;
  transition: -webkit-transform 0.6s;
  transition: transform 0.6s;
  transition: transform 0.6s, -webkit-transform 0.6s;
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
}

.icon-card .flip-card .flip-card-inner .flip-card-front,
.icon-card .flip-card .flip-card-inner .flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  border-radius: 12px;
}

.icon-card .flip-card .flip-card-inner .flip-card-front {
  background-color: #F3F4F5;
  color: #000;
}

.icon-card .flip-card .flip-card-inner .flip-card-back {
  background-color: #00004E;
  color: #fff;
  -webkit-transform: rotateY(180deg);
  transform: rotateY(180deg);
}

.icon-card[data-status="clicked"] {
  min-height: 340px;
  max-width: 370px;
  width: 100%;
  padding: 60px 25px 65px;
}

.icon-card[data-status="clicked"] .image {
  top: 0;
  width: 80px;
  height: 80px;
  border-color: #00004E;
  background: #fff;
  -webkit-transform: translate(50%, -50%);
  transform: translate(50%, -50%);
}

.icon-card[data-status="clicked"] h1 {
  margin-top: 0;
  margin-bottom: 0px;
  color: #fff;
}

.icon-card[data-status="clicked"] .desc {
  color: #fff;
  display: block;
  -webkit-animation: fadeUp 0.2s ease-in;
  animation: fadeUp 0.2s ease-in;
  -webkit-animation-delay: 0.4s;
  animation-delay: 0.4s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}

.icon-card[data-status="clicked"] .tips {
  display: none;
}

.icon-card[data-status="clicked"] .flip-card-inner {
  -webkit-transform: rotateY(180deg);
  transform: rotateY(180deg);
}

@-webkit-keyframes fadeUp {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeUp {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.stepsSliders {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  overflow: hidden;
}

.steps-heading {
  font-size: 1rem;
  color: #E5E7EA;
  position: relative;
  padding-bottom: 80px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  height: calc(3.6rem + 80px);
  cursor: pointer;
  text-align: center;
}

.steps-heading::before {
  content: "";
  width: calc(100% - 14px);
  height: 6px;
  background: rgba(0, 155, 135, 0.5);
  position: absolute;
  bottom: 50px;
  inset-inline-start: calc(50% + 14px);
  opacity: 0.2;
}

.steps-heading::after {
  content: "";
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid #d4d4d4;
  position: absolute;
  bottom: 40px;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}

.steps-heading .arrow {
  position: absolute;
  width: 0;
  height: 0;
  border: 25px solid rgba(0, 0, 0, 0);
  border-bottom-color: #00BF00;
  left: 50%;
  bottom: 10px;
  -webkit-transform: translate(-50%, 10px);
  transform: translate(-50%, 10px);
  opacity: 0;
  z-index: -1;
  display: none;
}

.swiper-slide-thumb-active .steps-heading {
  color: #00BF00;
}

.swiper-slide-thumb-active .steps-heading::after {
  background: #00BF00;
  border-color: #00BF00;
  opacity: 1 !important;
}

.swiper-slide-thumb-active .steps-heading .arrow {
  -webkit-animation: fadeUp 0.2s ease-in;
  animation: fadeUp 0.2s ease-in;
  -webkit-animation-delay: 0.4s;
  animation-delay: 0.4s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}

.swiper-steps-card {
  background: #00004E;
  border-radius: 16px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 38px;
  height: 100%;
  position: relative;
  color: #fff;
  font-size: 1.2rem;
}

.swiper-steps .swiper-slide {
  height: 100%;
}

.swiper-steps .swiper-slide-active {
  width: 90% !important;
}

.accordion {
  width: 100%;
}

.accordion .accordion-button {
  font-size: 1.2rem;
  font-weight: bold;
  color: #333371;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.accordion .accordion-button:hover {
  background-color: rgba(157, 157, 157, 0.1);
}

.accordion .accordion-body {
  font-size: 1.2rem;
  color: #00004E;
}

.accordion .accordion-button:not(.collapsed) {
  color: #00BF00;
  background-color: #BFEFBF;
  -webkit-box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 #00BF00;
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 #00BF00;
}

.accordion.businessJourney  .accordion-body {
  background: #F3F4F5;
  padding: 1rem 2rem;
}

.accordion.businessJourney .accordion-button.businessJourney:not(.collapsed) {
  color: #00122D;
  padding: 2rem;
background-color: #E5E7EA;
  -webkit-box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0
    #BFBFD3;
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 #F3F4F5;
}
.businessJourney-container{
  background: #fff;
  padding: 2rem;
  border-radius: 2rem;
  width: 100%;
  .businessJourneyTitle{
    padding-bottom:2rem;
  }
}
.accordion .accordion-button:focus {
  border-color: rgba(0, 155, 135, 0.3);
  -webkit-box-shadow: 0 0 0 rgba(0, 0, 0, 0);
  box-shadow: 0 0 0 rgba(0, 0, 0, 0);
}

.checklist__list {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.accordion.businessJourney .accordion-body{
  li{
    padding-bottom: 0.35rem;
  }
  ul{
  padding: 1rem;
  li{
    list-style:disc;
    ol{
      padding: 1rem;
      li{
        list-style:decimal;
      }
    }
  }
  }
}
.eligibility{
  background-image: linear-gradient(#fff 50%,#F5F6F8 50%);
}
.eligibilty-check{
  display: flex;
  justify-content: center;
}
.background-icon svg{
  width: 10rem;
  height: 14rem;
}
@media screen and (max-width: 1024px) {
  .eligibilty-check{
    justify-content: center;
  }
  .background-icon svg{
    display: none;
  }
}

.calc-btn-space-text{
  margin-left: 10px;
}
@media screen and (max-width: 992px) {
  .checklist__list {
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
  }
  .calc-btn-col{
    flex-direction: column !important;
  }
  .calc-btn-space-text{
    margin-left: 0;
    margin-bottom: 1.5rem;
  }
}

.checklist__item {
  padding: 10px;
  -webkit-padding-start: 48px;
  padding-inline-start: 48px;
  margin-bottom: 16px;
  min-height: 48px;
  -webkit-transition: 0.2s;
  transition: 0.2s;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 14px;
}

.checklist__checkbox {
  display: none;
}

.checklist__label {
  border: 1px dashed #d1d1d1;
  border-radius: 48px;
  width: 100%;
  height: 48px;
  top: 0;
  inset-inline-start: 0;
  display: block;
  position: absolute;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  z-index: 11;
  height: 100%;
  cursor: pointer;
}

.checklist__label::before {
  content: "";
  width: 28px;
  height: 28px;
  background: #d1d1d1;
  border-radius: 50%;
  position: absolute;
  inset-inline-start: 10px;
  z-index: 11;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  line-height: 39px;
  text-align: center;
  font-size: 22px;
  top: 50%;
  margin-top: -14px;
}

.checklist__label .svg {
  position: absolute;
  inset-inline-start: 10px;
  z-index: 111;
  width: 28px;
  height: 28px;
  display: none;
  -webkit-transition: 0.6s ease-in-out;
  transition: 0.6s ease-in-out;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-size: 19px;
  color: #00BF00;
  top: 50%;
  margin-top: -14px;
}

.checklist__item input:checked~.checklist__label {
  border-color: rgba(0, 0, 0, 0);
}

.checklist__item input:checked~.checklist__label::before {
  background: #fff;
  width: 28px;
  height: 28px;
  inset-inline-start: 10px;
  border-radius: 50%;
  top: 50%;
  margin-top: -14px;
}

.checklist__item input:checked~.checklist__label .svg {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.checklist__text {
  padding-right: 0;
  font-size: 1rem;
}

.checklist__text span {
  opacity: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: relative;
  color: #fff;
  z-index: 11;
  display: none;
  line-height: 1.5;
}

.checklist__text::before {
  content: "الرجاء الضغط هنا لمزيد من التفاصيل";
  color: #acacac;
  font-size: 1rem;
}

.checklist__text::after {
  content: "";
  width: 100%;
  height: 100%;
  top: 0;
  inset-inline-start: 0;
  display: block;
  position: absolute;
  -webkit-transition: 0.5s;
  transition: 0.5s;
  z-index: 1;
  border-radius: 30px;
}

.checklist__item input:checked~.checklist__text span {
  opacity: 1;
  display: inline-block;
}

.checklist__item input:checked~.checklist__text::before {
  display: none;
}

.checklist__item input:checked~.checklist__text::after {
  background: #00BF00;
}

.journey-end {
  font-size: 2.5rem;
  font-weight: bold;
  color: #00BF00;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.inner-slide-container {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

@media screen and (max-width: 992px) {
  .inner-slide-container {
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
  }
}

#share-bar.left {
  left: 20px;
}

.journey-end-new {
  background-color: #fff;
  border-radius: 10px;
  padding: 80px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}

.journey-end-new h1 {
  color: #00004E;
}

.journey-end-new img {
  max-width: 60px;
  margin: 0 0 15px;
}

.journey-end-new a {
  /* color: #fff;
  padding: 2px 20px 5px;
  background-color: #00BF00;
  border-radius: 40px;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  display: inline-block;
  margin-top: 20px;
  font-size: 1rem;
  font-weight: bold; */
  margin-top: 2rem;
}

/* .journey-end-new a:hover {
  background-color: #00BF00;
} */

.journey-video-container {
  width: 60%;
  aspect-ratio: 16/9;
}

@media screen and (max-width: 1024px) {
  .journey-video-container {
    width: 100%;
  }
}

.faq-title {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
}

.faq-title .number {
  font-weight: bold;
  font-size: 4rem;
  color: #00BF00;
  line-height: 1.1;
  margin-top: 1rem;
}

.faq-title .title h5 {
  font-size: 1.3rem;
  font-weight: bold;
  color: #00BF00;
}

.faq-selector {
  min-height: 7rem;
  padding: 1rem;
  margin: 1rem;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  background-color: #f8f8f8;
  border: 1px solid #efeeee;
  color: #00BF00;
  width: calc(100% - 2rem);
  font-size: 1.1rem;
  font-weight: bold;
  border-radius: 0.4rem;
}


@media screen and (max-width: 480px) {
  .faqCount {
    display: none;
  }
}

.faqCount .faq-title {
  align-items: center;
}

.faqCount>.faq-title>.number {
  margin-top: 0rem;
  line-height: 2rem;
  margin-bottom: 2rem;
}

@media screen and (min-width: 768px) {
  .faqCount>.faq-title {
    align-items: start;
  }

  .faqCount>.faq-title>.number {
    margin-top: 1rem;
  }
  .banner-img-cont img {
    height: 24rem;
}
}
.faq-selector:focus {
  background-color: #f8f8f8;
  border: 1px solid #efeeee;
  color: #00BF00;
}

[dir="rtl"] .slick-prev {
  right: 1rem;
  left: auto;
}

@media screen and (max-width: 500px) {
  [dir="rtl"] .slick-prev {
    right: 0;
  }
  .banner-img-cont img {
    height: 13rem !important;
}
}

[dir="rtl"] .slick-prev:before {
  content: "";
}

[dir="rtl"] .slick-next {
  left: 1rem;
  right: auto;
}

@media screen and (max-width: 500px) {
  [dir="rtl"] .slick-next {
    left: 0;
  }
}

[dir="rtl"] .slick-next:before {
  content: "";
}

.slick-prev:before,
.slick-next:before {
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: var(--fa-display, inline-block);
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-rendering: auto;
  color: #303030;
}

.faq-slider {
  padding: 0 4rem;
}

@media screen and (max-width: 500px) {
  .faq-slider {
    padding: 0 1rem;
  }
}

.faq-q-list {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  margin-left: calc(-0.5 * var(--bs-gutter-x));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
}

.faq-q-list li {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: calc(100% - 16px);
  background-color: #fff;
  border: 1px solid #efeeee;
  color: #00BF00;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 16px;
  margin-left: 16px;
  margin-bottom: 1rem;
}

.faq-q-list li .number {
  color: #00BF00;
  font-weight: bold;
  font-size: 2rem;
  font-size: 4rem;
  width: 6%;
  text-align: center;
}

@media screen and (max-width: 992px) {
  .faq-q-list li .number {
    width: 20%;
  }
}

@media screen and (max-width: 480px) {
  .faq-q-list li .number {
    width: 100%;
    text-align: right;
  }
}

.faq-q-list li h5 {
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  font-size: 1.2rem;
  width: 70%;
  font-weight: bold;
}

@media screen and (max-width: 992px) {
  .faq-q-list li h5 {
    width: 56%;
  }
}

@media screen and (max-width: 480px) {
  .faq-q-list li h5 {
    width: 100%;
  }
}

.faq-q-list li button {
  border: 1px solid #00BF00;
  background-color: #fff;
  color: #00BF00;
  padding: 0.5rem 1rem;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  border-radius: 50px;
  min-height: auto;
  width: auto;
  font-size: 0.85rem;
  font-weight: normal;
}

@media screen and (max-width: 480px) {
  .faq-q-list li button {
    margin-right: 0px;
  }
}

.topHeaderTitle h1:first-child {
  position: relative;
  z-index: 2;
  color: white;
  padding-top: 1rem;
}


.backWebsite {
  position: relative;
  padding-bottom: 0.8rem;
}

.backWebsite svg {
  margin-bottom: -0.1rem;
}

.topHeaderTitle {
  width: fit-content;
  /* margin-top: 2rem; */ 
  margin-bottom: 5rem;
}

header nav a.navbar-brand {
  max-width: 50%;
  padding: 0.5rem 0 0.5rem 0;
}

.container.homePageFooter div#share {
  /* position: static; */
  order: initial;
}

footer .brand-logo {
  margin: 0;
  flex: 0 0 calc(50% - 0.25rem);
}

@media (min-width: 576px) {

  .container.homePageFooter div#share {
    order: 2;
  }

  footer .brand-logo {
    margin-top: 1rem;
  }

}

.jssocials-share>a {
  border: 1px solid #00BF00;
}


.lineConected.swiper-wrapper .swiper-slide {
  flex: 1;
  margin-left: 0 !important;
}

.steps-heading::before {
  content: "";
  width: 100%;
  height: 6px;
  background: rgba(0, 155, 135, 0.5);
  position: absolute;
  bottom: 50px;
  opacity: 0.2;
  right: 0;
}

.lineConected.swiper-wrapper .swiper-slide:first-child h1.steps-heading::before {
  width: 50%;
  right: 50%;
}

.lineConected.swiper-wrapper .swiper-slide:last-child h1.steps-heading::before {
  width: 50%;
}


@media screen and (max-width: 992px) {
  .flex-sm-md-column {
    flex-direction: column !important;
  }
  .jur-button-cont {
    top: -5rem;
}
  #business_journey {
    height: 38rem ;
    .business_journey_section{
      height: 29rem;
      .journies-section h1{
        align-items: center;
        font-size: 1.2em !important;
      }
    .popup-card.business-popup-card{
      margin: 3rem 0 0 0;
    .card-thumb {
      width: 300px !important;
      height: 183px !important;
      }
    }
    .article-card .start-journey{
      max-width: 100%;
      width: 70%;
    }
  }

  .businessjourney4{
    height: 25rem ;
    flex-direction: column;
    align-items: center;
    justify-content: center !important;
    .business-card-top{
      height: 10rem;
      .info-card{
        /* margin: 1rem !important; */
        .info-hint3{
          font-size: 1rem !important;
          text-align: center !important;
        }
        .info-hint2 {
          width: 100% !important;
          font-size: 1.2em !important;
          text-align: center !important;
      }

      }
      .jur-button-cont{
        display: flex;
        align-items: center;
        right: unset;
        max-width: 100%;
        top: 11rem;
        z-index: 2;
        justify-content: center;
        margin: auto;      
      }
    }

    .contarineImage{
      position: relative ;
      width: 80%;
      display: block;
      min-height: 8.318125rem;
      margin-bottom: 0;
      img {
        pointer-events: none;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        pointer-events: none;
        object-fit: contain;
        bottom: -6rem;
      }
    }
  }
  }
}


@media screen and (max-height: 33rem) {
  div#share {
    display: none;
  }
}

@media screen and (max-height: 40rem) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0
  }

  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0
  }

  .modal-fullscreen-sm-down .modal-footer,
  .modal-fullscreen-sm-down .modal-header {
    border-radius: 0
  }

  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
    padding: 1rem 3rem;
  }
}

@media screen and (max-width: 576px) {
  .pe-sm-only-0 {
    padding-left: 0 !important;
  }
  .smallest-bp-jur-card{
    padding-bottom: 1rem !important;
  }
}

.accordion button.accordion-button {
  padding-left: 0.5rem;
  gap: 0.5rem;
}



div#pre-load {
  height: 100%;
  width: 100%;
  position: fixed;
  margin-top: 0px;
  top: 0px;
  z-index: 999999;
  background: #000048;
  display: none;
}


.loader .loader-container {
  position: absolute;
  left: 0;
  right: 0;
  top: 40vh;
  margin: auto;
  width: 8rem;
  height: 8rem;
  /* border: 0.4rem solid #ebebec;
  border-radius: 50%; */
}

.loader .loader-container:before {
  position: absolute;
  content: "";
  display: block;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* width: 8rem;
  height: 8rem;
  border-top: 0.4rem solid #008755;
  border-radius: 50%;
  animation: loaderSpin 1.8s infinite ease-in-out;
  -webkit-animation: loaderSpin 1.8s infinite ease-in-out; */
}

.loader .loader-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* width: 6rem; */
  text-align: center;
  margin-top: 0.2rem;
}

.loader .loader-icon svg {
  animation: loaderPulse alternate 900ms infinite;
  width: 3.5rem;
}

@keyframes loaderSpin {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }

  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

@-webkit-keyframes loaderSpin {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }

  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

@keyframes loaderPulse {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.2);
  }
}


.bannerBackground {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  background-position: bottom left;
  background-size: cover;
  min-height: 208px;
  display: -webkit-box;
  display: -ms-flexbox;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 16rem;
}
.text-cont{
    max-width: 25rem;
    max-height: 12rem;
    width: 25rem;
    height: 12rem;
}
.homeBanner {
  z-index: 1;
}

.TaminatyMessage {
  background: #0064FF;
  display: block;
  text-align: center;
  padding: 0.5rem;
}
.TaminatyMessage p {
  display: inline-block;
  margin: .5rem;
  font-size: 1rem;
  font-weight: 600;
  color: #fff;
}
.TaminatyMessage a {
  font-weight: 550;
  color: #fff !important;
  background: #00004e;
  border-radius: .5rem;
  padding: .5rem 1rem;
  text-align: center;
  display: inline-block;
  cursor: pointer;
}
@media screen and (max-width: 600px) {
  .TaminatyMessage p {
    display: inline-block;
    width: 60%;
    font-size: .8rem;
    text-align: start;
}
.TaminatyMessage a {
  display: inline-block;
  font-size: .8rem;
  padding: .8rem .3rem;
  width: 6rem;
}
header nav .navbar-brand .logo-desktop {
  display: none;
}
header nav .navbar-brand .logo-mobile {
  display: inline-block;
  width: 4rem;
}
.topHeaderTitle{
  width: 100%;
}

.jur-button-cont {
  top: 0rem;
}

.business-journey-cover {
  img {
    max-width: 300px !important;
  }
  h1,.welcome-business{
    font-size: 1.5rem !important;
  }
}
}
#business_journey {
  .business_journey_section{
  .popup-card.business-popup-card{
  .card-thumb {
    width: 275px !important;
    height: 183px !important;
    }
  }
}
}
.subbanner-title{
  font-size: 2rem !important;

}
.subbanner-text{
  font-size: 1.2rem !important;
  color: white;
  width: 20rem;
  margin: 0.5rem 0rem;
}

section.homeBanner .container {
  display: flex;
  align-items: center;
  margin-inline-end: 0;
  margin: 0 auto;
  /* margin: 0;
  padding: 0;
  max-width: inherit; */

}

/* section.homeBanner .container>div {
  flex: 1;
} */

img.backline,
img.frontline {
  position: absolute;
  width: 60%;
  left: 0;
}

img.backline {
  top: 0;
  bottom: auto;
}

img.frontline {
  z-index: 10;
  bottom: -50%;
}

section.homeBanner {
  position: relative;
  overflow: hidden;
  background: #00004E;
  width: 100%;
}

@media screen and (max-width: 992px) {

  /* on mobile */
  .topHeaderTitle{
    margin-bottom: 0rem;
  }
  section.homeBanner .container {
    display: block;
  }
  .bannerBackground {
    background-size: cover;
    height: 20rem;
  }
}

a.btn {
  background-color: #00BF00;
  color: #00004E;
  padding: 0.5rem 1.2rem;
  border-radius: 10px;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  margin: 0.5rem 2rem 1rem 2rem;
  /* min-width: 15rem; */
}

a.btn:hover {
  background-color: #80DF80;
  color: #00004E;
}
a.btn:focus {
  background-color: #BFEFBF;
  color: #00004E;
}

i.jssocials-share-logo {
  width: 24px;
  height: 24px;
  display: block;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.jssocials-share.jssocials-share-email i.jssocials-share-logo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.jssocials-share.jssocials-share-twitter i.jssocials-share-logo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.jssocials-share.jssocials-share-facebook i.jssocials-share-logo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.jssocials-share.jssocials-share-linkedin i.jssocials-share-logo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.jssocials-share.jssocials-share-whatsapp i.jssocials-share-logo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
svg:not(:host).svg-inline--fa,
svg:not(:root).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}

.popup-card .card-thumb:hover {
  border: 2px solid #00BF00;
}

.popup-card .card-thumb:hover img {
  filter: grayscale(1);
}

span.journeyStart {
  margin-top: 0;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
  font-size: 1.25em;
  margin-bottom: 0.1rem;
  width: 100%;
    text-align: center;
}

button.slick-arrow.slick-prev::before,
button.slick-arrow.slick-next::before {
  font-family: swiper-icons;
  font-size: 1.2rem;
  text-transform: none !important;
  letter-spacing: 0;
  font-variant: initial;
  line-height: 1;
}

button.slick-arrow.slick-prev::before {
  content: 'next' !important;
}

button.slick-arrow.slick-next::before {
  content: 'prev' !important;
}

button.slick-arrow {
  z-index: 10;
}

.checklist__list-description {
  padding: 1rem;
  font-size: 1rem;
}

.table {
  font-size: 1rem;
}

.new-card {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  border-radius: 12px;
  padding: 1rem;
  padding-top: 0;
  display: flex;
  flex-direction: column;
}

.new-card h5 {
  width: 100%;
  font-weight: bold;
  font-size: 1.2rem;
  text-align: center;
  color: #0e4e41;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}

.new-card p {
  width: 100%;
  font-size: 1rem;
  text-align: center;
}

.custom-description {
  font-size: 1.2rem;
  margin-bottom: 1rem;
  color: #333371;
}



/* this is for social animation */
.jssocials-shares,
.jssocials-shares:before,
.jssocials-shares:after,
.jssocials-share {
  height: calc(1.2em + 24px);
  width: calc(1.2em + 24px);
  border-radius: 50%;
  position: absolute;
  cursor: pointer;
}

.jssocials-shares {
  position: relative;
}

.jssocials-shares:before,
.jssocials-shares:after {
  content: '';
  will-change: transform;
}

.jssocials-shares:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) center/18px no-repeat;
  z-index: 5;
  transition: 0.3s;
}

.jssocials-shares:after {
  background: #f4f6f8;
  /* box-shadow: 0 2px 5px rgba(0, 0, 0, .3); */
  z-index: -1;
  transition: 0.39s;
  border: 1px solid #333371;
}

.jssocials-shares:hover{
  border: 1px solid #00BF00;
}

.jssocials-shares.active:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) center/14px no-repeat;
  transform: rotate(90deg);
}

.jssocials-share {
  transition: 0.3s;
  animation: 0.3s down forwards;
  opacity: 0;
  will-change: animation;
}

.jssocials-share:nth-child(1) {
  background: transparent;
  top: calc((-100% + -0.5rem) * 4);
}

.jssocials-share:nth-child(2) {
  background: transparent;
  top: calc((-100% + -0.5rem) * 3);
}

.jssocials-share:nth-child(3) {
  top: calc((-100% + -0.5rem) * 2);
  background: transparent;
}

.jssocials-share:nth-child(4) {
  top: calc((-100% + -0.5rem) * 1);
  background: transparent;
}

.jssocials-share:nth-child(5) {
  background: transparent;
}

.jssocials-share.active {
  animation-duration: 0.48s;
  animation-timing-function: ease;
  animation-delay: 0s;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-fill-mode: forwards;
  animation-play-state: running;
  animation-name: up;
  animation-timeline: auto;
  animation-range-start: normal;

}

.jssocials-share.active:nth-child(1) {
  animation-delay: 0.8s;
}

.jssocials-share.active:nth-child(2) {
  animation-delay: 0.6s;
}

.jssocials-share.active:nth-child(3) {
  animation-delay: 0.4s;
}

.jssocials-share.active:nth-child(4) {
  animation-delay: 0.2s;
}

.jssocials-share.active:nth-child(5) {
  animation-delay: 0s;
}

.jssocials-share.no {
  animation: none;
}

@keyframes up {
  50% {
    transform: translateY(-170%);
  }

  100% {
    opacity: 1;
    transform: translateY(-130%);
  }
}

@keyframes down {
  0% {
    opacity: 1;
    transform: translateY(-130%);
  }

  100% {
    opacity: 0;
    transform: translateY(0);
    top: 0;
  }
}

a.jssocials-share-link {
  padding: 0.6em;
}

div:where(.swal2-container) .otpContainer {
  display: flex;
  overflow: hidden;
  direction:ltr;
}

div:where(.swal2-container) .otpContainer .swal2-input{
  margin: 0.5rem;
  width: calc(25% + 3rem);
  text-align: center;
}

.input-field input {
  border: 2px solid #808896;
  outline: none;
  height: 3rem;
  width: 100%;
  font-size: 16px;
  margin: 0 0 8px;
  padding: 0;
  box-shadow: none;
  padding-left: 10px;
  border-style: solid;
  border-width: 1px;
  border-color: #eaeaea;
  border-radius: 1rem !important;
  background-color: #fcfcfc;
  padding-right: 10px;
  box-sizing: border-box;
  font-weight: 400;
  font-family: Ping AR + LT!important;
  color: #00004E;
}

.input-field input:focus {
  border: 3px solid #00BF00 ;
  box-shadow: 0px 0px 3px 0px #44C875;
}

.input-field label {
  font-size: 1rem;
  cursor: text;
  transition: transform .2s ease-out,color .2s ease-out;
  transform-origin: 0% 100%;
  right: 1rem!important;
  top: -5px;
  color: #00BF00;
  font-weight: 500;
  left: auto;
  position: relative;
  display: block;
  text-align: right;
  transform: none!important;
  margin-bottom: 0;
}

.input-field label span.mandatoryField {
  display: inline-block;
  color: #ff5858;
  font-size: 1.4rem;
  position: absolute;
  right: -1rem;
  top: 1px;
  font-family: initial;
}

div:where(.swal2-container) h2:where(.swal2-title) {
  font-size: 1.3rem !important;
}

button.swal2-confirm.btn.swal2-styled {
  background-color: #00BF00;
  color: #fff;
  padding: 0.5rem 1.2rem;
  border-radius: 50px;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

button.swal2-confirm.btn.swal2-styled:hover {
  background-color: #00BF00;
}

button.btn {
  background-color: #00BF00;
  color: #00004E;
  padding: 0.5rem 3rem;
  border-radius: 10px;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

button.btn:hover {
  background-color: #80DF80;
  color: #00004E;
}

button.btn:focus {
  background-color: #BFEFBF;
  color: #00004E;
}

button.swal2-cancel.btn.swal2-styled {
  background-color: #00BF00;
  color: #fff;
  padding: 0.5rem 1.2rem;
  border-radius: 50px;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

button.swal2-cancel.btn.swal2-styled:hover {
  background-color: #025f52;
}

button.btn.swal2-styled[disabled] {
  opacity: .4;
}

svg.otpIcon {
  width: 80%;
  height: 80%;
  margin-left: 15px;
}
svg.otpIcon path, svg.otpIcon circle{
  fill: #00BF00
}

input.swal2-input.customFocus:focus {
  border: none;
  outline: none;
  box-shadow: none;
  border-style: solid;
  border-width: 1px;
  border-color: #eaeaea;
  border-style: solid;
  border-width: 1px;
  border-color: #eaeaea;
}

div#calculateRetirementResult .title {
  width: 100%;
  font-weight: bold;
  font-size: 1.2rem;
  text-align: center;
  color: #0e4e41;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  line-height: 1.2;
}

div:where(.swal2-container) button:where(.swal2-styled).swal2-cancel:focus {
  box-shadow: none !important;
}

div.input-field select {
  box-shadow: none;
  transition: box-shadow .3s,border .3s;
  position: relative;
  cursor: pointer;
  border: 2px solid #808896;
  outline: none;
  height: 3rem;
  line-height: 3rem;
  width: 100%;
  font-size: 16px;
  margin: 0 0 8px;
  padding: 0;
  display: block;
  user-select: none;
  z-index: 1;
  padding-left: 10px;
  border-style: solid;
  border-width: 1px;
  border-color: #eaeaea;
  border-radius: 8px;
  background-color: white;
  padding-right: 10px;
  box-sizing: border-box;
  font-weight: 400;
  font-family: Ping AR + LT!important;
  color: #00004E;
}

p#validationMsg {
   color: #ff5858;
}
p#UIDValidationMsg {
  color: #ff5858;
  height: 2rem;
  text-align: center;
}

.list {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

@media screen and (max-width: 992px) {
  .list {
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
  }
}

.list__item {
  padding: 10px;
  -webkit-padding-start: 48px;
  padding-inline-start: 48px;
  margin-bottom: 16px;
  min-height: 48px;
  border-radius: 48px;
  -webkit-transition: 0.2s;
  transition: 0.2s;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 14px;
  background: #00004E;
}

.list__label {
  border-color: rgba(0, 0, 0, 0);
  border-radius: 48px;
  width: 100%;
  height: 48px;
  top: 0;
  inset-inline-start: 0;
  display: block;
  position: absolute;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  z-index: 11;
  height: 100%;
}

.list__label::before {
  content: "";
  width: 28px;
  height: 28px;
  background: #d1d1d1;
  border-radius: 50%;
  position: absolute;
  inset-inline-start: 10px;
  z-index: 11;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  line-height: 39px;
  text-align: center;
  font-size: 22px;
  top: 50%;
  margin-top: -14px;
}

.list__label .svg {
  position: absolute;
  inset-inline-start: 10px;
  z-index: 111;
  width: 28px;
  height: 28px;
  display: none;
  -webkit-transition: 0.6s ease-in-out;
  transition: 0.6s ease-in-out;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-size: 19px;
  color: #00BF00;
  top: 50%;
  margin-top: -14px;
}

.list__label::before {
  background: #fff;
  width: 28px;
  height: 28px;
  inset-inline-start: 10px;
  border-radius: 50%;
  top: 50%;
  margin-top: -14px;
  border-color: rgba(0, 0, 0, 0);
}

.list__label .svg {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}



.list__item .list__title {
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: relative;
  color: #fff;
  z-index: 11;
  line-height: 1.5;

  width: 100%;
  height: 100%;
  top: 0;
  display: block;
  -webkit-transition: 0.5s;
  transition: 0.5s;
  z-index: 1;
  border-radius: 30px;

  opacity: 1;
  display: inline-block;

  padding-right: 0;
  font-size: 1rem;
}

/* .journies_background{
  padding: 1rem !important;
  height: 24rem !important;

} */
.journies_continer {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.divider {
  width: 2px;
  max-height: 27.183125rem;
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: rgb(216, 216, 216);
  border-radius: 2px;
}

.my_top_section h1{
  padding: 0 20px;
  text-align: center;
}

.business_journey_section{
  .journies_continer.temp-height{
    margin: 2rem 0rem !important;
    width: inherit !important;
  }
}

@media screen and (max-width: 991px) {
  .journies_continer {
    flex-direction: column;
  }
  .journey_card_title{
    height: auto;
  }

  

  .divider {
    height:2px;
    width: 50%;
    margin: auto;
    background-color: rgb(216, 216, 216);
  }

}



.journey_section1 {
  flex: 1 ;
  padding: 20px;
}

.journey_section2 {
  flex: 2 ;
  padding: 20px;
}


/* .journey_card{
  min-width: 23.20875rem; 
  min-height: 27.183125rem;
} */


.journey_card_title p {
  max-width: 100%;
  white-space: nowrap;

}

.red {
  background-color: #FF0020;
}

.blue {
  background-color: #0064FF;;
}


.my_top_section{
  height: fit-content;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
}
.business_journey_section{
  width: inherit !important;
  height: 22rem;  
  align-items: normal;
}
.my_card {
  flex: 1;
    padding: 0 24px;

}

.homescreen_banner {
  width: 100%;
  height: 100%;
  object-fit: cover;
}





/* .slider{
  position: relative;
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
}

.slider .list{
  position: absolute;
  width: max-content;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: row;
  transition: 1s;
}

.slider .list .item{
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.slider .buttons{
  position: absolute;
  top: 45%;
  left: 5%;
  width: 90%;
  display: flex;
  justify-content: space-between;
}
.slider .buttons button{
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #fff5;
  color: #fff;
  border: none;
  font-family: monospace;
  font-weight: bold;
}
.slider .dots{
  position: absolute;
  bottom: 10px;
  left: 0;
  color: #fff;
  width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
}
.slider .dots li{
  list-style: none;
  width: 10px;
  height: 10px;
  background-color: #0e4e41;
  margin: 10px;
  border-radius: 20px;
  transition: 0.5s;
}
.slider .dots li.active{
  width: 30px;
  background-color: #008755;
}
@media screen and (max-width: 768px){
  .slider{
      height: 400px;
  }
  .temp-height{
    width: 100% !important;
  }
}





.swiper-show-wrapper{
  position: relative;
  width: 100%;
  margin: 0 auto;
}
 
.swiper-show-slider {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  box-shadow: 0 1.5rem 3 rem -0.75rem hsla(0, 0%, 0%, 0.25);
}
 
.swiper-show-item{
  flex: 1 0 100%;
  scroll-snap-align: start;
  width: 100%;
  height: 100%;
  object-fit: cover;
  aspect-ratio: 16/9;
}
 
.swiper-show-nav {
  display: flex;
  column-gap: 1rem;
  position: relative;
  bottom: 1.25rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
}
 
.swiper-show-nav a {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background-color: #0e4e41;
  opacity: 0.75;
  transition: opacity ease 250ms;
}
 
.swiper-show-nav a:hover {
  opacity: 1;
} */


.swiper-pagination-bullet {
 opacity: 1;
  background-color: #00BF00;
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 1.25rem;
  transition: 0.5s ease;
}

.swiper-pagination-bullet-active {
  background-color: #00BF00;
  width: 2rem;
}


.swiper-pagination-bullet-slider {
  background-color: white !important; 
    width: max-content !important;
    border-radius: 0.25rem !important; 
    left: 50% !important; 
    transform: translateX(-50%) !important; 
    box-shadow: 0 1px 3px 1px hsla(0, 0%, 0%, 0.25) !important; 
    padding: 0 0.25rem;
}


.swiper_banner_04 {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
.swiper_banner_05 {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
.swiper_banner_06 {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}






.text-top-j4s7 {
  width: 100%;
  padding-bottom: 2rem;
}
.text-bottom-j4s7 {
  width: 100%;
  padding-top: 2rem;
}

.newsletter{
  width: 200px;
}


.hint-img {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.eligibility .container{
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.eligibility-container{
  margin: auto;
  background-color: #F1F6E0;
  border: 1px solid #ACD02A;
  border-radius: 1rem;
  padding: 1.25rem;

  font-size: 1.5rem;
  color: #004d41;
  font-weight: 500;
}

.eligibility-container .eligibility-body {
  font-size: 1.25rem;
  color: #1F2020;
  font-weight: 400;
}

.introduction-video, .workshop-video {
  background-color: #E5E7EA;
}
.workshop-video{
  position: relative;
  padding: 0;  
  z-index: 2;
}
.container-area {
  background-color: white;
  border-radius: 1rem;
  padding: 3rem 1.25rem;
}
.container-area-journies{
  padding: 0rem;
}
.journies_content{
  background: #fff;
  border-radius: 2rem;
  padding: 1rem;
}
/* .journies_continer{
  background: #F3F4F5;
} */
.search-sec{
  background-color: #F7F8F8;
}
.search-sec .container{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.search-container {
  margin: auto;
  background-image: linear-gradient(to right, #76C08F, #338F73);
  border-radius: 1rem;

  display: flex;
  padding: 3rem 6rem;
}

.search-btn{
  align-items: center;
  flex: 1;
  display: flex;
  justify-content: center; 
}


.search-content{
  flex: 2;
}
.search-content div{
  display: flex;
  flex-direction: column;
}


.search-text{
  margin-top: 0.75rem;
  font-weight: 700;
  color: white;
  font-size: 1.75rem;
}

#search{
  background-color: white;
  font-weight: 700;
  color: #004D41;
  font-size: 1rem;
  border-radius: 1rem;
}

.my_top_section{
  background-color: #F3F4F5;
  border-radius: 1rem;
  width: 33%;
  padding: 0rem 0rem 3.5rem 0;
  /* padding: 1rem;
  margin: 1rem; */
}

/* .journies-section{
  background-color: #E5E7EA;
} */

.changes-jur{
  margin-left: 1rem;
  width: 66% ;
}
.changes-jur h1{
  color: #00004E !important;
}

.elg{
  color: #00004E !important;
}


.start-journey-text{
  justify-content: space-between;
  width: 100%;
}
/* .journeyStart{
  padding-right: 0.4rem;
} */

.info-cards{
  min-height: 6.631875rem;

  display: flex;
  margin: 0 1rem;
  border-radius: 0.25rem;
  align-items: center;
}
.info-card{
  flex: 1;

  border-radius: 0.25rem;
  padding: 1rem 1.5rem 1rem;
}

.info-card .info-hint{
  color: #333371;
  font-size: 1em;
  font-weight: 900;
  text-align: center;
}

.info-card .info-hint2{


padding-top: 0.75rem;
  color: white;
  font-size: 0.875em;
  font-weight: 500;
  text-align: center;
}

.info-card .info-hint3{
  font-size: 0.9rem;
    color: #BFBFD3;
    text-align: center;
}
.rm-paddint-lr{
  padding-left: 0%;
  padding-right: 0%;
}

@media screen and (max-width: 991px) {
  .swiper_banner_04 {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  }
  .swiper_banner_05 {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  }
  .swiper_banner_06 {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  }


  .search-container {
    flex-direction: column;
  }

  .search-content{
    flex: 2;
    align-items: center;
    display: flex;
    justify-content: center;
    margin-bottom: 0.5rem;
    flex-direction: column;
    text-align: center;
  }
  
.my_top_section{
  width: inherit;
}
  .changes-jur{
    margin-bottom: 1rem;
    margin-left: 0;
  }
  /* .my_top_section{
    width: 100% !important;
    min-width: 22rem;
  } */
  .journies_continer{
    align-items: center;
  }

  .temp-height{
    height: 30.652375rem !important;
  }
}

.close-conversational{
  font-size: 2.5rem;
  font-weight: 100;
}


.popupModalCloseBtn {
  border: 0 !important;
  background-color: transparent !important;
  top: 0rem;
  right: 1rem;
  cursor: pointer;

  span {
    padding: 0.75rem;
  }

  &:hover {
    span {
      font-weight: 600;
    }
  }
}

.conversational-header{
  border: 0;
}


h6 {
  font-size: 1.15rem;
  line-height: 110%;
  margin-top: 0.46rem;
  margin-bottom: 0.46rem;
}

.category-tabs,.services-tabs,.newQue{
  display: none;
}

#ServicesModel {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.25);
  z-index: 999999;
  display: none;


  .popupModal {
    margin-left: auto;
    margin-right: auto;
    margin-top: 150px;
    margin-bottom: 5vh;
    max-height: 100vh;
    min-height: 45vh;
    height: auto;
    width: 50vw;
    background-color: white;
    border-radius: 0.5rem;
    box-shadow: 0 5px 38px -6px rgb(0 0 0 / 5%);
    padding: 1rem;
    padding-top: 0rem;
    text-align: center;
    border: 1px solid #efefef;
    position: relative;
    overflow: hidden;
    animation: fadeIn 0.5s;

    .close {
      font-size: 2.5rem;
      font-weight: 100;
    }

    .close:hover {
      font-weight: 100 !important;
    }

    #popupModalTitle {
      font-weight: 500;
      padding-left: 1rem;
      padding-right: 0rem;
      padding-top: 0.5rem;
      padding-bottom: 1rem;
      width: calc(100%);
      min-height: 2rem;
    }

    .popupModalCloseBtn {
      position: absolute;
      top: 0rem;
      right: 1rem;
      cursor: pointer;

      span {
        padding: 0.75rem;
      }

      &:hover {
        span {
          font-weight: 600;
        }
      }
    }

    .title-message {
      display: flex;
      flex-direction: column;
      align-items: end;

      .modalTitle {
        text-align: end;
        padding-bottom: 2rem;
      }
    }



    .messageContainer {
      
      position: absolute;
      top: 1rem;
      right: 3.5rem;
      width: 91%;
      font-size: 0.9rem;

      display: none; 

      flex-direction: row-reverse;
      padding: 0.5rem;
      border-radius: 0.5rem;

      animation: fadeIn 1s;
    }

    .notClearInfo {
      background-color: #EEF6D5;
    }

    .categoryInfo {
      display: none;
      flex-direction: row-reverse;
      padding: 0.5rem;
      margin-bottom: 3rem;
      border-radius: 0.5rem;

      animation: fadeIn 1s;
      background-color: #F3EDDA;

      .note {
        text-align: end;
      }
    }

    @media screen and (max-width: 768px){
  .slider{
      height: 400px;
  }
  .temp-height{
    width: 100% !important;
  }
}
    .modalHeader {
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
      width: 100%;
    }

    .role {
      display: none;
      flex-direction: row-reverse;
      justify-content: end;
      align-items: center;
      gap: 0.1rem;
      padding: 1rem 0.5rem;
      cursor: pointer;

    }

    .breadCrumb {
      color: #A7A8AA;
    }

    .breadCrumb-text {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
    }




    .contentContainer {
      padding: 5rem 0rem 3rem 0rem;
      display: flex;
      direction: ltr;
      flex-direction: column;
      justify-content: start;
      align-items: end;
    }

    .modelMessage {
      padding: 1rem;
      background-color: #EEF6D5;
      border-radius: 0rem 0.8rem 0.8rem 0.8rem;
      font-size: 1rem;
      font-weight: bold;
      width: fit-content;
    }

    .quistion {
      display: flex;
      padding-top: 1rem;
    }

    .message {
      padding: 0rem 2rem 0rem 2rem;
      margin-top: 1rem;
    }

    .modalBody {
      min-height: 10rem;
      padding: 2rem 0rem 3rem 0rem;
    }

    .modalCategory {
      padding-top: 1rem;
      display: flex;
      flex-direction: row-reverse;
      justify-content: end;
      gap: 0.5rem;
      flex-wrap: wrap;
      width: 100%;
    }

    .category {
      border: none;
      background: #F7F8F8;
      border-radius: 1rem;
      padding: 0.5rem 1rem;
      font-weight: 350;
      cursor: pointer;
      transition: transform 250ms;
      font-family: 'Ping AR + LT', sans-serif;

      &:hover {
        background-color: #EEF6D5;
        color: #004D41;
        transform: translateY(-3px);
      }
    }

    .notClear {
      text-align: center;
      font-weight: 500;
      color: #004D41;
      position: absolute;
      bottom: 2rem;
      right: 50%;
      cursor: pointer;

      &:hover {
        color: #ABD02B;
      }
    }

    .back-btn {
      width: fit-content;
      display: none;
      flex-direction: row-reverse;
      align-items: center;
      border: none;
      border-radius: 0.5rem;
      background: white;
      padding: 1rem 0rem 1rem 1rem;
      color: #004D41;
      box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
      position: absolute;
      bottom: 1.5rem;
      right: 2rem;
      cursor: pointer;

      &:hover {
        color: white;
        background: #00AE9A;
      }

    }
  }
}


.opacity-transtion{
  transition: opacity 0.5s ease-in-out, height 0.5s ease-in-out;
  display: none ;
}
.opacity-transtion.shown{
  opacity: 1;
  display: block ;
}
.opacity-transtion.hidden{
  opacity: 0;
  display: none ;
}
#OTP-tab {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.25);
  z-index: 999999;


  .popupModal {
    margin-left: auto;
    margin-right: auto;
    margin-top: 150px;
    margin-bottom: 5vh;
    max-height: 100vh;
    height: auto;
    width: 34.1875rem;
    background-color: white;
    border-radius: 0.5rem;
    box-shadow: 0 5px 38px -6px rgb(0 0 0 / 5%);
    padding: 1rem;
    padding-top: 0rem;
    text-align: center;
    border: 1px solid #efefef;
    position: relative;
    overflow: hidden;
    animation: fadeIn 0.5s;

    .close {
      font-size: 2.5rem;
      font-weight: 100;
    }

    .close:hover {
      font-weight: 100 !important;
    }

    #popupModalTitle {
      font-weight: 500;
      padding-left: 1rem;
      padding-right: 0rem;
      padding-top: 0.5rem;
      padding-bottom: 1rem;
      width: calc(100%);
      min-height: 2rem;
    }
    
    .otp-header{
      width: 100%;
      display: flex;
      flex-direction: row;

      .popupModalCloseBtn {
      
        padding: 1.5rem 0 0 0.625rem;
  
        cursor: pointer;
  
        &:hover {
          span {
            font-weight: 600;
          }
        }
      }

      .otp-icon-Container {
        padding: 2.187rem 1.187rem 0 0 ;
        flex: 1;
        text-align: right;
      
        width: 100%;
        font-size: 0.9rem;
  
        flex-direction: row-reverse;
        border-radius: 0.5rem;
  
        animation: fadeIn 1s;
      }
    }
    

    .otp-send-tab{
      padding-top: 1.25rem;
      
      display: flex;
      flex-direction: row-reverse;
      justify-content: end;
      gap: 0.5rem;
      flex-wrap: wrap;
      width: 100%;

      
      .tab-span{
        width: 100%;
        padding-bottom: 2rem;
        color: #1F2020;
        font-weight: 500;
        font-size: 1.5em;
        text-align: right;
      }
      
      .new-otp-resend {
        width: 100%; 
        height: 2rem;
        color: #1F2020;
        font-weight: 400;
        font-size: 1.25em;
        text-align: center;
      }
      .new-otp-resend
      
      .new-otp-resend-shown{
        cursor: pointer;
        color: #004D41 ;
        text-decoration: underline;
      }
    }

    
    .contentContainer {
      padding: 0rem 1.25rem 2.125rem;
      display: flex;
      direction: ltr;
      flex-direction: column;
      justify-content: start;
      align-items: end;
    }

    .modalBody {
      min-height: 10rem;
      padding: 0rem;
    }

    .otpContainer{
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 1.5rem;
    }

    .input-field{
      width: 23.157%;
      
    }
.input-field input {
  border: none;
  border-bottom: 1px solid #9e9e9e;
  outline: none;
  height: 6.1875rem;
  width: 100%;
  margin: 0 0 8px;
  padding: 0;
  box-shadow: none;
  padding-left: 10px;
  border-style: solid;
  border-width: 1px;
  border-color: #eaeaea;
  border-radius: 0.75rem;
  background-color: #fcfcfc;
  padding-right: 10px;
  box-sizing: border-box;
  font-weight: 400;
  font-family: Ping AR + LT!important;
  text-align: center;
  color: #1F2020;
  font-size: 2em;
}

  }

} 
/* @media (max-width: 600px){
  .opacity-transtion.shown{
    opacity: 1;
    display: flex ;
  }
  #OTP-tab {
  .popupModal {
    align-self: flex-end;
    margin: 0;
    width: 100vw;
    border-radius: 0.5rem 0.5rem 0 0;

    .otp-send-tab{
      .new-otp-resend {
        width: 100%;
        color: #1F2020;
        font-weight: 400;
        font-size: 1.25em;
        text-align: center;
        padding-bottom: 3rem;
      }
    }

    .input-field{
      width: 23.157%;
      
    }
.input-field input {
  border: none;
  border-bottom: 1px solid #9e9e9e;
  outline: none;
  height: 6.1875rem;
  width: 100%;
  margin: 0 0 8px;
  padding: 0;
  box-shadow: none;
  padding-left: 10px;
  border-style: solid;
  border-width: 1px;
  border-color: #eaeaea;
  border-radius: 0.75rem;
  background-color: #fcfcfc;
  padding-right: 10px;
  box-sizing: border-box;
  font-weight: 400;
  font-family: Ping AR + LT!important;
  text-align: center;
  color: #1F2020;
  font-size: 2em;
}

  }
}
} */


.conection-latter{
  max-height: fit-content;
}
.conection-latter-txt{
  font-weight: 500;
  font-size: 2em;
  color: #00004E;
  max-height: fit-content;

}
.modalFade {
  animation: fadeIn 0.3s;
}

@media (min-width: 1200px) {
  .journeys {
    padding-right: 2rem;
    padding-left: 2rem;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@media screen and (max-width: 767px){

  .temp-height{
    width: 100% !important;
  }
}

.journey-sections-titles{
  margin-top: 2.687rem !important;
  margin-bottom: 1.875rem !important;
}


.jur-button-cont{
  height: 5rem;
  position: relative;
  width: 80%;
  right: 2.5rem;
}


.cont-height{
  height: fit-content !important;
}
@media (min-width: 576px) {
  .journies_continer{
    height: 59.76175rem;
  }
  .article-card figure {
    min-height: 13.318125rem;
  }
  
}

@media (max-width: 768px){
  .calc-btn{
    width: 100% !important;
  }
}

@media (min-width: 768px){
  
  .journies_continer{
    height: 60.652375rem;
  }
  .cont-height{
    height: fit-content !important;
  }

  .article-card figure {
    min-height: 17.5rem;
  }

  .info-cards{
    min-height: 6.631875rem;
  }
}

@media (min-width: 992px) {
  .journies_continer{
    height: 26.5rem;
  }
  .article-card figure {
    min-height: 7rem;
  }
  .info-cards{
    min-height: 9rem;
  }
}


@media (min-width: 1200px){
  .journies_continer{
    height: 26rem;
  }
  .article-card figure {
    min-height: 9rem;
  }
  .info-cards{
    min-height: 6.631875rem;
  }
}

@media (min-width: 1400px){
  .journies_continer{
    height: 28rem;
  }
  .article-card figure {
    /* min-height: 10rem; */
    min-height: 12rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/layout.css"],"names":[],"mappings":";AACA;;;;;EAKE,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA2DE,4BAA4B;EAC5B,SAAS;EACT,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,8DAA8D;EAC9D,yDAAyD;EACzD,0DAA0D;EAC1D,2DAA2D;EAC3D,sDAAsD;AACxD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,iCAAiC;EACnC;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,iCAAiC;IACjC,yBAAyB;EAC3B;;EAEA;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;AACF;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,4CAA4C;EAC5C,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;IAChB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,oBAAoB;IACpB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;AACf;AACA,iCAAiC;AACjC;EACE,mBAAmB;AACrB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,SAAS;EACT,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,OAAO;EACP,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,MAAM;EACN,iCAAiC;EACjC,yBAAyB;EACzB,gCAAgC;EAChC,wBAAwB;EACxB,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,MAAM;EACN,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;;AAEb;AACA;IACI;MACE,6BAA6B;IAC/B;MACE,wBAAwB;MACxB,wBAAwB;MACxB;IACF;IACA;MACE,wBAAwB;MACxB,kCAAkC;MAClC;QACE,uBAAuB;;MAEzB;IACF;;IAEA;MACE;MACA;QACE,eAAe;QACf,UAAU;MACZ;IACF;IACA;IACA;;AAEJ;EACE;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,kCAAkC;EACpC;IACE,uBAAuB;;EAEzB;AACF;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B;EACA;IACE,0BAA0B;IAC1B;AACJ;EACE;EACA,wBAAwB;EACxB;EACA;IACE,wBAAwB;IACxB;AACJ;AACA;EACE,wBAAwB;EACxB,kCAAkC;EAClC;IACE,uBAAuB;EACzB;AACF;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB;IACE,wBAAwB;IACxB;MACE,mBAAmB;MACnB,2BAA2B;IAC7B;EACF;IACE,kBAAkB;EACpB;IACE,uBAAuB;IACvB,wBAAwB;IACxB;EACF;EACA;IACE,0BAA0B;IAC1B,qBAAqB;EACvB;AACF;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,wBAAwB;EACxB;IACE,wBAAwB;;IAExB;IACA,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;IACxB,YAAY;IACZ,sBAAsB;IACtB,UAAU;;EAEZ;EACA;AACF;AACA;AACA;AACA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;;;AAIA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6EAAuE;EACvE,qEAA+D;EAC/D,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;AACV;;;AAGA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,WAAW;EACX;AACF;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE;IACE,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;AACvB;AACA;;AAEA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;EACxC,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;;EAEzB,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,8BAA8B;;AAEhC;AACA;EACE;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,8BAA8B;IAC9B;MACE;QACE,iBAAiB;OAClB;QACC,kBAAkB;QAClB,uBAAuB;QACvB,iBAAiB;QACjB,UAAU;QACV;QACA;UACE,iBAAiB;UACjB,iBAAiB;MACrB;MACA;IACF;;EAEF;EACA;IACE,yCAAyC;IACzC,oBAAoB;IACpB,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,wBAAwB;IACxB,kCAAkC;;IAElC;MACE,uBAAuB;MACvB,wBAAwB;IAC1B;EACF;AACF;AACA;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;EAChC,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,oCAAoC;EACpC,kCAAkC;EAClC,kBAAkB;AACpB;;;;AAIA;MACM,gCAAgC;MAChC,oBAAoB;MACpB,oBAAoB;MACpB,aAAa;MACb,yBAAyB;MACzB,sBAAsB;MACtB,mBAAmB;MACnB,yBAAyB;MACzB,sBAAsB;MACtB,8BAA8B;MAC9B,yBAAyB;MACzB,aAAa;MACb,4BAA4B;MAC5B,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;MAClB,mBAAmB;MACnB,mBAAmB;MACnB,cAAc;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6EAAwE;EACxE,qEAAgE;AAClE;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB;+BAC6B;;EAE7B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6EAAwE;EACxE,qEAAgE;AAClE;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,+CAA+C;EAC/C,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;;;;AAKA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,WAAW;AACb;;AAEA;EACE;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,aAAa;IACb,0BAA0B;IAC1B,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;AAEF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE;MACE,iBAAiB;IACnB;IACA;MACE,iBAAiB;IACnB;;EAEF;AACF;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;EACtB,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,uDAAuD;EACvD,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,gBAAgB;EAChB,wCAAwC;EACxC,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,OAAO;EACP,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;;EAEE,MAAM;EACN,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;;AAGA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;AAChB;;;;AAIA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,6EAAuE;EACvE,2EAAqE;EACrE,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;;KAEG;;AAEL;AACA;EACE;IACE;EACF;AACF;AACA;EACE,2BAA2B;EAC3B;IACE;;;;8BAI0B;;QAEtB,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,aAAa;QACb,cAAc;QACd,UAAU;QACV,2BAA2B;QAC3B,2BAA2B;QAC3B,oBAAoB;QACpB,4BAA4B;QAC5B,6BAA6B;QAC7B,0BAA0B;QAC1B,sBAAsB;QACtB,yBAAyB;QACzB,sBAAsB;QACtB,mBAAmB;QACnB,+CAA+C;QAC/C,uCAAuC;IAC3C;MACE;QACE,YAAY;QACZ,gBAAgB;QAChB,wBAAwB;QACxB,gBAAgB;QAChB,oBAAoB;QACpB,uBAAuB;MACzB;IACF;EACF;AACF;AACA;EACE,2EAAkE;EAClE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,uCAAuC;EACvC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,sBAAsB;EACtB,0BAA0B;;AAE5B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,qBAAqB;EACrB,gCAAgC;;EAEhC,wBAAwB;EACxB,iCAAiC;EACjC,kCAAkC;EAClC,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,wBAAwB;EACxB,4CAA4C;EAC5C,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,8BAA8B;EAC9B,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,OAAO;EACP,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,oCAAoC;EACpC,4BAA4B;EAC5B,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,uCAAuC;EACvC,+BAA+B;EAC/B,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,4BAA4B;EAC5B,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;EACpC,4BAA4B;EAC5B,yCAAyC;EACzC,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,wCAAwC;EACxC,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,wCAAwC;EACxC,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,kCAAkC;EAClC,0BAA0B;EAC1B,kDAAkD;EAClD,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,MAAM;EACN,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;EACd,sCAAsC;EACtC,8BAA8B;EAC9B,6BAA6B;EAC7B,qBAAqB;EACrB,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,4BAA4B;EAC5B,SAAS;EACT,YAAY;EACZ,wCAAwC;EACxC,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;EAC9B,6BAA6B;EAC7B,qBAAqB;EACrB,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,iFAAiF;EACjF,yEAAyE;AAC3E;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;AACf,yBAAyB;EACvB;WACS;EACT,yEAAyE;AAC3E;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX;IACE,mBAAmB;EACrB;AACF;AACA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,WAAW;EACX,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE;IACE,uBAAuB;EACzB;EACA;EACA,aAAa;EACb;IACE,eAAe;IACf;MACE,aAAa;MACb;QACE,kBAAkB;MACpB;IACF;EACF;EACA;AACF;AACA;EACE,uDAAuD;AACzD;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,uBAAuB;IACvB,oBAAoB;IACpB,2BAA2B;EAC7B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,cAAc;IACd,qBAAqB;EACvB;AACF;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,wCAAwC;EACxC,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;EACX,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;EAC7C,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,MAAM;EACN,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;IACE,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;EACzB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,+CAA+C;EAC/C,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;;;;;;;;;sBASoB;EACpB,gBAAgB;AAClB;;AAEA;;GAEG;;AAEH;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;;AAGA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;AACjB;AACA;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE;IACE,QAAQ;EACV;EACA;IACE,wBAAwB;AAC5B;AACA;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE;IACE,OAAO;EACT;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,kCAAkC;EAClC,gBAAgB;EAChB,kCAAkC;EAClC,mCAAmC;EACnC,wCAAwC;EACxC,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,WAAW;EACX,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;EACtB,4CAA4C;EAC5C,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,6BAA6B;AAC/B;;AAEA;;EAEE;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;AAEF;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,OAAO;EACP,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE;IACE,iCAAiC;EACnC;EACA;IACE,UAAU;AACd;EACE;IACE,cAAc;IACd;MACE,aAAa;MACb;QACE,mBAAmB;QACnB,2BAA2B;MAC7B;IACF;MACE,kBAAkB;IACpB;MACE,uBAAuB;MACvB,wBAAwB;MACxB;IACF;IACA;MACE,eAAe;MACf,UAAU;IACZ;EACF;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;IACnB,kCAAkC;IAClC;MACE,aAAa;MACb;QACE,6BAA6B;QAC7B;UACE,0BAA0B;UAC1B,6BAA6B;QAC/B;QACA;UACE,sBAAsB;UACtB,2BAA2B;UAC3B,6BAA6B;MACjC;;MAEA;MACA;QACE,aAAa;QACb,mBAAmB;QACnB,YAAY;QACZ,eAAe;QACf,UAAU;QACV,UAAU;QACV,uBAAuB;QACvB,YAAY;MACd;IACF;;IAEA;MACE,mBAAmB;MACnB,UAAU;MACV,cAAc;MACd,uBAAuB;MACvB,gBAAgB;MAChB;QACE,oBAAoB;QACpB,kBAAkB;QAClB,SAAS;QACT,2BAA2B;QAC3B,WAAW;QACX,oBAAoB;QACpB,mBAAmB;QACnB,aAAa;MACf;IACF;EACF;EACA;AACF;;;AAGA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ;EACF;;EAEA;IACE,YAAY;IACZ,SAAS;IACT;EACF;;EAEA;;IAEE;EACF;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;;;AAIA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;;;AAGA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,WAAW;EACX,YAAY;EACZ;uBACqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC;;;;;4DAK0D;AAC5D;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,aAAa;AACf;;AAEA;EACE;IACE,6CAA6C;EAC/C;;EAEA;IACE,+CAA+C;EACjD;AACF;;AAEA;EACE;IACE,6CAA6C;EAC/C;;EAEA;IACE,+CAA+C;EACjD;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;AACF;;;AAGA;EACE,yDAAkD;EAClD,4BAA4B;EAC5B,gCAAgC;EAChC,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,aAAa;AACjB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE;IACE,qBAAqB;IACrB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;AACA;EACE;EACA;EACA;IACE,uBAAuB;IACvB,wBAAwB;IACxB;EACF;AACF;AACA;AACA;EACE,0BAA0B;;AAE5B;AACA;EACE,4BAA4B;EAC5B,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd;;uBAEqB;;AAEvB;;AAEA;;GAEG;;AAEH;;EAEE,kBAAkB;EAClB,UAAU;EACV,OAAO;AACT;;AAEA;EACE,MAAM;EACN,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,sBAAsB;IACtB,aAAa;EACf;AACF;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;EACxC,gCAAgC;EAChC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,4BAA4B;EAC5B,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,yDAAqD;AACvD;;AAEA;EACE,yDAA8C;AAChD;;AAEA;EACE,yDAA6C;AAC/C;;AAEA;EACE,yDAAgD;AAClD;;AAEA;EACE,yDAA6C;AAC/C;AACA;;EAEE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,WAAW;EACX,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;IACT,kBAAkB;AACtB;;AAEA;;EAEE,yBAAyB;EACzB,iBAAiB;EACjB,+BAA+B;EAC/B,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;;;AAIA,iCAAiC;AACjC;;;;EAIE,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,0EAA2yD;EAC3yD,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0EAAuW;EACvW,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;EACxB,6BAA6B;;AAE/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;IACxB,MAAM;EACR;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,qDAAqD;EACrD,yBAAyB;EACzB,qBAAqB;EACrB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;AACA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,eAAe;EACf,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;GACG,cAAc;AACjB;AACA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,WAAW;EACX,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE;IACE,uBAAuB;IACvB,oBAAoB;IACpB,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,wCAAwC;EACxC,gCAAgC;EAChC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;EACX,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;AACf;;;;AAIA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gBAAgB;;EAEhB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,cAAc;EACd,wBAAwB;EACxB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;;EAEnB,UAAU;EACV,qBAAqB;;EAErB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;GAIG;AACH;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,YAAY;EACd;;;;EAIA;IACE,UAAU;IACV,UAAU;IACV,YAAY;IACZ,oCAAoC;EACtC;;AAEF;;;;AAIA;EACE,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,QAAQ;EACR,aAAa;AACf;;;AAGA;;;GAGG;;;AAGH;EACE,eAAe;EACf,mBAAmB;;AAErB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,OAAO;IACL,eAAe;;AAEnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;;;;;AAMA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA4HG;;;AAGH;CACC,UAAU;EACT,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;;AAGA;EACE,kCAAkC;IAChC,6BAA6B;IAC7B,iCAAiC;IACjC,oBAAoB;IACpB,sCAAsC;IACtC,0DAA0D;IAC1D,kBAAkB;AACtB;;;AAGA;EACE,iDAA2C;AAC7C;AACA;EACE,iDAA2C;AAC7C;AACA;EACE,iDAA2C;AAC7C;;;;;;;AAOA;EACE,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,iDAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;;EAEhB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;AACA;;GAEG;AACH;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,6DAA6D;EAC7D,mBAAmB;;EAEnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,OAAO;EACP,aAAa;EACb,uBAAuB;AACzB;;;AAGA;EACE,OAAO;AACT;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;;;AAGA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,2BAA2B;EAC3B;iBACe;AACjB;;AAEA;;GAEG;;AAEH;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,8BAA8B;EAC9B,WAAW;AACb;AACA;;GAEG;;AAEH;EACE,uBAAuB;;EAEvB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,OAAO;;EAEP,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;AAGA,oBAAoB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;IACf,cAAc;IACd,kBAAkB;AACtB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,iDAA8C;EAChD;EACA;IACE,iDAA8C;EAChD;EACA;IACE,iDAA8C;EAChD;;;EAGA;IACE,sBAAsB;EACxB;;EAEA;IACE,OAAO;IACP,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;EACpB;;AAEF;EACE,cAAc;AAChB;EACE;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;;;KAGG;EACH;IACE,mBAAmB;EACrB;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;;AAGA;EACE,oBAAoB;EACpB,wCAAwC;EACxC,SAAS;EACT,WAAW;EACX,eAAe;;EAEf;IACE,gBAAgB;EAClB;;EAEA;IACE;MACE,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,SAAS;AACX;;;AAGA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,aAAa;;;EAGb;IACE,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,qBAAqB;IACrB,2CAA2C;IAC3C,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;;IAEtB;MACE,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;MACE,2BAA2B;IAC7B;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;MACnB,mBAAmB;MACnB,oBAAoB;MACpB,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;MACE,kBAAkB;MAClB,SAAS;MACT,WAAW;MACX,eAAe;;MAEf;QACE,gBAAgB;MAClB;;MAEA;QACE;UACE,gBAAgB;QAClB;MACF;IACF;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,gBAAgB;;MAEhB;QACE,eAAe;QACf,oBAAoB;MACtB;IACF;;;;IAIA;;MAEE,kBAAkB;MAClB,SAAS;MACT,aAAa;MACb,UAAU;MACV,iBAAiB;;MAEjB,aAAa;;MAEb,2BAA2B;MAC3B,eAAe;MACf,qBAAqB;;MAErB,oBAAoB;IACtB;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,aAAa;MACb,2BAA2B;MAC3B,eAAe;MACf,mBAAmB;MACnB,qBAAqB;;MAErB,oBAAoB;MACpB,yBAAyB;;MAEzB;QACE,eAAe;MACjB;IACF;;IAEA;EACF;MACI,aAAa;EACjB;EACA;IACE,sBAAsB;EACxB;AACF;IACI;MACE,aAAa;MACb,2BAA2B;MAC3B,8BAA8B;MAC9B,WAAW;IACb;;IAEA;MACE,aAAa;MACb,2BAA2B;MAC3B,oBAAoB;MACpB,mBAAmB;MACnB,WAAW;MACX,oBAAoB;MACpB,eAAe;;IAEjB;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,aAAa;MACb,2BAA2B;MAC3B,mBAAmB;IACrB;;;;;IAKA;MACE,4BAA4B;MAC5B,aAAa;MACb,cAAc;MACd,sBAAsB;MACtB,sBAAsB;MACtB,gBAAgB;IAClB;;IAEA;MACE,aAAa;MACb,yBAAyB;MACzB,wCAAwC;MACxC,eAAe;MACf,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,aAAa;MACb,iBAAiB;IACnB;;IAEA;MACE,4BAA4B;MAC5B,gBAAgB;IAClB;;IAEA;MACE,iBAAiB;MACjB,4BAA4B;IAC9B;;IAEA;MACE,iBAAiB;MACjB,aAAa;MACb,2BAA2B;MAC3B,oBAAoB;MACpB,WAAW;MACX,eAAe;MACf,WAAW;IACb;;IAEA;MACE,YAAY;MACZ,mBAAmB;MACnB,mBAAmB;MACnB,oBAAoB;MACpB,gBAAgB;MAChB,eAAe;MACf,2BAA2B;MAC3B,uCAAuC;;MAEvC;QACE,yBAAyB;QACzB,cAAc;QACd,2BAA2B;MAC7B;IACF;;IAEA;MACE,kBAAkB;MAClB,gBAAgB;MAChB,cAAc;MACd,kBAAkB;MAClB,YAAY;MACZ,UAAU;MACV,eAAe;;MAEf;QACE,cAAc;MAChB;IACF;;IAEA;MACE,kBAAkB;MAClB,aAAa;MACb,2BAA2B;MAC3B,mBAAmB;MACnB,YAAY;MACZ,qBAAqB;MACrB,iBAAiB;MACjB,4BAA4B;MAC5B,cAAc;MACd,0CAA0C;MAC1C,kBAAkB;MAClB,cAAc;MACd,WAAW;MACX,eAAe;;MAEf;QACE,YAAY;QACZ,mBAAmB;MACrB;;IAEF;EACF;AACF;;;AAGA;EACE,6DAA6D;EAC7D,cAAc;AAChB;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,eAAe;;;EAGf;IACE,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,qBAAqB;IACrB,2CAA2C;IAC3C,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;;IAEtB;MACE,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;MACE,2BAA2B;IAC7B;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;MACnB,mBAAmB;MACnB,oBAAoB;MACpB,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;MACE,WAAW;MACX,aAAa;MACb,mBAAmB;;MAEnB;;QAEE,4BAA4B;;QAE5B,eAAe;;QAEf;UACE;YACE,gBAAgB;UAClB;QACF;MACF;;MAEA;QACE,+BAA+B;QAC/B,OAAO;QACP,iBAAiB;;QAEjB,WAAW;QACX,iBAAiB;;QAEjB,2BAA2B;QAC3B,qBAAqB;;QAErB,oBAAoB;MACtB;IACF;;;IAGA;MACE,oBAAoB;;MAEpB,aAAa;MACb,2BAA2B;MAC3B,oBAAoB;MACpB,WAAW;MACX,eAAe;MACf,WAAW;;;MAGX;QACE,WAAW;QACX,oBAAoB;QACpB,cAAc;QACd,gBAAgB;QAChB,gBAAgB;QAChB,iBAAiB;MACnB;;MAEA;QACE,WAAW;QACX,YAAY;QACZ,cAAc;QACd,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;MACpB;MACA;;;QAGE,eAAe;QACf,eAAe;QACf,0BAA0B;MAC5B;IACF;;;IAGA;MACE,8BAA8B;MAC9B,aAAa;MACb,cAAc;MACd,sBAAsB;MACtB,sBAAsB;MACtB,gBAAgB;IAClB;;IAEA;MACE,iBAAiB;MACjB,aAAa;IACf;;IAEA;MACE,WAAW;MACX,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,qBAAqB;IACvB;;IAEA;MACE,cAAc;;IAEhB;AACJ;EACE,YAAY;EACZ,gCAAgC;EAChC,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;EAEE;;AAEF;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAqDG;;;AAGH;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,uBAAuB;;AAEzB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;;EAEE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;;AAGA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;;;AAGA;EACE,8BAA8B;AAChC;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,wBAAwB;EAC1B;;AAEF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;;EAEE;IACE,oBAAoB;EACtB;EACA;IACE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;;;AAGA;EACE;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;AACF","sourcesContent":["\r\na,\r\na:focus,\r\na:hover,\r\na:visited,\r\na:link {\r\n  outline: 0 !important;\r\n}\r\n\r\nhtml,\r\nbody,\r\ndiv,\r\nspan,\r\napplet,\r\nobject,\r\niframe,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\np,\r\nblockquote,\r\npre,\r\na,\r\nabbr,\r\nacronym,\r\naddress,\r\nbig,\r\ncite,\r\ncode,\r\ndel,\r\ndfn,\r\nem,\r\nfont,\r\nimg,\r\nins,\r\nkbd,\r\nq,\r\ns,\r\nsamp,\r\nsmall,\r\nstrike,\r\nstrong,\r\nsub,\r\nsup,\r\ntt,\r\nvar,\r\nb,\r\nu,\r\ni,\r\ncenter,\r\nol,\r\nul,\r\nli,\r\nfieldset,\r\nform,\r\nlabel,\r\nlegend,\r\ntable,\r\ncaption,\r\ntbody,\r\ntfoot,\r\nthead,\r\ntr,\r\nth,\r\ntd {\r\n  background: rgba(0, 0, 0, 0);\r\n  border: 0;\r\n  margin: 0;\r\n  padding: 0;\r\n  vertical-align: baseline;\r\n  outline: none;\r\n  list-style: none;\r\n  -ms-text-shadow: none;\r\n  text-shadow: none;\r\n}\r\n\r\nbody.active-BW {\r\n  -webkit-filter: grayscale(100%) brightness(95%) contrast(120%);\r\n  -o-filter: grayscale(100%) brightness(95%) contrast(120%);\r\n  -ms-filter: grayscale(100%) brightness(95%) contrast(120%);\r\n  -moz-filter: grayscale(100%) brightness(95%) contrast(120%);\r\n  filter: grayscale(100%) brightness(95%) contrast(120%);\r\n}\r\n\r\n.banner-img-cont img{\r\n  height: 17rem !important;\r\n}\r\n\r\n.black-white {\r\n  cursor: pointer;\r\n}\r\n\r\nbody {\r\n  font-family: \"Ping AR + LT\";\r\n  overflow-x: hidden;\r\n  direction: rtl;\r\n  overflow-y: scroll;\r\n  position: relative;\r\n  background: #E5E7EA;\r\n}\r\n\r\nhtml {\r\n  position: relative;\r\n  min-height: 100%;\r\n}\r\n\r\nbody {\r\n  text-align: right;\r\n}\r\n\r\nfooter {\r\n  width: 100%;\r\n}\r\n\r\n@-webkit-keyframes spinAround {\r\n  from {\r\n    -webkit-transform: rotate(360deg);\r\n  }\r\n\r\n  to {\r\n    -webkit-transform: rotate(0deg);\r\n  }\r\n}\r\n\r\n@keyframes spinAround {\r\n  from {\r\n    -webkit-transform: rotate(360deg);\r\n    transform: rotate(360deg);\r\n  }\r\n\r\n  to {\r\n    -webkit-transform: rotate(0deg);\r\n    transform: rotate(0deg);\r\n  }\r\n}\r\n\r\n.animated {\r\n  -webkit-animation-duration: 1s;\r\n  animation-duration: 1s;\r\n  -webkit-animation-fill-mode: none !important;\r\n  animation-fill-mode: none !important;\r\n}\r\n\r\n* {\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\nbutton {\r\n  cursor: pointer;\r\n}\r\n\r\na:hover,\r\na:visited,\r\na:link,\r\na:active {\r\n  text-decoration: none;\r\n}\r\n\r\nul,\r\np {\r\n  margin: 0px;\r\n  padding: 0px;\r\n}\r\n\r\nbody {\r\n  color: #595959;\r\n  font-size: 0.9rem;\r\n  padding: 0 !important;\r\n  overflow-y: auto !important;\r\n}\r\n\r\nh1 {\r\n  color: #00004E;\r\n  font-size: 1.8em;\r\n  font-weight: bold;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n\r\nh1 span {\r\n  color: #9d9d9d;\r\n  font-weight: normal;\r\n  font-size: 1.2rem;\r\n  -webkit-margin-start: 0.5rem;\r\n  margin-inline-start: 0.5rem;\r\n}\r\n\r\n.icon {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\na {\r\n  text-decoration: none;\r\n}\r\n\r\n.welcome-hero {\r\n  background-color: #00BF00;\r\n  padding: 50px 0;\r\n}\r\n\r\n.welcome-hero h1 {\r\n  font-size: 2rem;\r\n  font-weight: bold;\r\n  color: #fff;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.welcome-hero p {\r\n  color: #fff;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.introduction-video {\r\n  padding: 50px 0;  \r\n  position: relative;\r\n  background-color: #F5F6F8;\r\n  z-index: 2;\r\n}\r\n\r\n.introduction-video h1 {\r\n  font-size: 2rem;\r\n  font-weight: bold;\r\n  color: #00BF00;\r\n  margin-bottom: 2rem;\r\n  width: 100%;\r\n  -webkit-box-pack: start;\r\n  -ms-flex-pack: start;\r\n  justify-content: start;\r\n}\r\n\r\n.introduction-video p {\r\n  font-size: 1.8rem;\r\n  color:#00004E;\r\n  font-weight: 400;\r\n}\r\n\r\n.introduction-video .video-container {\r\n  width: 100%;\r\n  margin: 0 auto;\r\n  aspect-ratio: 16/9;\r\n}\r\n\r\n.calc-container {\r\n  background-color: #E5E7EA;\r\n  padding: 50px 0 0 0;\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n.calc-container h1 {\r\n  font-size: 1.75rem;\r\n    font-weight: 700;\r\n    color: white;\r\n    margin-bottom: 2rem;\r\n    width: 100%;\r\n    -webkit-box-pack: start;\r\n    -ms-flex-pack: start;\r\n    justify-content: center;\r\n    text-align: center;\r\n}\r\n\r\n.calc-container p {\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.calc-container .video-container {\r\n  width: 100%;\r\n  margin: 0 auto;\r\n  aspect-ratio: 16/9;\r\n}\r\n\r\n.calc-container .container-area {\r\n  background-color: #00004E !important;\r\n}\r\n\r\n/* Style the tab */\r\n.tab {\r\n  overflow: hidden;\r\n  border: 1px solid #ccc;\r\n  background-color: #F3F4F5;\r\n  width: fit-content;\r\n  border-radius: 2rem;\r\n  align-items: center;\r\n  display: flex;\r\n  padding: 0.2rem;\r\n  min-width: 20.5rem;\r\n}\r\n\r\n/* Style the buttons inside the tab */\r\n.tab button {\r\n  background-color: inherit;\r\n  float: left;\r\n  border: none;\r\n  outline: none;\r\n  cursor: pointer;\r\n  transition: 0.3s;\r\n  color: #00004e;\r\n  font-weight: 700;\r\n  font-size: 1rem;\r\n  font-weight: 500;\r\n  border-radius: 2rem;\r\n  padding: 0.5rem 1rem;\r\n  min-width: 10rem;\r\n}\r\n\r\n/* Change background color of buttons on hover */\r\n.tab button:hover {\r\n  color: #00BF00;\r\n}\r\n\r\n/* Create an active/current tablink class */\r\n.tab button.active {\r\n  background-color: #00BF00;\r\n  border-radius: 2rem;\r\n  padding: 0.5rem 1rem;\r\n  min-width: 10rem;\r\n  color: #00004e;\r\n  font-weight: 700;\r\n  font-size: 1rem;\r\n}\r\n\r\n/* Style the tab content */\r\n.tabcontent {\r\n  display: none;\r\n}\r\n/* Show the default tab content */\r\n#Individuals_journey {\r\n  /* display: flex; */\r\n}\r\n#business_journey {\r\n    /* display: none; */\r\n    background: #fff;\r\n    border-radius: 2rem;\r\n    padding: 1rem;\r\n}\r\n\r\n.journies-section {\r\n  padding: 50px 0 0 0;\r\n  position: relative;\r\n  flex-direction: column;\r\n  margin-top: -10rem;  \r\n  z-index: 2;\r\n  display: flex;\r\n  gap: 1rem;\r\n}\r\n\r\n.journies-section h1 {\r\n  position: relative;\r\n  font-size: 1.7em;\r\n  font-weight: bold;\r\n  color: #00BF00;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.journies-section p {\r\n  position: relative;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.welcome-icon {\r\n  display: -webkit-inline-box;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  max-width: 30px;\r\n  -webkit-margin-start: 5px;\r\n  margin-inline-start: 5px;\r\n}\r\n\r\n.done-icon {\r\n  display: -webkit-inline-box;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  max-width: 20px;\r\n  margin-top: 5px;\r\n  -webkit-margin-start: 5px;\r\n  margin-inline-start: 5px;\r\n}\r\n\r\n.celebrate-icon {\r\n  display: -webkit-inline-box;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  max-width: 70px;\r\n  margin-top: 5px;\r\n  -webkit-margin-start: 10px;\r\n  margin-inline-start: 10px;\r\n}\r\n\r\n.jssocials {\r\n  position: fixed;\r\n  bottom: 150px;\r\n  inset-inline-end: 20px;\r\n  z-index: 9999;\r\n}\r\n\r\n.jssocials .jssocials-shares {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  margin: 0;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n}\r\n\r\n.jssocials .jssocials-shares .jssocials-share {\r\n  margin: 0.3rem 0;\r\n}\r\n\r\n.jssocials-share-link {\r\n  border-radius: 50%;\r\n}\r\n\r\n.jssocials-share-twitter .jssocials-share-link {\r\n  background: #f4f6f8;\r\n  color: #1e1d1d;\r\n}\r\n\r\n.jssocials-share-twitter .jssocials-share-link:hover {\r\n  background: #000;\r\n  color: #fff;\r\n}\r\n\r\n.jssocials-share-email .jssocials-share-link {\r\n  background: #f4f6f8;\r\n  color: #1e1d1d;\r\n}\r\n\r\n.jssocials-share-email .jssocials-share-link:hover {\r\n  background: #0064FF;\r\n  color: #fff;\r\n}\r\n\r\n.jssocials-share-facebook .jssocials-share-link {\r\n  background: #f4f6f8;\r\n  color: #1e1d1d;\r\n}\r\n\r\n.jssocials-share-facebook .jssocials-share-link:hover {\r\n  background: #334157;\r\n  color: #fff;\r\n}\r\n\r\n.jssocials-share-linkedin .jssocials-share-link {\r\n  background: #f4f6f8;\r\n  color: #1e1d1d;\r\n}\r\n\r\n.jssocials-share-linkedin .jssocials-share-link:hover {\r\n  background: #0064FF;\r\n  color: #fff;\r\n}\r\n\r\n.jssocials-share-whatsapp .jssocials-share-link {\r\n  background: #f4f6f8;\r\n  color: #1e1d1d;\r\n}\r\n\r\n.jssocials-share-whatsapp .jssocials-share-link:hover {\r\n  background: #00BF00;\r\n  color: #fff;\r\n}\r\n\r\na {\r\n  color: #00BF00;\r\n  -webkit-transition: all 0.3s ease-in-out;\r\n  transition: all 0.3s ease-in-out;\r\n}\r\n\r\na:hover {\r\n  color: #00BF00;\r\n}\r\n\r\na:focus {\r\n  color: #00BF00;\r\n}\r\n\r\na:active {\r\n  color: #00BF00;\r\n}\r\n\r\n.calc-btn-row{\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.align-sidebar {\r\n  color: rgba(128, 128, 128, 0.3);\r\n  height: 100%;\r\n  left: 0;\r\n  line-height: 2;\r\n  margin: 0;\r\n  position: absolute;\r\n  top: 0;\r\n  -webkit-transform: rotate(-30deg);\r\n  transform: rotate(-30deg);\r\n  -webkit-transform-origin: 0 100%;\r\n  transform-origin: 0 100%;\r\n  width: 250%;\r\n  word-spacing: 20px;\r\n  z-index: 1;\r\n  -webkit-touch-callout: none;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n}\r\n\r\nvideo,\r\niframe {\r\n  position: relative;\r\n  z-index: 2;\r\n  border-radius: 15px;\r\n}\r\n\r\n.align-sidebar-container {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: hidden;\r\n  z-index: 1;\r\n  top: 0;\r\n  left: 0;\r\n  display: block;\r\n}\r\n\r\n.popup-card {\r\n  max-width: 350px;\r\n  width: 100%;\r\n  \r\n}\r\n@media (max-width: 990px){\r\n    .popup-card.business-popup-card{\r\n      margin: 3rem 0 0 0 !important;\r\n    .card-thumb {\r\n      width: 300px !important ;\r\n      height: 183px !important;\r\n      }\r\n    }\r\n    .popup-card.businessJourney-image{\r\n      display: flex !important;\r\n      justify-content: center !important;\r\n      .card-thumb {\r\n        width: 267px !important;\r\n    \r\n      }\r\n    }\r\n\r\n    #business_journey {\r\n      .business_journey_section{\r\n      .article-card .start-journey{\r\n        max-width: 100%;\r\n        width: 70%;\r\n      }\r\n    }\r\n    }\r\n    }\r\n\r\n@media (max-width: 600px){\r\n  .card-thumb {\r\n    width: 267px !important;\r\n  }\r\n  .popup-card{\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  .popup-card.business-popup-card {\r\n    display: flex !important;\r\n    justify-content: center !important;\r\n  .card-thumb {\r\n    width: 267px !important;\r\n\r\n  }\r\n}\r\n.card-thumb {\r\n  width: 161px !important;\r\n}\r\nul.paddingJourney{\r\n  padding: 0.5rem !important;\r\n  }\r\n  ol.paddingJourney{\r\n    padding: 0.5rem !important;\r\n    }\r\n.accordion.businessJourney .accordion-body{\r\n  ul{\r\n  padding: 0rem !important;\r\n  }\r\n  ol{\r\n    padding: 0rem !important;\r\n    }\r\n}\r\n.popup-card.businessJourney-image{\r\n  display: flex !important;\r\n  justify-content: center !important;\r\n  .card-thumb {\r\n    width: 161px !important;\r\n  }\r\n}\r\n.accordion.businessJourney .accordion-body{\r\n  padding: 1rem 1.5rem !important;\r\n}\r\n\r\n#business_journey {\r\n  height: 30rem !important;\r\n  .business_journey_section{\r\n    height: 27rem !important;\r\n    .journies-section h1{\r\n      align-items: center;\r\n      font-size: 1.2em !important;\r\n    }\r\n  .popup-card.business-popup-card{\r\n    margin: 3rem 0 0 0;\r\n  .card-thumb {\r\n    width: 300px !important;\r\n    height: 183px !important;\r\n    }\r\n  }\r\n  .article-card .start-journey{\r\n    max-width: 100% !important;\r\n    width: 70% !important;\r\n  }\r\n}\r\n\r\n.businessjourney4{\r\n  align-items: center;\r\n  justify-content: center !important;\r\n  height: 23rem !important;\r\n  .business-card-top{\r\n    height: 10rem !important;\r\n\r\n    .jur-button-cont{\r\n    height: 0rem;\r\n    position: relative;\r\n    width: 80%;\r\n    right: unset;\r\n    align-items: center;\r\n    justify-content: center;\r\n    display: flex !important;\r\n    margin: auto;\r\n    top: 8.8rem !important;\r\n    z-index: 2;    \r\n\r\n  }\r\n  }\r\n}\r\n}\r\n}\r\n.popup-card .card-thumb {\r\n  width: 350px;\r\n  height: 220px;\r\n  border-radius: 0.5rem;\r\n  overflow: hidden;\r\n  position: relative;\r\n  border: 2px solid #334157;\r\n}\r\n\r\n.popup-card .card-thumb img {\r\n  max-width: 100%;\r\n  min-height: 100%;\r\n}\r\n\r\n.popup-card .card-thumb .card-play {\r\n  width: 40px;\r\n  height: 40px;\r\n  display: -webkit-inline-box;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  border-radius: 50px;\r\n  background-color: #00BF00;\r\n  color: #fff;\r\n  position: absolute;\r\n  z-index: 1;\r\n  top: 50%;\r\n  margin-top: -20px;\r\n  left: 50%;\r\n  margin-left: -20px;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  -webkit-box-pack: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n}\r\n\r\n.popup-card button {\r\n  border: 0 none;\r\n  border-radius: 0.5rem;\r\n  overflow: hidden;\r\n}\r\n\r\n.popup-card h3 {\r\n  font-size: 1.2rem;\r\n  color: #333371;\r\n  font-weight: bold;\r\n  text-align: center;\r\n  margin-top: 8px;\r\n}\r\n\r\n.popup-card:last-of-type {\r\n  -webkit-margin-end: 0;\r\n  margin-inline-end: 0;\r\n}\r\n\r\n.modal-title {\r\n  color: #333371;\r\n}\r\n\r\n\r\n\r\n.main-heading {\r\n  color: #33CC33;\r\n  font-weight: bold;\r\n  font-size: 1rem;\r\n  text-align: right;\r\n  width: 100%;\r\n}\r\n\r\nheader .top-bar {\r\n  width: 100%;\r\n  height: 52px;\r\n  background-color: #00004E;\r\n}\r\n\r\nheader nav {\r\n  background-color: #fff;\r\n  padding: 0;\r\n  -webkit-box-shadow: 0 8px 12px 0px rgba(0, 0, 0, 0.1);\r\n  box-shadow: 0 8px 12px 0px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\nheader nav .navbar-brand {\r\n  padding: 0px;\r\n}\r\n\r\nheader nav .navbar-brand img {\r\n  width: 100%;\r\n  max-height: 5rem;\r\n}\r\nheader nav .navbar-brand .logo-desktop {\r\n  display: inline-block;\r\n  width: 8rem;\r\n}\r\nheader nav .navbar-brand .logo-mobile {\r\n  display: none;\r\n}\r\n\r\nheader .welcome-message {\r\n  color: #fff;\r\n  background-color: #00BF00;\r\n  font-weight: bold;\r\n  padding: 0.8rem 0;\r\n  text-align: center;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.mobile-header {\r\n  display: none;\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  width: 100%;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  -webkit-box-pack: justify;\r\n  -ms-flex-pack: justify;\r\n  justify-content: space-between;\r\n  z-index: 999;\r\n  height: 65px;\r\n  padding-inline-start: 20px;\r\n  padding-inline-end: 20px;\r\n  padding-top: 15px;\r\n}\r\n\r\n.mobile-header .backHome {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  width: 40px;\r\n  height: 40px;\r\n  color: #1e1d1d;\r\n  /* background: #00004E; */\r\n  text-align: center;\r\n  font-size: 22px;\r\n  border-radius: 50%;\r\n  -webkit-box-pack: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  border: 1px solid #00BF00;\r\n}\r\n\r\n.mobile-header .backHome .home-mask {\r\n  background: #1e1d1d;\r\n  width: 100%;\r\n  height: 100%;\r\n  border-radius: 50%;\r\n  -webkit-mask: url(\"../images/back-to-home.svg\") center center no-repeat;\r\n  mask: url(\"../images/back-to-home.svg\") center center no-repeat;\r\n  -webkit-transition: all 0.2s ease-in-out;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.mobile-header .backHome:hover .home-mask {\r\n  background-color: #334157;\r\n}\r\n\r\n.mobile-header .navbar-toggler {\r\n  background-color: #00BF00;\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50px;\r\n  position: relative;\r\n  right: 0;\r\n}\r\n\r\n\r\n.mobile-header .navbar-toggler::before {\r\n  content: \"\";\r\n  width: 20px;\r\n  height: 2px;\r\n  border-radius: 3px;\r\n  position: absolute;\r\n  top: 13px;\r\n  right: 10px;\r\n  background-color: #00004E;\r\n}\r\n\r\n.mobile-header .navbar-toggler::after {\r\n  content: \"\";\r\n  width: 20px;\r\n  height: 2px;\r\n  border-radius: 3px;\r\n  position: absolute;\r\n  top: auto;\r\n  bottom: 13px;\r\n  right: 10px;\r\n  background-color: #00004E\r\n}\r\n\r\n.mobile-header .navbar-toggler .navbar-toggler-icon {\r\n  width: 20px;\r\n  height: 2px;\r\n  border-radius: 3px;\r\n  position: absolute;\r\n  top: 19px;\r\n  right: 10px;\r\n  background-color: #00004E;\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .mobile-header {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n  }\r\n\r\n  .temp-height{\r\n    width: 33.96375rem;\r\n  }\r\n  .my_top_section {\r\n    align-items: center;\r\n}\r\n}\r\n\r\n.offcanvas-header .btn-close {\r\n  top: 10px;\r\n  left: 10px;\r\n  position: absolute;\r\n  z-index: 99999;\r\n  -webkit-filter: none;\r\n  filter: none;\r\n}\r\n\r\n.offcanvas-header .btn-close:focus {\r\n  -webkit-box-shadow: 0 8px 12px -13px rgba(0, 0, 0, 0);\r\n  box-shadow: 0 8px 12px -13px rgba(0, 0, 0, 0);\r\n}\r\n\r\n.backWebsite {\r\n  background-color: #00BF00;\r\n  color: #00004E;\r\n  padding: 0.5rem 1.2rem;\r\n  border-radius: 10px;\r\n  -webkit-transition: all 0.3s ease-in-out;\r\n  transition: all 0.3s ease-in-out;\r\n  font-weight: bold;\r\n}\r\n\r\n.backWebsite:hover {\r\n  background-color: #80DF80;\r\n  color: #00004E;\r\n}\r\n\r\n.backWebsite:focus {\r\n  background-color: #BFEFBF;\r\n  color: #00004E;\r\n}\r\n\r\nfooter .footer-content {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  -webkit-box-pack: justify;\r\n  -ms-flex-pack: justify;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  padding: 1rem 0;\r\n  margin-top: 1rem;\r\n  -ms-flex-wrap: wrap;\r\n  flex-wrap: wrap;\r\n}\r\n\r\nfooter .brand-logo {\r\n  -webkit-margin-end: 0.5rem;\r\n  margin-inline-end: 0.5rem;\r\n}\r\n\r\nfooter .brand-logo img {\r\n  width: 140px;\r\n  max-height: 60px;\r\n}\r\n\r\n.article-card {\r\n  border-radius: 16px 16px 26px 26px;\r\n  overflow: hidden;\r\n  /* height: 94%; */\r\n  border: 1px solid #D8DBDD;\r\n\r\n  padding-bottom: 0.75rem;\r\n}\r\n.journey1{\r\n  background-color:#00BF00;\r\n}\r\n.journey4{\r\n  background-color: #A37DFC; \r\n}\r\n.journey3{\r\n  background-color:#00004E ; \r\n}\r\n.businessjourney4{\r\n  background-color: #00004E;\r\n  height: 18rem ;\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n.business-card-top{\r\n  display: flex;\r\n  width: 100%;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n\r\n}\r\n#business_journey {\r\n  .business_journey_section{\r\n  .article-card .start-journey{\r\n    max-width: 50% ;\r\n  }\r\n  .business-card-top{\r\n    display: flex;\r\n    width: 100%;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    .info-cards{\r\n      .info-card{\r\n        margin: 2rem 1rem;\r\n       .info-hint2{\r\n        font-size: 1.875em;\r\n        padding-bottom: 0.75rem;\r\n        text-align: right;\r\n        width: 90%;\r\n        }\r\n        .info-hint3 {\r\n          font-size: 1.2rem;\r\n          text-align: right;\r\n      }\r\n      }\r\n    }\r\n  \r\n  }\r\n  img {\r\n    transform: translateX(4%) translatey(11%);\r\n    pointer-events: none;\r\n    height: 17rem;\r\n  }\r\n  .popup-card.business-popup-card{\r\n    max-width: 312px;\r\n    display: flex !important;\r\n    justify-content: center !important;\r\n\r\n    .card-thumb {\r\n      width: 320px !important;\r\n      height: 200px !important;\r\n    }\r\n  }\r\n}\r\n}\r\n.banner-cont{\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n}\r\n.banner-img-cont{\r\n  width: fit-content;\r\n  display: inline-block;\r\n  text-align: left;\r\n}\r\n.article-card figure {\r\n  position: relative;\r\n  width: 100%;\r\n  /* overflow: hidden; */\r\n  display: block;\r\n  min-height: 12.318125rem;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.article-card figure img {\r\n  position: absolute;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 100%;\r\n  /* width: 90%; */\r\n  pointer-events: none;\r\n  object-fit: contain;\r\n  bottom: -6rem;\r\n}\r\n\r\n.article-card time {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  border-bottom: 1px solid #f4f4f4;\r\n  padding: 0.5rem 0.75rem;\r\n  color: #9d9d9d;\r\n}\r\n\r\n.article-card time img {\r\n  margin-left: 0.25rem;\r\n  margin-top: 0.15rem;\r\n}\r\n\r\n.article-card h2 {\r\n  color: #00122D;\r\n  font-size: 1rem;\r\n  font-weight: bold;\r\n  margin-top: 1.75rem;\r\n  margin-bottom: 1.18rem;\r\n  width: fit-content;\r\n  background: rgba(191, 239, 191, 0.5);\r\n  padding: 0.5rem 1.5rem 0.5rem 1rem;\r\n  border-radius: 5px;\r\n}\r\n\r\n\r\n\r\n.article-card .start-journey {\r\n      /* width: calc(100% - 1.5rem); */\r\n      display: -webkit-box;\r\n      display: -ms-flexbox;\r\n      display: flex;\r\n      -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n      align-items: center;\r\n      -webkit-box-pack: justify;\r\n      -ms-flex-pack: justify;\r\n      justify-content: space-between;\r\n      background-color: #00BF00;\r\n      padding: 1rem;\r\n      /* padding-right: 1.68rem; */\r\n      bottom: 1rem;\r\n      margin-left: 1rem;\r\n      margin-right: 1rem;\r\n      border-radius: 5rem;\r\n      min-height: 3.25rem;\r\n      color: #00004E;\r\n}\r\n\r\n.article-card .start-journey:hover {\r\n    color: #00004E;\r\n}\r\n\r\n.article-card .start-journey:focus {\r\n  border: 3px solid #00BF00;\r\n  color: #00BF00;\r\n}\r\n\r\n.article-card .start-journey .icon-container {\r\n  width: 32px;\r\n  height: 32px;\r\n  background-color: #fff;\r\n  border-radius: 50%;\r\n  display: -webkit-inline-box;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  -webkit-box-flex: 0;\r\n  -ms-flex: 0 0 32px;\r\n  flex: 0 0 32px;\r\n  padding: 3px;\r\n  -webkit-box-pack: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.article-card .start-journey .icon-container .icon {\r\n  background: #00BF00;\r\n}\r\n\r\n.article-card .start-journey .icon-container .plane-mask {\r\n  -webkit-mask: url(\"../images/lx-card_plane.svg\") center center no-repeat;\r\n  mask: url(\"../images/lx-card_plane.svg\") center center no-repeat;\r\n}\r\n\r\n.article-card .start-journey .start-journey-text {\r\n  display: -webkit-inline-box;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  /* -webkit-padding-end: 2.5rem;\r\n  padding-inline-end: 2.5rem; */\r\n  \r\n  position: relative;\r\n}\r\n\r\n.article-card .start-journey .start-journey-text h6 {\r\n  font-size: 1.2rem;\r\n  margin-bottom: 0.2rem;\r\n}\r\n\r\n.article-card .start-journey .start-journey-text .icon-container {\r\n  background-color: rgba(0, 0, 0, 0);\r\n  position: absolute;\r\n  left: 0.5rem;\r\n  -webkit-transition: all 0.3s ease-in-out;\r\n  transition: all 0.3s ease-in-out;\r\n}\r\n\r\n.article-card .start-journey .start-journey-text .icon {\r\n  background: #00004E;\r\n  margin-top: 0.2rem;\r\n}\r\n\r\n.article-card .start-journey .start-journey-text .arrow-mask {\r\n  -webkit-mask: url(\"../images/lx-card_arrow.svg\") center center no-repeat;\r\n  mask: url(\"../images/lx-card_arrow.svg\") center center no-repeat;\r\n}\r\n\r\n.journeys {\r\n  padding-top: 32px;\r\n  padding-bottom: 40px;\r\n  position: relative;\r\n  z-index: 2;\r\n  padding-right: 0rem;\r\n  padding-left: 0rem;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .journeys {\r\n    padding-right: 2rem;\r\n    padding-left: 2rem;\r\n  }\r\n}\r\n\r\n\r\n.journeys a {\r\n  margin: 0 1rem;\r\n}\r\n\r\n.journeys a:hover .article-card {\r\n  -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\r\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.journeys a:hover .article-card .start-journey {\r\n  background-color: #00BF00;\r\n}\r\n\r\n.journeys a:hover .article-card .start-journey .start-journey-text .icon-container {\r\n  left: 0;\r\n}\r\n\r\n.journeys a:first-of-type {\r\n  margin-right: 0;\r\n}\r\n\r\n.journeys .swiper-button-prev:after,\r\n.journeys.swiper-rtl .swiper-button-next:after {\r\n  font-size: 0.8rem;\r\n  color: #9d9d9d;\r\n}\r\n\r\n.journeys .swiper-button-next:after,\r\n.journeys.swiper-rtl .swiper-button-prev:after {\r\n  font-size: 0.8rem;\r\n  color: #9d9d9d;\r\n}\r\n\r\n.journeys .swiper-button-next,\r\n.journeys.swiper-rtl .swiper-button-prev {\r\n  right: auto;\r\n  left: 50%;\r\n  margin-left: 5px;\r\n}\r\n\r\n.journeys .swiper-button-prev,\r\n.journeys.swiper-rtl .swiper-button-next {\r\n  left: 50%;\r\n  margin-left: -45px;\r\n  right: auto;\r\n}\r\n\r\n.journeys .swiper-button-next,\r\n.journeys .swiper-button-prev {\r\n  top: auto;\r\n  background: #fff;\r\n  border: 1px solid #00BF00;\r\n  border-radius: 50%;\r\n  height: 40px;\r\n  width: 40px;\r\n  bottom: 0px;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.journeys .swiper-button-next:hover,\r\n.journeys .swiper-button-prev:hover {\r\n  background-color: #00BF00;\r\n}\r\n\r\n.journeys .swiper-button-next:hover::after,\r\n.journeys .swiper-button-prev:hover::after {\r\n  color: #fff;\r\n}\r\n\r\n@media screen and (max-width: 500px) {\r\n  .journeys {\r\n    padding-top: 110px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 330px) {\r\n  .journeys {\r\n    padding-top: 130px;\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n.journey-container {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  width: 100%;\r\n}\r\n\r\n@media screen and (min-width: 1024px) {\r\n  .journey-container {\r\n    -webkit-padding-start: 320px;\r\n    padding-inline-start: 320px;\r\n  }\r\n\r\n  .journey-container .navbar-toggler {\r\n    display: none;\r\n  }\r\n\r\n  .journey-container .offcanvas {\r\n    position: fixed;\r\n    visibility: visible;\r\n    -webkit-transform: none;\r\n    transform: none;\r\n    height: 100vh;\r\n    width: -webkit-fit-content;\r\n    width: -moz-fit-content;\r\n    width: fit-content;\r\n    min-width: 320px;\r\n    max-width: 320px;\r\n  }\r\n\r\n  .journey-container .offcanvas .btn-close {\r\n    display: none;\r\n  }\r\n\r\n}\r\n@media screen and (max-width: 1024px) {\r\n  .banner-img-cont img{\r\n    height: 17.5rem !important;\r\n  }\r\n  .business-journey-cover {\r\n    img {\r\n      max-width: 400px ;\r\n    }\r\n    h1,.welcome-business{\r\n      font-size: 1.5rem;    \r\n    }\r\n\r\n  }\r\n}\r\n.journey-container .offcanvas {\r\n  background-color: #fff !important;\r\n}\r\n\r\n.journey-container .offcanvas-header {\r\n  padding: 0 30px;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  min-height: 115px;\r\n  -webkit-box-pack: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  -webkit-box-align: start;\r\n  -ms-flex-align: start;\r\n  align-items: flex-start;\r\n  -webkit-box-shadow: 0 8px 12px -13px rgba(0, 0, 0, 0.6);\r\n  box-shadow: 0 8px 12px -13px rgba(0, 0, 0, 0.6);\r\n}\r\n\r\n.journey-container .offcanvas-header p {\r\n  color: #9d9d9d;\r\n  font-size: 1rem;\r\n}\r\n\r\n.journey-container .offcanvas-header h3 {\r\n  font-size: 1.2rem;\r\n  color: #00BF00;\r\n  font-weight: bold;\r\n}\r\n\r\n.journey-container .offcanvas-body {\r\n  padding: 20px 30px;\r\n  padding-left: 20px;\r\n}\r\n\r\n.journey-container .offcanvas-body .navbar-nav .nav-item {\r\n  position: relative;\r\n}\r\n\r\n.journey-container .offcanvas-body .navbar-nav .nav-item .nav-link {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  padding: 1rem 0.5rem;\r\n  padding-right: 1rem;\r\n  font-size: 1.2rem;\r\n  position: relative;\r\n  -webkit-transition: all 0.3s ease-in-out;\r\n  transition: all 0.3s ease-in-out;\r\n}\r\n\r\n.journey-container .offcanvas-body .navbar-nav .nav-item .nav-link span {\r\n  display: none;\r\n}\r\n\r\n.journey-container .offcanvas-body .navbar-nav .nav-item .nav-link::before {\r\n  content: \"\";\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 50px;\r\n  background-color: #c3c4c9;\r\n  position: absolute;\r\n  right: -5px;\r\n  top: 50%;\r\n  margin-top: -2px;\r\n  -webkit-transition: all 0.3s ease-in-out;\r\n  transition: all 0.3s ease-in-out;\r\n  z-index: 3;\r\n}\r\n\r\n.journey-container .offcanvas-body .navbar-nav .nav-item .nav-link::after {\r\n  content: \"\";\r\n  width: 2px;\r\n  height: 100%;\r\n  position: absolute;\r\n  bottom: 0;\r\n  right: 0;\r\n  background-color: #c3c4c9;\r\n  z-index: 1;\r\n}\r\n\r\n.journey-container .offcanvas-body .navbar-nav .nav-item .nav-link:hover {\r\n  color: #00BF00;\r\n}\r\n\r\n.journey-container .offcanvas-body .navbar-nav .nav-item .nav-link:hover::before {\r\n  background-color: #00BF00;\r\n}\r\n\r\n.journey-container .offcanvas-body .navbar-nav .nav-item .nav-link.visited {\r\n  color: #00004E;\r\n}\r\n\r\n.journey-container .offcanvas-body .navbar-nav .nav-item .nav-link.visited::before {\r\n  background-color: #00BF00;\r\n}\r\n\r\n.journey-container .offcanvas-body .navbar-nav .nav-item .nav-link.active {\r\n  color: #0064FF;\r\n  background-color: #BFEFBF;\r\n}\r\n\r\n.journey-container .offcanvas-body .navbar-nav .nav-item .nav-link.active span {\r\n  display: inline-block;\r\n  width: 16px;\r\n  height: 16px;\r\n  border-radius: 10px;\r\n  position: absolute;\r\n  background-color: #00BF00;\r\n  top: 50%;\r\n  margin-top: -6px;\r\n  right: -8px;\r\n  z-index: 2;\r\n}\r\n\r\n.journey-container .offcanvas-body .navbar-nav .nav-item .nav-link.active::before {\r\n  background-color: #fff;\r\n  width: 6px;\r\n  height: 6px;\r\n  right: -3px;\r\n  margin-top: -1px;\r\n}\r\n\r\n.journey-container .journey-page-content {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-flex: 1;\r\n  -ms-flex: 1;\r\n  flex: 1;\r\n  width: calc(100% - 320px);\r\n}\r\n\r\n.journey-container .journey-page-content .pageContent {\r\n  width: 100%;\r\n}\r\n\r\n.journey-container .journey-page-content .pageContent .swiper-slide {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.journey-container .journey-page-content .pageContent .swiper-slide .journey-default-container {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n}\r\n\r\n.journey-container .journey-page-content .swiper-button-next,\r\n.journey-container .journey-page-content .swiper-button-prev {\r\n  top: 0;\r\n  background: #fff;\r\n  border: 1px solid #00BF00;\r\n  border-radius: 50%;\r\n  height: 40px;\r\n  width: 40px;\r\n  bottom: 50px;\r\n  top: auto;\r\n  left: 20px;\r\n  right: auto;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  position: fixed;\r\n}\r\n\r\n\r\n.swiper-button-prev:hover {\r\n  border: 1px solid #00BF00 !important;\r\n  color: #00BF00 !important;\r\n}\r\n.journey-container .journey-page-content .swiper-button-next:hover{\r\n  background: #80DF80;\r\n}\r\n\r\n.journey-container .journey-page-content .swiper-button-next:hover::after,\r\n.journey-container .journey-page-content .swiper-button-prev:hover::after {\r\n  color: #00004E;\r\n}\r\n\r\n.journey-container .journey-page-content .swiper-button-prev {\r\n  bottom: 100px;\r\n}\r\n\r\n.journey-container .journey-page-content .swiper-button-next {\r\n  background-color: #00BF00;\r\n}\r\n\r\n.journey-container .journey-page-content .swiper-button-prev:after,\r\n.journey-container .journey-page-content .swiper-button-next:after {\r\n  font-size: 0.8rem;\r\n  color: #00004E;\r\n}\r\n\r\n\r\n\r\n.journey-container .journey-page-content .swiper-button-next:after {\r\n  color: #00004E;\r\n}\r\n\r\n.journey-container .journey-page-content .backHome {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  position: fixed;\r\n  width: 44px;\r\n  height: 44px;\r\n  color: #1e1d1d;\r\n  background: #f4f6f8;\r\n  text-align: center;\r\n  font-size: 22px;\r\n  border-radius: 50%;\r\n  -webkit-box-pack: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  left: 20px;\r\n  top: 30px;\r\n  z-index: 1021;\r\n  border: 1px solid #333371;\r\n}\r\n\r\n.journey-container .journey-page-content .backHome .home-mask {\r\n  position: absolute;\r\n  background: #00004E;\r\n  width: 100%;\r\n  height: 100%;\r\n  border-radius: 50%;\r\n  top: 0;\r\n  left: 0;\r\n  -webkit-mask: url(\"../images/back-to-home.svg\") center center no-repeat;\r\n  background: url(\"../images/back-to-home.svg\") center center no-repeat;\r\n  -webkit-transition: all 0.2s ease-in-out;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.journey-container .journey-page-content .backHome:hover .home-mask {\r\n  background-color: #334157;\r\n}\r\n\r\n@media screen and (max-width: 992px) {\r\n  .journey-container .journey-page-content .backHome {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.journey-container .journey-page-content header {\r\n  -webkit-padding-start: 20px;\r\n  padding-inline-start: 20px;\r\n  -webkit-padding-end: 70px;\r\n  padding-inline-end: 70px;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.journey-container .journey-page-content header h3 {\r\n  font-size: 1.8rem;\r\n  color: #00004E;\r\n  padding: 22px 0 7px;\r\n  font-weight: bold;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.journey-container .journey-page-content header h3 .done-icon {\r\n  max-width: 35px;\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .journey-container .journey-page-content header {\r\n    padding-top: 65px;\r\n  }\r\n  .article-card{\r\n    height: 28.505625rem;\r\n  }\r\n  /* .businessjourney4{\r\n    height: 15rem !important;\r\n  } */\r\n\r\n}\r\n@media screen and (max-width: 991px) and (min-width: 426) {\r\n  .article-card{\r\n    border: 1px solid #FF0020\r\n  }  \r\n}\r\n.journey-cover.businessJourneyCover {\r\n  background: none !important;\r\n  .newsletter-business{\r\n    /* -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\r\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\r\n    border-radius: 20px;\r\n    background-color: white;\r\n    padding: 3rem 2rem 2rem; */\r\n\r\n        padding: 80px;\r\n        background-color: #fff;\r\n        border-radius: 10px;\r\n        padding: 80px;\r\n        max-width: 55%;\r\n        width: 45%;        \r\n        display: -webkit-inline-box;\r\n        display: -ms-inline-flexbox;\r\n        display: inline-flex;\r\n        -webkit-box-orient: vertical;\r\n        -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n        flex-direction: column;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        align-items: center;\r\n        -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\r\n        box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\r\n    a{\r\n      img{\r\n        width: 100px;\r\n        max-width: 100px;\r\n        -webkit-box-shadow: none;\r\n        box-shadow: none;\r\n        border-radius: unset;\r\n        background-color: unset;\r\n      }\r\n    }\r\n  }\r\n}\r\n.journey-cover {\r\n  background: url(\"../images/patternBG.svg\") no-repeat center center;\r\n  background-size: cover;\r\n  width: 100%;\r\n  min-height: 100vh;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  text-align: center;\r\n}\r\n\r\n.journey-cover img {\r\n  max-width: 200px;\r\n  -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\r\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\r\n  border-radius: 20px;\r\n  background-color: white;\r\n}\r\n\r\n.journey-cover h1 {\r\n  font-size: 1.5rem;\r\n  font-weight: bold;\r\n  color: #00004E;\r\n  margin-top: 2rem;\r\n  margin-bottom: 1rem;\r\n  line-height: 1.5;\r\n  padding-inline-start: 65px;\r\n  padding-inline-end: 65px;\r\n}\r\n.journey-cover h1.welcomebusiness {\r\n  font-size: 1.5rem;\r\n  font-weight: bold;\r\n  color: #00004E;\r\n  margin-top: 2rem;\r\n  margin-bottom: 1rem;\r\n  line-height: 1.5;\r\n  padding-inline-start: 65px;\r\n  padding-inline-end: 65px;\r\n}\r\n.journey-cover p {\r\n  color: #fff;\r\n}\r\n\r\n.business-journey-cover {\r\n  width: 100%;\r\n  min-height: 100vh;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  text-align: center;\r\n}\r\n.business-journey-cover h1 {\r\n  font-size: 1.8rem;\r\n  font-weight: bold;\r\n  color: #00004E;\r\n  /* margin-top: 2rem; */\r\n  margin-bottom: 1rem;\r\n  line-height: 1.5;\r\n  padding-inline-start: 65px;\r\n  padding-inline-end: 65px;\r\n}\r\n.business-journey-cover h1.welcome-business {\r\n  font-size: 1.7rem;\r\n  font-weight: bold;\r\n  color: #00004E;\r\n  margin-top: 2rem;\r\n  line-height: 1.5;\r\n  padding-inline-start: 65px;\r\n  padding-inline-end: 65px;\r\n}\r\n\r\n.calc-btn:disabled{\r\n  background-color: #E5E7EA !important;\r\n  border-radius: 0.5rem !important;\r\n  stroke: #808896 !important;\r\n  color: #808896 !important;\r\n  font-weight: 700 !important;\r\n  font-size: 1rem !important;\r\n  width: 100% !important;\r\n  min-width: 100% !important;\r\n\r\n}\r\n\r\n.calc-btn{\r\n  background-color: #00BF00 !important;\r\n  border-radius: 0.5rem !important;\r\n  stroke: #00004E !important;\r\n  color: #00004E !important;\r\n  font-weight: 600 !important;\r\n  font-size: 1rem !important;\r\n  width: 40% !important;\r\n  /* min-width: 100% !important; */\r\n\r\n  display: flex !important;\r\n  flex-direction: column !important;\r\n  justify-content: center !important;\r\n  height: 100% !important ;\r\n  margin: 0 !important;\r\n}\r\n\r\n.calc-btn:hover{\r\n  background-color: #80DF80 !important;\r\n}\r\n.calc-btn:focus{\r\n  background-color: #BFEFBF !important;\r\n}\r\n\r\n.hint {\r\n  padding: 0.2rem;\r\n  color: #303030;\r\n  -webkit-padding-end: 30px;\r\n  padding-inline-end: 30px;\r\n  background: rgba(254, 208, 47, 0.0509803922);\r\n  border: 1px solid #00BF00;\r\n  border-radius: 50px;\r\n  line-height: 31px;\r\n  display: -webkit-inline-box;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  -webkit-box-orient: horizontal;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: row;\r\n  flex-direction: row;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  font-size: 0.85rem;\r\n  font-weight: bold;\r\n}\r\n\r\n.hint .hint-ico {\r\n  width: 40px;\r\n  height: 34px;\r\n  display: -webkit-inline-box;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  -webkit-box-pack: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n}\r\n\r\n.hint .hint-ico img {\r\n  width: 24px;\r\n}\r\n\r\n.inner-page-content {\r\n  -webkit-padding-start: 20px;\r\n  padding-inline-start: 20px;\r\n  -webkit-padding-end: 70px;\r\n  padding-inline-end: 70px;\r\n  padding-bottom: 70px;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-flex: 1;\r\n  -ms-flex: 1;\r\n  flex: 1;\r\n  min-height: calc(100vh - 140px);\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n.icon-card {\r\n  text-align: center;\r\n  padding: 130px 25px 30px;\r\n  max-width: 370px;\r\n  width: 100%;\r\n  margin: 0 auto;\r\n  position: relative;\r\n  min-height: 250px;\r\n  cursor: pointer;\r\n  -webkit-transition: 0.3s ease-in-out;\r\n  transition: 0.3s ease-in-out;\r\n}\r\n\r\n.icon-card .image {\r\n  margin: auto auto 20px;\r\n  width: 80px;\r\n  height: 80px;\r\n  border: 2.375px solid #E5E7EA;\r\n  -webkit-transition: 0.5s ease-in-out;\r\n  transition: 0.5s ease-in-out;\r\n  position: absolute;\r\n  top: 70px;\r\n  inset-inline-start: 50%;\r\n  -webkit-transform: translate(50%, -50%);\r\n  transform: translate(50%, -50%);\r\n  border-radius: 50%;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  -webkit-box-pack: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  padding: 13px;\r\n}\r\n\r\n.icon-card .image img {\r\n  max-width: 100%;\r\n  max-height: 80px;\r\n}\r\n\r\n.icon-card h1 {\r\n  font-weight: bold;\r\n  font-size: 1.5rem;\r\n  margin-top: 0;\r\n  margin-bottom: 30px;\r\n  -webkit-transition: 0.3s ease-in-out;\r\n  transition: 0.3s ease-in-out;\r\n  -webkit-box-pack: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n}\r\n\r\n.icon-card .desc {\r\n  display: none;\r\n  opacity: 0;\r\n  padding: 0;\r\n  font-size: 1.2rem;\r\n  line-height: 1.5;\r\n  -webkit-transition: 0.3s ease-in-out;\r\n  transition: 0.3s ease-in-out;\r\n  -webkit-transform: translate3d(0, 10%, 0);\r\n  transform: translate3d(0, 10%, 0);\r\n  overflow: hidden;\r\n}\r\n\r\n.icon-card .desc a {\r\n  color: #fff;\r\n  text-decoration: none;\r\n  -webkit-transition: all 0.3s ease-in-out;\r\n  transition: all 0.3s ease-in-out;\r\n  position: relative;\r\n  padding-bottom: 5px;\r\n}\r\n\r\n.icon-card .desc a::after {\r\n  content: \"\";\r\n  width: 100%;\r\n  height: 2px;\r\n  background-color: #fff;\r\n  position: absolute;\r\n  bottom: 4px;\r\n  right: 0;\r\n  -webkit-transition: all 0.3s ease-in-out;\r\n  transition: all 0.3s ease-in-out;\r\n  display: inline-block;\r\n}\r\n\r\n.icon-card .desc a:hover {\r\n  color: #00BF00;\r\n  text-decoration: none;\r\n}\r\n\r\n.icon-card .desc a:hover::after {\r\n  background-color: #00BF00;\r\n}\r\n\r\n.icon-card .desc a:focus {\r\n  color: #00BF00;\r\n  text-decoration: underline;\r\n}\r\n\r\n.icon-card .desc a:focus::after {\r\n  background-color: #00BF00;\r\n}\r\n\r\n.icon-card .tips {\r\n  color: #808896;\r\n  height: auto;\r\n  font-size: 0.9rem;\r\n  display: -webkit-inline-box;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.icon-card .tips .hand {\r\n  -webkit-transform: rotate(-25deg);\r\n  transform: rotate(-25deg);\r\n  -webkit-margin-end: 5px;\r\n  margin-inline-end: 5px;\r\n}\r\n\r\n.icon-card .flip-card {\r\n  background-color: rgba(0, 0, 0, 0);\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  -webkit-perspective: 1000px;\r\n  perspective: 1000px;\r\n  z-index: -1;\r\n}\r\n\r\n.icon-card .flip-card .flip-card-inner {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  text-align: center;\r\n  -webkit-transition: -webkit-transform 0.6s;\r\n  transition: -webkit-transform 0.6s;\r\n  transition: transform 0.6s;\r\n  transition: transform 0.6s, -webkit-transform 0.6s;\r\n  -webkit-transform-style: preserve-3d;\r\n  transform-style: preserve-3d;\r\n}\r\n\r\n.icon-card .flip-card .flip-card-inner .flip-card-front,\r\n.icon-card .flip-card .flip-card-inner .flip-card-back {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  -webkit-backface-visibility: hidden;\r\n  backface-visibility: hidden;\r\n  border-radius: 12px;\r\n}\r\n\r\n.icon-card .flip-card .flip-card-inner .flip-card-front {\r\n  background-color: #F3F4F5;\r\n  color: #000;\r\n}\r\n\r\n.icon-card .flip-card .flip-card-inner .flip-card-back {\r\n  background-color: #00004E;\r\n  color: #fff;\r\n  -webkit-transform: rotateY(180deg);\r\n  transform: rotateY(180deg);\r\n}\r\n\r\n.icon-card[data-status=\"clicked\"] {\r\n  min-height: 340px;\r\n  max-width: 370px;\r\n  width: 100%;\r\n  padding: 60px 25px 65px;\r\n}\r\n\r\n.icon-card[data-status=\"clicked\"] .image {\r\n  top: 0;\r\n  width: 80px;\r\n  height: 80px;\r\n  border-color: #00004E;\r\n  background: #fff;\r\n  -webkit-transform: translate(50%, -50%);\r\n  transform: translate(50%, -50%);\r\n}\r\n\r\n.icon-card[data-status=\"clicked\"] h1 {\r\n  margin-top: 0;\r\n  margin-bottom: 0px;\r\n  color: #fff;\r\n}\r\n\r\n.icon-card[data-status=\"clicked\"] .desc {\r\n  color: #fff;\r\n  display: block;\r\n  -webkit-animation: fadeUp 0.2s ease-in;\r\n  animation: fadeUp 0.2s ease-in;\r\n  -webkit-animation-delay: 0.4s;\r\n  animation-delay: 0.4s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.icon-card[data-status=\"clicked\"] .tips {\r\n  display: none;\r\n}\r\n\r\n.icon-card[data-status=\"clicked\"] .flip-card-inner {\r\n  -webkit-transform: rotateY(180deg);\r\n  transform: rotateY(180deg);\r\n}\r\n\r\n@-webkit-keyframes fadeUp {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes fadeUp {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.stepsSliders {\r\n  width: 100%;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  -webkit-box-pack: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  overflow: hidden;\r\n}\r\n\r\n.steps-heading {\r\n  font-size: 1rem;\r\n  color: #E5E7EA;\r\n  position: relative;\r\n  padding-bottom: 80px;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  height: calc(3.6rem + 80px);\r\n  cursor: pointer;\r\n  text-align: center;\r\n}\r\n\r\n.steps-heading::before {\r\n  content: \"\";\r\n  width: calc(100% - 14px);\r\n  height: 6px;\r\n  background: rgba(0, 155, 135, 0.5);\r\n  position: absolute;\r\n  bottom: 50px;\r\n  inset-inline-start: calc(50% + 14px);\r\n  opacity: 0.2;\r\n}\r\n\r\n.steps-heading::after {\r\n  content: \"\";\r\n  width: 28px;\r\n  height: 28px;\r\n  border-radius: 50%;\r\n  background: #fff;\r\n  border: 1px solid #d4d4d4;\r\n  position: absolute;\r\n  bottom: 40px;\r\n  left: 50%;\r\n  -webkit-transform: translate(-50%);\r\n  transform: translate(-50%);\r\n}\r\n\r\n.steps-heading .arrow {\r\n  position: absolute;\r\n  width: 0;\r\n  height: 0;\r\n  border: 25px solid rgba(0, 0, 0, 0);\r\n  border-bottom-color: #00BF00;\r\n  left: 50%;\r\n  bottom: 10px;\r\n  -webkit-transform: translate(-50%, 10px);\r\n  transform: translate(-50%, 10px);\r\n  opacity: 0;\r\n  z-index: -1;\r\n  display: none;\r\n}\r\n\r\n.swiper-slide-thumb-active .steps-heading {\r\n  color: #00BF00;\r\n}\r\n\r\n.swiper-slide-thumb-active .steps-heading::after {\r\n  background: #00BF00;\r\n  border-color: #00BF00;\r\n  opacity: 1 !important;\r\n}\r\n\r\n.swiper-slide-thumb-active .steps-heading .arrow {\r\n  -webkit-animation: fadeUp 0.2s ease-in;\r\n  animation: fadeUp 0.2s ease-in;\r\n  -webkit-animation-delay: 0.4s;\r\n  animation-delay: 0.4s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.swiper-steps-card {\r\n  background: #00004E;\r\n  border-radius: 16px;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  padding: 38px;\r\n  height: 100%;\r\n  position: relative;\r\n  color: #fff;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.swiper-steps .swiper-slide {\r\n  height: 100%;\r\n}\r\n\r\n.swiper-steps .swiper-slide-active {\r\n  width: 90% !important;\r\n}\r\n\r\n.accordion {\r\n  width: 100%;\r\n}\r\n\r\n.accordion .accordion-button {\r\n  font-size: 1.2rem;\r\n  font-weight: bold;\r\n  color: #333371;\r\n  -webkit-transition: all 0.3s ease-in-out;\r\n  transition: all 0.3s ease-in-out;\r\n}\r\n\r\n.accordion .accordion-button:hover {\r\n  background-color: rgba(157, 157, 157, 0.1);\r\n}\r\n\r\n.accordion .accordion-body {\r\n  font-size: 1.2rem;\r\n  color: #00004E;\r\n}\r\n\r\n.accordion .accordion-button:not(.collapsed) {\r\n  color: #00BF00;\r\n  background-color: #BFEFBF;\r\n  -webkit-box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 #00BF00;\r\n  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 #00BF00;\r\n}\r\n\r\n.accordion.businessJourney  .accordion-body {\r\n  background: #F3F4F5;\r\n  padding: 1rem 2rem;\r\n}\r\n\r\n.accordion.businessJourney .accordion-button.businessJourney:not(.collapsed) {\r\n  color: #00122D;\r\n  padding: 2rem;\r\nbackground-color: #E5E7EA;\r\n  -webkit-box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0\r\n    #BFBFD3;\r\n  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 #F3F4F5;\r\n}\r\n.businessJourney-container{\r\n  background: #fff;\r\n  padding: 2rem;\r\n  border-radius: 2rem;\r\n  width: 100%;\r\n  .businessJourneyTitle{\r\n    padding-bottom:2rem;\r\n  }\r\n}\r\n.accordion .accordion-button:focus {\r\n  border-color: rgba(0, 155, 135, 0.3);\r\n  -webkit-box-shadow: 0 0 0 rgba(0, 0, 0, 0);\r\n  box-shadow: 0 0 0 rgba(0, 0, 0, 0);\r\n}\r\n\r\n.checklist__list {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  width: 100%;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  -webkit-box-pack: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n}\r\n.accordion.businessJourney .accordion-body{\r\n  li{\r\n    padding-bottom: 0.35rem;\r\n  }\r\n  ul{\r\n  padding: 1rem;\r\n  li{\r\n    list-style:disc;\r\n    ol{\r\n      padding: 1rem;\r\n      li{\r\n        list-style:decimal;\r\n      }\r\n    }\r\n  }\r\n  }\r\n}\r\n.eligibility{\r\n  background-image: linear-gradient(#fff 50%,#F5F6F8 50%);\r\n}\r\n.eligibilty-check{\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.background-icon svg{\r\n  width: 10rem;\r\n  height: 14rem;\r\n}\r\n@media screen and (max-width: 1024px) {\r\n  .eligibilty-check{\r\n    justify-content: center;\r\n  }\r\n  .background-icon svg{\r\n    display: none;\r\n  }\r\n}\r\n\r\n.calc-btn-space-text{\r\n  margin-left: 10px;\r\n}\r\n@media screen and (max-width: 992px) {\r\n  .checklist__list {\r\n    -webkit-box-pack: start;\r\n    -ms-flex-pack: start;\r\n    justify-content: flex-start;\r\n  }\r\n  .calc-btn-col{\r\n    flex-direction: column !important;\r\n  }\r\n  .calc-btn-space-text{\r\n    margin-left: 0;\r\n    margin-bottom: 1.5rem;\r\n  }\r\n}\r\n\r\n.checklist__item {\r\n  padding: 10px;\r\n  -webkit-padding-start: 48px;\r\n  padding-inline-start: 48px;\r\n  margin-bottom: 16px;\r\n  min-height: 48px;\r\n  -webkit-transition: 0.2s;\r\n  transition: 0.2s;\r\n  position: relative;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  font-size: 14px;\r\n}\r\n\r\n.checklist__checkbox {\r\n  display: none;\r\n}\r\n\r\n.checklist__label {\r\n  border: 1px dashed #d1d1d1;\r\n  border-radius: 48px;\r\n  width: 100%;\r\n  height: 48px;\r\n  top: 0;\r\n  inset-inline-start: 0;\r\n  display: block;\r\n  position: absolute;\r\n  -webkit-transition: all 0.4s ease-in-out;\r\n  transition: all 0.4s ease-in-out;\r\n  z-index: 11;\r\n  height: 100%;\r\n  cursor: pointer;\r\n}\r\n\r\n.checklist__label::before {\r\n  content: \"\";\r\n  width: 28px;\r\n  height: 28px;\r\n  background: #d1d1d1;\r\n  border-radius: 50%;\r\n  position: absolute;\r\n  inset-inline-start: 10px;\r\n  z-index: 11;\r\n  -webkit-transition: 0.4s;\r\n  transition: 0.4s;\r\n  line-height: 39px;\r\n  text-align: center;\r\n  font-size: 22px;\r\n  top: 50%;\r\n  margin-top: -14px;\r\n}\r\n\r\n.checklist__label .svg {\r\n  position: absolute;\r\n  inset-inline-start: 10px;\r\n  z-index: 111;\r\n  width: 28px;\r\n  height: 28px;\r\n  display: none;\r\n  -webkit-transition: 0.6s ease-in-out;\r\n  transition: 0.6s ease-in-out;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  -webkit-box-pack: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  font-size: 19px;\r\n  color: #00BF00;\r\n  top: 50%;\r\n  margin-top: -14px;\r\n}\r\n\r\n.checklist__item input:checked~.checklist__label {\r\n  border-color: rgba(0, 0, 0, 0);\r\n}\r\n\r\n.checklist__item input:checked~.checklist__label::before {\r\n  background: #fff;\r\n  width: 28px;\r\n  height: 28px;\r\n  inset-inline-start: 10px;\r\n  border-radius: 50%;\r\n  top: 50%;\r\n  margin-top: -14px;\r\n}\r\n\r\n.checklist__item input:checked~.checklist__label .svg {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n}\r\n\r\n.checklist__text {\r\n  padding-right: 0;\r\n  font-size: 1rem;\r\n}\r\n\r\n.checklist__text span {\r\n  opacity: 0;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  position: relative;\r\n  color: #fff;\r\n  z-index: 11;\r\n  display: none;\r\n  line-height: 1.5;\r\n}\r\n\r\n.checklist__text::before {\r\n  content: \"الرجاء الضغط هنا لمزيد من التفاصيل\";\r\n  color: #acacac;\r\n  font-size: 1rem;\r\n}\r\n\r\n.checklist__text::after {\r\n  content: \"\";\r\n  width: 100%;\r\n  height: 100%;\r\n  top: 0;\r\n  inset-inline-start: 0;\r\n  display: block;\r\n  position: absolute;\r\n  -webkit-transition: 0.5s;\r\n  transition: 0.5s;\r\n  z-index: 1;\r\n  border-radius: 30px;\r\n}\r\n\r\n.checklist__item input:checked~.checklist__text span {\r\n  opacity: 1;\r\n  display: inline-block;\r\n}\r\n\r\n.checklist__item input:checked~.checklist__text::before {\r\n  display: none;\r\n}\r\n\r\n.checklist__item input:checked~.checklist__text::after {\r\n  background: #00BF00;\r\n}\r\n\r\n.journey-end {\r\n  font-size: 2.5rem;\r\n  font-weight: bold;\r\n  color: #00BF00;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-wrap: wrap;\r\n  flex-wrap: wrap;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.inner-slide-container {\r\n  width: 100%;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n\r\n@media screen and (max-width: 992px) {\r\n  .inner-slide-container {\r\n    -webkit-box-align: start;\r\n    -ms-flex-align: start;\r\n    align-items: flex-start;\r\n  }\r\n}\r\n\r\n#share-bar.left {\r\n  left: 20px;\r\n}\r\n\r\n.journey-end-new {\r\n  background-color: #fff;\r\n  border-radius: 10px;\r\n  padding: 80px;\r\n  display: -webkit-inline-box;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\r\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.journey-end-new h1 {\r\n  color: #00004E;\r\n}\r\n\r\n.journey-end-new img {\r\n  max-width: 60px;\r\n  margin: 0 0 15px;\r\n}\r\n\r\n.journey-end-new a {\r\n  /* color: #fff;\r\n  padding: 2px 20px 5px;\r\n  background-color: #00BF00;\r\n  border-radius: 40px;\r\n  -webkit-transition: all 0.3s ease-in-out;\r\n  transition: all 0.3s ease-in-out;\r\n  display: inline-block;\r\n  margin-top: 20px;\r\n  font-size: 1rem;\r\n  font-weight: bold; */\r\n  margin-top: 2rem;\r\n}\r\n\r\n/* .journey-end-new a:hover {\r\n  background-color: #00BF00;\r\n} */\r\n\r\n.journey-video-container {\r\n  width: 60%;\r\n  aspect-ratio: 16/9;\r\n}\r\n\r\n@media screen and (max-width: 1024px) {\r\n  .journey-video-container {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.faq-title {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  -webkit-box-align: start;\r\n  -ms-flex-align: start;\r\n  align-items: flex-start;\r\n}\r\n\r\n.faq-title .number {\r\n  font-weight: bold;\r\n  font-size: 4rem;\r\n  color: #00BF00;\r\n  line-height: 1.1;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.faq-title .title h5 {\r\n  font-size: 1.3rem;\r\n  font-weight: bold;\r\n  color: #00BF00;\r\n}\r\n\r\n.faq-selector {\r\n  min-height: 7rem;\r\n  padding: 1rem;\r\n  margin: 1rem;\r\n  display: -webkit-inline-box;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  -webkit-box-pack: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  background-color: #f8f8f8;\r\n  border: 1px solid #efeeee;\r\n  color: #00BF00;\r\n  width: calc(100% - 2rem);\r\n  font-size: 1.1rem;\r\n  font-weight: bold;\r\n  border-radius: 0.4rem;\r\n}\r\n\r\n\r\n@media screen and (max-width: 480px) {\r\n  .faqCount {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.faqCount .faq-title {\r\n  align-items: center;\r\n}\r\n\r\n.faqCount>.faq-title>.number {\r\n  margin-top: 0rem;\r\n  line-height: 2rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n  .faqCount>.faq-title {\r\n    align-items: start;\r\n  }\r\n\r\n  .faqCount>.faq-title>.number {\r\n    margin-top: 1rem;\r\n  }\r\n  .banner-img-cont img {\r\n    height: 24rem;\r\n}\r\n}\r\n.faq-selector:focus {\r\n  background-color: #f8f8f8;\r\n  border: 1px solid #efeeee;\r\n  color: #00BF00;\r\n}\r\n\r\n[dir=\"rtl\"] .slick-prev {\r\n  right: 1rem;\r\n  left: auto;\r\n}\r\n\r\n@media screen and (max-width: 500px) {\r\n  [dir=\"rtl\"] .slick-prev {\r\n    right: 0;\r\n  }\r\n  .banner-img-cont img {\r\n    height: 13rem !important;\r\n}\r\n}\r\n\r\n[dir=\"rtl\"] .slick-prev:before {\r\n  content: \"\";\r\n}\r\n\r\n[dir=\"rtl\"] .slick-next {\r\n  left: 1rem;\r\n  right: auto;\r\n}\r\n\r\n@media screen and (max-width: 500px) {\r\n  [dir=\"rtl\"] .slick-next {\r\n    left: 0;\r\n  }\r\n}\r\n\r\n[dir=\"rtl\"] .slick-next:before {\r\n  content: \"\";\r\n}\r\n\r\n.slick-prev:before,\r\n.slick-next:before {\r\n  font-family: \"Font Awesome 6 Free\";\r\n  font-weight: 900;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  -webkit-font-smoothing: antialiased;\r\n  display: var(--fa-display, inline-block);\r\n  font-style: normal;\r\n  font-variant: normal;\r\n  line-height: 1;\r\n  text-rendering: auto;\r\n  color: #303030;\r\n}\r\n\r\n.faq-slider {\r\n  padding: 0 4rem;\r\n}\r\n\r\n@media screen and (max-width: 500px) {\r\n  .faq-slider {\r\n    padding: 0 1rem;\r\n  }\r\n}\r\n\r\n.faq-q-list {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  width: 100%;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  margin-left: calc(-0.5 * var(--bs-gutter-x));\r\n  margin-right: calc(-0.5 * var(--bs-gutter-x));\r\n}\r\n\r\n.faq-q-list li {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  width: calc(100% - 16px);\r\n  background-color: #fff;\r\n  border: 1px solid #efeeee;\r\n  color: #00BF00;\r\n  -ms-flex-wrap: wrap;\r\n  flex-wrap: wrap;\r\n  padding: 16px;\r\n  margin-left: 16px;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.faq-q-list li .number {\r\n  color: #00BF00;\r\n  font-weight: bold;\r\n  font-size: 2rem;\r\n  font-size: 4rem;\r\n  width: 6%;\r\n  text-align: center;\r\n}\r\n\r\n@media screen and (max-width: 992px) {\r\n  .faq-q-list li .number {\r\n    width: 20%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 480px) {\r\n  .faq-q-list li .number {\r\n    width: 100%;\r\n    text-align: right;\r\n  }\r\n}\r\n\r\n.faq-q-list li h5 {\r\n  -webkit-box-flex: 1;\r\n  -ms-flex-positive: 1;\r\n  flex-grow: 1;\r\n  font-size: 1.2rem;\r\n  width: 70%;\r\n  font-weight: bold;\r\n}\r\n\r\n@media screen and (max-width: 992px) {\r\n  .faq-q-list li h5 {\r\n    width: 56%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 480px) {\r\n  .faq-q-list li h5 {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.faq-q-list li button {\r\n  border: 1px solid #00BF00;\r\n  background-color: #fff;\r\n  color: #00BF00;\r\n  padding: 0.5rem 1rem;\r\n  display: -webkit-inline-box;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  border-radius: 50px;\r\n  min-height: auto;\r\n  width: auto;\r\n  font-size: 0.85rem;\r\n  font-weight: normal;\r\n}\r\n\r\n@media screen and (max-width: 480px) {\r\n  .faq-q-list li button {\r\n    margin-right: 0px;\r\n  }\r\n}\r\n\r\n.topHeaderTitle h1:first-child {\r\n  position: relative;\r\n  z-index: 2;\r\n  color: white;\r\n  padding-top: 1rem;\r\n}\r\n\r\n\r\n.backWebsite {\r\n  position: relative;\r\n  padding-bottom: 0.8rem;\r\n}\r\n\r\n.backWebsite svg {\r\n  margin-bottom: -0.1rem;\r\n}\r\n\r\n.topHeaderTitle {\r\n  width: fit-content;\r\n  /* margin-top: 2rem; */ \r\n  margin-bottom: 5rem;\r\n}\r\n\r\nheader nav a.navbar-brand {\r\n  max-width: 50%;\r\n  padding: 0.5rem 0 0.5rem 0;\r\n}\r\n\r\n.container.homePageFooter div#share {\r\n  /* position: static; */\r\n  order: initial;\r\n}\r\n\r\nfooter .brand-logo {\r\n  margin: 0;\r\n  flex: 0 0 calc(50% - 0.25rem);\r\n}\r\n\r\n@media (min-width: 576px) {\r\n\r\n  .container.homePageFooter div#share {\r\n    order: 2;\r\n  }\r\n\r\n  footer .brand-logo {\r\n    margin-top: 1rem;\r\n  }\r\n\r\n}\r\n\r\n.jssocials-share>a {\r\n  border: 1px solid #00BF00;\r\n}\r\n\r\n\r\n.lineConected.swiper-wrapper .swiper-slide {\r\n  flex: 1;\r\n  margin-left: 0 !important;\r\n}\r\n\r\n.steps-heading::before {\r\n  content: \"\";\r\n  width: 100%;\r\n  height: 6px;\r\n  background: rgba(0, 155, 135, 0.5);\r\n  position: absolute;\r\n  bottom: 50px;\r\n  opacity: 0.2;\r\n  right: 0;\r\n}\r\n\r\n.lineConected.swiper-wrapper .swiper-slide:first-child h1.steps-heading::before {\r\n  width: 50%;\r\n  right: 50%;\r\n}\r\n\r\n.lineConected.swiper-wrapper .swiper-slide:last-child h1.steps-heading::before {\r\n  width: 50%;\r\n}\r\n\r\n\r\n@media screen and (max-width: 992px) {\r\n  .flex-sm-md-column {\r\n    flex-direction: column !important;\r\n  }\r\n  .jur-button-cont {\r\n    top: -5rem;\r\n}\r\n  #business_journey {\r\n    height: 38rem ;\r\n    .business_journey_section{\r\n      height: 29rem;\r\n      .journies-section h1{\r\n        align-items: center;\r\n        font-size: 1.2em !important;\r\n      }\r\n    .popup-card.business-popup-card{\r\n      margin: 3rem 0 0 0;\r\n    .card-thumb {\r\n      width: 300px !important;\r\n      height: 183px !important;\r\n      }\r\n    }\r\n    .article-card .start-journey{\r\n      max-width: 100%;\r\n      width: 70%;\r\n    }\r\n  }\r\n\r\n  .businessjourney4{\r\n    height: 25rem ;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center !important;\r\n    .business-card-top{\r\n      height: 10rem;\r\n      .info-card{\r\n        /* margin: 1rem !important; */\r\n        .info-hint3{\r\n          font-size: 1rem !important;\r\n          text-align: center !important;\r\n        }\r\n        .info-hint2 {\r\n          width: 100% !important;\r\n          font-size: 1.2em !important;\r\n          text-align: center !important;\r\n      }\r\n\r\n      }\r\n      .jur-button-cont{\r\n        display: flex;\r\n        align-items: center;\r\n        right: unset;\r\n        max-width: 100%;\r\n        top: 11rem;\r\n        z-index: 2;\r\n        justify-content: center;\r\n        margin: auto;      \r\n      }\r\n    }\r\n\r\n    .contarineImage{\r\n      position: relative ;\r\n      width: 80%;\r\n      display: block;\r\n      min-height: 8.318125rem;\r\n      margin-bottom: 0;\r\n      img {\r\n        pointer-events: none;\r\n        position: absolute;\r\n        left: 50%;\r\n        transform: translateX(-50%);\r\n        width: 100%;\r\n        pointer-events: none;\r\n        object-fit: contain;\r\n        bottom: -6rem;\r\n      }\r\n    }\r\n  }\r\n  }\r\n}\r\n\r\n\r\n@media screen and (max-height: 33rem) {\r\n  div#share {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media screen and (max-height: 40rem) {\r\n  .modal-fullscreen-sm-down {\r\n    width: 100vw;\r\n    max-width: none;\r\n    height: 100%;\r\n    margin: 0\r\n  }\r\n\r\n  .modal-fullscreen-sm-down .modal-content {\r\n    height: 100%;\r\n    border: 0;\r\n    border-radius: 0\r\n  }\r\n\r\n  .modal-fullscreen-sm-down .modal-footer,\r\n  .modal-fullscreen-sm-down .modal-header {\r\n    border-radius: 0\r\n  }\r\n\r\n  .modal-fullscreen-sm-down .modal-body {\r\n    overflow-y: auto;\r\n    padding: 1rem 3rem;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 576px) {\r\n  .pe-sm-only-0 {\r\n    padding-left: 0 !important;\r\n  }\r\n  .smallest-bp-jur-card{\r\n    padding-bottom: 1rem !important;\r\n  }\r\n}\r\n\r\n.accordion button.accordion-button {\r\n  padding-left: 0.5rem;\r\n  gap: 0.5rem;\r\n}\r\n\r\n\r\n\r\ndiv#pre-load {\r\n  height: 100%;\r\n  width: 100%;\r\n  position: fixed;\r\n  margin-top: 0px;\r\n  top: 0px;\r\n  z-index: 999999;\r\n  background: #000048;\r\n  display: none;\r\n}\r\n\r\n\r\n.loader .loader-container {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  top: 40vh;\r\n  margin: auto;\r\n  width: 8rem;\r\n  height: 8rem;\r\n  /* border: 0.4rem solid #ebebec;\r\n  border-radius: 50%; */\r\n}\r\n\r\n.loader .loader-container:before {\r\n  position: absolute;\r\n  content: \"\";\r\n  display: block;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  /* width: 8rem;\r\n  height: 8rem;\r\n  border-top: 0.4rem solid #008755;\r\n  border-radius: 50%;\r\n  animation: loaderSpin 1.8s infinite ease-in-out;\r\n  -webkit-animation: loaderSpin 1.8s infinite ease-in-out; */\r\n}\r\n\r\n.loader .loader-icon {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  /* width: 6rem; */\r\n  text-align: center;\r\n  margin-top: 0.2rem;\r\n}\r\n\r\n.loader .loader-icon svg {\r\n  animation: loaderPulse alternate 900ms infinite;\r\n  width: 3.5rem;\r\n}\r\n\r\n@keyframes loaderSpin {\r\n  0% {\r\n    transform: translate(-50%, -50%) rotate(0deg);\r\n  }\r\n\r\n  100% {\r\n    transform: translate(-50%, -50%) rotate(360deg);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes loaderSpin {\r\n  0% {\r\n    transform: translate(-50%, -50%) rotate(0deg);\r\n  }\r\n\r\n  100% {\r\n    transform: translate(-50%, -50%) rotate(360deg);\r\n  }\r\n}\r\n\r\n@keyframes loaderPulse {\r\n  0% {\r\n    transform: scale(1);\r\n  }\r\n\r\n  100% {\r\n    transform: scale(1.2);\r\n  }\r\n}\r\n\r\n\r\n.bannerBackground {\r\n  background-image: url('../images/home_banner.jpg');\r\n  background-repeat: no-repeat;\r\n  background-position: bottom left;\r\n  background-size: cover;\r\n  min-height: 208px;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  position: relative;\r\n  width: 100%;\r\n  height: 16rem;\r\n}\r\n.text-cont{\r\n    max-width: 25rem;\r\n    max-height: 12rem;\r\n    width: 25rem;\r\n    height: 12rem;\r\n}\r\n.homeBanner {\r\n  z-index: 1;\r\n}\r\n\r\n.TaminatyMessage {\r\n  background: #0064FF;\r\n  display: block;\r\n  text-align: center;\r\n  padding: 0.5rem;\r\n}\r\n.TaminatyMessage p {\r\n  display: inline-block;\r\n  margin: .5rem;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  color: #fff;\r\n}\r\n.TaminatyMessage a {\r\n  font-weight: 550;\r\n  color: #fff !important;\r\n  background: #00004e;\r\n  border-radius: .5rem;\r\n  padding: .5rem 1rem;\r\n  text-align: center;\r\n  display: inline-block;\r\n  cursor: pointer;\r\n}\r\n@media screen and (max-width: 600px) {\r\n  .TaminatyMessage p {\r\n    display: inline-block;\r\n    width: 60%;\r\n    font-size: .8rem;\r\n    text-align: start;\r\n}\r\n.TaminatyMessage a {\r\n  display: inline-block;\r\n  font-size: .8rem;\r\n  padding: .8rem .3rem;\r\n  width: 6rem;\r\n}\r\nheader nav .navbar-brand .logo-desktop {\r\n  display: none;\r\n}\r\nheader nav .navbar-brand .logo-mobile {\r\n  display: inline-block;\r\n  width: 4rem;\r\n}\r\n.topHeaderTitle{\r\n  width: 100%;\r\n}\r\n\r\n.jur-button-cont {\r\n  top: 0rem;\r\n}\r\n\r\n.business-journey-cover {\r\n  img {\r\n    max-width: 300px !important;\r\n  }\r\n  h1,.welcome-business{\r\n    font-size: 1.5rem !important;\r\n  }\r\n}\r\n}\r\n#business_journey {\r\n  .business_journey_section{\r\n  .popup-card.business-popup-card{\r\n  .card-thumb {\r\n    width: 275px !important;\r\n    height: 183px !important;\r\n    }\r\n  }\r\n}\r\n}\r\n.subbanner-title{\r\n  font-size: 2rem !important;\r\n\r\n}\r\n.subbanner-text{\r\n  font-size: 1.2rem !important;\r\n  color: white;\r\n  width: 20rem;\r\n  margin: 0.5rem 0rem;\r\n}\r\n\r\nsection.homeBanner .container {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-inline-end: 0;\r\n  margin: 0 auto;\r\n  /* margin: 0;\r\n  padding: 0;\r\n  max-width: inherit; */\r\n\r\n}\r\n\r\n/* section.homeBanner .container>div {\r\n  flex: 1;\r\n} */\r\n\r\nimg.backline,\r\nimg.frontline {\r\n  position: absolute;\r\n  width: 60%;\r\n  left: 0;\r\n}\r\n\r\nimg.backline {\r\n  top: 0;\r\n  bottom: auto;\r\n}\r\n\r\nimg.frontline {\r\n  z-index: 10;\r\n  bottom: -50%;\r\n}\r\n\r\nsection.homeBanner {\r\n  position: relative;\r\n  overflow: hidden;\r\n  background: #00004E;\r\n  width: 100%;\r\n}\r\n\r\n@media screen and (max-width: 992px) {\r\n\r\n  /* on mobile */\r\n  .topHeaderTitle{\r\n    margin-bottom: 0rem;\r\n  }\r\n  section.homeBanner .container {\r\n    display: block;\r\n  }\r\n  .bannerBackground {\r\n    background-size: cover;\r\n    height: 20rem;\r\n  }\r\n}\r\n\r\na.btn {\r\n  background-color: #00BF00;\r\n  color: #00004E;\r\n  padding: 0.5rem 1.2rem;\r\n  border-radius: 10px;\r\n  -webkit-transition: all 0.3s ease-in-out;\r\n  transition: all 0.3s ease-in-out;\r\n  margin: 0.5rem 2rem 1rem 2rem;\r\n  /* min-width: 15rem; */\r\n}\r\n\r\na.btn:hover {\r\n  background-color: #80DF80;\r\n  color: #00004E;\r\n}\r\na.btn:focus {\r\n  background-color: #BFEFBF;\r\n  color: #00004E;\r\n}\r\n\r\ni.jssocials-share-logo {\r\n  width: 24px;\r\n  height: 24px;\r\n  display: block;\r\n  background-repeat: no-repeat;\r\n  background-size: contain;\r\n  background-position: center;\r\n}\r\n\r\n.jssocials-share.jssocials-share-email i.jssocials-share-logo {\r\n  background-image: url(../images/envelope-regular.svg);\r\n}\r\n\r\n.jssocials-share.jssocials-share-twitter i.jssocials-share-logo {\r\n  background-image: url(../images/x-twitter.svg);\r\n}\r\n\r\n.jssocials-share.jssocials-share-facebook i.jssocials-share-logo {\r\n  background-image: url(../images/facebook.svg);\r\n}\r\n\r\n.jssocials-share.jssocials-share-linkedin i.jssocials-share-logo {\r\n  background-image: url(../images/linkedin-in.svg);\r\n}\r\n\r\n.jssocials-share.jssocials-share-whatsapp i.jssocials-share-logo {\r\n  background-image: url(../images/whatsapp.svg);\r\n}\r\nsvg:not(:host).svg-inline--fa,\r\nsvg:not(:root).svg-inline--fa {\r\n  overflow: visible;\r\n  box-sizing: content-box;\r\n}\r\n\r\n.svg-inline--fa {\r\n  display: var(--fa-display, inline-block);\r\n  height: 1em;\r\n  overflow: visible;\r\n  vertical-align: -0.125em;\r\n}\r\n\r\n.popup-card .card-thumb:hover {\r\n  border: 2px solid #00BF00;\r\n}\r\n\r\n.popup-card .card-thumb:hover img {\r\n  filter: grayscale(1);\r\n}\r\n\r\nspan.journeyStart {\r\n  margin-top: 0;\r\n  font-weight: 500;\r\n  line-height: 1.2;\r\n  color: var(--bs-heading-color);\r\n  font-size: 1.25em;\r\n  margin-bottom: 0.1rem;\r\n  width: 100%;\r\n    text-align: center;\r\n}\r\n\r\nbutton.slick-arrow.slick-prev::before,\r\nbutton.slick-arrow.slick-next::before {\r\n  font-family: swiper-icons;\r\n  font-size: 1.2rem;\r\n  text-transform: none !important;\r\n  letter-spacing: 0;\r\n  font-variant: initial;\r\n  line-height: 1;\r\n}\r\n\r\nbutton.slick-arrow.slick-prev::before {\r\n  content: 'next' !important;\r\n}\r\n\r\nbutton.slick-arrow.slick-next::before {\r\n  content: 'prev' !important;\r\n}\r\n\r\nbutton.slick-arrow {\r\n  z-index: 10;\r\n}\r\n\r\n.checklist__list-description {\r\n  padding: 1rem;\r\n  font-size: 1rem;\r\n}\r\n\r\n.table {\r\n  font-size: 1rem;\r\n}\r\n\r\n.new-card {\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: #f5f5f5;\r\n  border-radius: 12px;\r\n  padding: 1rem;\r\n  padding-top: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.new-card h5 {\r\n  width: 100%;\r\n  font-weight: bold;\r\n  font-size: 1.2rem;\r\n  text-align: center;\r\n  color: #0e4e41;\r\n  margin-top: 1rem;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.new-card p {\r\n  width: 100%;\r\n  font-size: 1rem;\r\n  text-align: center;\r\n}\r\n\r\n.custom-description {\r\n  font-size: 1.2rem;\r\n  margin-bottom: 1rem;\r\n  color: #333371;\r\n}\r\n\r\n\r\n\r\n/* this is for social animation */\r\n.jssocials-shares,\r\n.jssocials-shares:before,\r\n.jssocials-shares:after,\r\n.jssocials-share {\r\n  height: calc(1.2em + 24px);\r\n  width: calc(1.2em + 24px);\r\n  border-radius: 50%;\r\n  position: absolute;\r\n  cursor: pointer;\r\n}\r\n\r\n.jssocials-shares {\r\n  position: relative;\r\n}\r\n\r\n.jssocials-shares:before,\r\n.jssocials-shares:after {\r\n  content: '';\r\n  will-change: transform;\r\n}\r\n\r\n.jssocials-shares:before {\r\n  background: url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gVXBsb2FkZWQgdG86IFNWRyBSZXBvLCB3d3cuc3ZncmVwby5jb20sIEdlbmVyYXRvcjogU1ZHIFJlcG8gTWl4ZXIgVG9vbHMgLS0+CjxzdmcgZmlsbD0iIzAwMDAwMCIgd2lkdGg9IjgwMHB4IiBoZWlnaHQ9IjgwMHB4IiB2aWV3Qm94PSIwIDAgMzIgMzIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjx0aXRsZT5zaGFyZS1ub2RlczwvdGl0bGU+DQo8cGF0aCBkPSJNMjYgMjEuMjVjLTEuNTgxIDAuMDAzLTIuOTgxIDAuNzgxLTMuODM5IDEuOTc0bC0wLjAxMCAwLjAxNC0xMS42NDItNS44MjFjMC4xNTItMC40MjIgMC4yNC0wLjkwOSAwLjI0LTEuNDE3cy0wLjA4OC0wLjk5NS0wLjI0OS0xLjQ0N2wwLjAwOSAwLjAzMCAxMS42NDItNS44MmMwLjg3IDEuMTkgMi4yNjEgMS45NTMgMy44MzEgMS45NTMgMi42MTQgMCA0LjczMy0yLjExOSA0LjczMy00LjczM3MtMi4xMTktNC43MzMtNC43MzMtNC43MzNjLTIuNjE0IDAtNC43MzMgMi4xMTktNC43MzMgNC43MzMgMCAwLjAwNiAwIDAuMDEyIDAgMC4wMTh2LTAuMDAxYzAuMDA3IDAuNTA5IDAuMDk1IDAuOTk1IDAuMjUgMS40NDlsLTAuMDEwLTAuMDMzLTExLjY0MiA1LjgyMWMtMC44NzItMS4yMDktMi4yNzctMS45ODctMy44NjQtMS45ODctMi42MjMgMC00Ljc1IDIuMTI3LTQuNzUgNC43NXMyLjEyNyA0Ljc1IDQuNzUgNC43NWMxLjU4NyAwIDIuOTkyLTAuNzc4IDMuODU1LTEuOTc0bDAuMDEwLTAuMDE0IDExLjY0MiA1LjgyMWMtMC4xNDYgMC40MjItMC4yMzMgMC45MDgtMC4yNCAxLjQxNGwtMCAwLjAwM2MwIDIuNjIzIDIuMTI3IDQuNzUgNC43NSA0Ljc1czQuNzUtMi4xMjcgNC43NS00Ljc1YzAtMi42MjMtMi4xMjctNC43NS00Ljc1LTQuNzV2MHpNMjYgMi43NWMxLjc5NSAwIDMuMjUgMS40NTUgMy4yNSAzLjI1cy0xLjQ1NSAzLjI1LTMuMjUgMy4yNWMtMS43OTUgMC0zLjI1LTEuNDU1LTMuMjUtMy4yNXYwYzAuMDAyLTEuNzk0IDEuNDU2LTMuMjQ4IDMuMjUtMy4yNWgwek02IDE5LjI1Yy0xLjc5NSAwLTMuMjUtMS40NTUtMy4yNS0zLjI1czEuNDU1LTMuMjUgMy4yNS0zLjI1YzEuNzk1IDAgMy4yNSAxLjQ1NSAzLjI1IDMuMjV2MGMtMC4wMDIgMS43OTQtMS40NTYgMy4yNDgtMy4yNSAzLjI1aC0wek0yNiAyOS4yNWMtMS43OTUgMC0zLjI1LTEuNDU1LTMuMjUtMy4yNXMxLjQ1NS0zLjI1IDMuMjUtMy4yNWMxLjc5NSAwIDMuMjUgMS40NTUgMy4yNSAzLjI1djBjLTAuMDAxIDEuNzk0LTEuNDU2IDMuMjQ5LTMuMjUgMy4yNWgtMHoiPjwvcGF0aD4NCjwvc3ZnPg==\") center/18px no-repeat;\r\n  z-index: 5;\r\n  transition: 0.3s;\r\n}\r\n\r\n.jssocials-shares:after {\r\n  background: #f4f6f8;\r\n  /* box-shadow: 0 2px 5px rgba(0, 0, 0, .3); */\r\n  z-index: -1;\r\n  transition: 0.39s;\r\n  border: 1px solid #333371;\r\n}\r\n\r\n.jssocials-shares:hover{\r\n  border: 1px solid #00BF00;\r\n}\r\n\r\n.jssocials-shares.active:before {\r\n  background: url(\"data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27><path d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/></svg>\") center/14px no-repeat;\r\n  transform: rotate(90deg);\r\n}\r\n\r\n.jssocials-share {\r\n  transition: 0.3s;\r\n  animation: 0.3s down forwards;\r\n  opacity: 0;\r\n  will-change: animation;\r\n}\r\n\r\n.jssocials-share:nth-child(1) {\r\n  background: transparent;\r\n  top: calc((-100% + -0.5rem) * 4);\r\n}\r\n\r\n.jssocials-share:nth-child(2) {\r\n  background: transparent;\r\n  top: calc((-100% + -0.5rem) * 3);\r\n}\r\n\r\n.jssocials-share:nth-child(3) {\r\n  top: calc((-100% + -0.5rem) * 2);\r\n  background: transparent;\r\n}\r\n\r\n.jssocials-share:nth-child(4) {\r\n  top: calc((-100% + -0.5rem) * 1);\r\n  background: transparent;\r\n}\r\n\r\n.jssocials-share:nth-child(5) {\r\n  background: transparent;\r\n}\r\n\r\n.jssocials-share.active {\r\n  animation-duration: 0.48s;\r\n  animation-timing-function: ease;\r\n  animation-delay: 0s;\r\n  animation-iteration-count: 1;\r\n  animation-direction: normal;\r\n  animation-fill-mode: forwards;\r\n  animation-play-state: running;\r\n  animation-name: up;\r\n  animation-timeline: auto;\r\n  animation-range-start: normal;\r\n\r\n}\r\n\r\n.jssocials-share.active:nth-child(1) {\r\n  animation-delay: 0.8s;\r\n}\r\n\r\n.jssocials-share.active:nth-child(2) {\r\n  animation-delay: 0.6s;\r\n}\r\n\r\n.jssocials-share.active:nth-child(3) {\r\n  animation-delay: 0.4s;\r\n}\r\n\r\n.jssocials-share.active:nth-child(4) {\r\n  animation-delay: 0.2s;\r\n}\r\n\r\n.jssocials-share.active:nth-child(5) {\r\n  animation-delay: 0s;\r\n}\r\n\r\n.jssocials-share.no {\r\n  animation: none;\r\n}\r\n\r\n@keyframes up {\r\n  50% {\r\n    transform: translateY(-170%);\r\n  }\r\n\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateY(-130%);\r\n  }\r\n}\r\n\r\n@keyframes down {\r\n  0% {\r\n    opacity: 1;\r\n    transform: translateY(-130%);\r\n  }\r\n\r\n  100% {\r\n    opacity: 0;\r\n    transform: translateY(0);\r\n    top: 0;\r\n  }\r\n}\r\n\r\na.jssocials-share-link {\r\n  padding: 0.6em;\r\n}\r\n\r\ndiv:where(.swal2-container) .otpContainer {\r\n  display: flex;\r\n  overflow: hidden;\r\n  direction:ltr;\r\n}\r\n\r\ndiv:where(.swal2-container) .otpContainer .swal2-input{\r\n  margin: 0.5rem;\r\n  width: calc(25% + 3rem);\r\n  text-align: center;\r\n}\r\n\r\n.input-field input {\r\n  border: 2px solid #808896;\r\n  outline: none;\r\n  height: 3rem;\r\n  width: 100%;\r\n  font-size: 16px;\r\n  margin: 0 0 8px;\r\n  padding: 0;\r\n  box-shadow: none;\r\n  padding-left: 10px;\r\n  border-style: solid;\r\n  border-width: 1px;\r\n  border-color: #eaeaea;\r\n  border-radius: 1rem !important;\r\n  background-color: #fcfcfc;\r\n  padding-right: 10px;\r\n  box-sizing: border-box;\r\n  font-weight: 400;\r\n  font-family: Ping AR + LT!important;\r\n  color: #00004E;\r\n}\r\n\r\n.input-field input:focus {\r\n  border: 3px solid #00BF00 ;\r\n  box-shadow: 0px 0px 3px 0px #44C875;\r\n}\r\n\r\n.input-field label {\r\n  font-size: 1rem;\r\n  cursor: text;\r\n  transition: transform .2s ease-out,color .2s ease-out;\r\n  transform-origin: 0% 100%;\r\n  right: 1rem!important;\r\n  top: -5px;\r\n  color: #00BF00;\r\n  font-weight: 500;\r\n  left: auto;\r\n  position: relative;\r\n  display: block;\r\n  text-align: right;\r\n  transform: none!important;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.input-field label span.mandatoryField {\r\n  display: inline-block;\r\n  color: #ff5858;\r\n  font-size: 1.4rem;\r\n  position: absolute;\r\n  right: -1rem;\r\n  top: 1px;\r\n  font-family: initial;\r\n}\r\n\r\ndiv:where(.swal2-container) h2:where(.swal2-title) {\r\n  font-size: 1.3rem !important;\r\n}\r\n\r\nbutton.swal2-confirm.btn.swal2-styled {\r\n  background-color: #00BF00;\r\n  color: #fff;\r\n  padding: 0.5rem 1.2rem;\r\n  border-radius: 50px;\r\n  -webkit-transition: all 0.3s ease-in-out;\r\n  transition: all 0.3s ease-in-out;\r\n}\r\n\r\nbutton.swal2-confirm.btn.swal2-styled:hover {\r\n  background-color: #00BF00;\r\n}\r\n\r\nbutton.btn {\r\n  background-color: #00BF00;\r\n  color: #00004E;\r\n  padding: 0.5rem 3rem;\r\n  border-radius: 10px;\r\n  -webkit-transition: all 0.3s ease-in-out;\r\n  transition: all 0.3s ease-in-out;\r\n}\r\n\r\nbutton.btn:hover {\r\n  background-color: #80DF80;\r\n  color: #00004E;\r\n}\r\n\r\nbutton.btn:focus {\r\n  background-color: #BFEFBF;\r\n  color: #00004E;\r\n}\r\n\r\nbutton.swal2-cancel.btn.swal2-styled {\r\n  background-color: #00BF00;\r\n  color: #fff;\r\n  padding: 0.5rem 1.2rem;\r\n  border-radius: 50px;\r\n  -webkit-transition: all 0.3s ease-in-out;\r\n  transition: all 0.3s ease-in-out;\r\n}\r\n\r\nbutton.swal2-cancel.btn.swal2-styled:hover {\r\n  background-color: #025f52;\r\n}\r\n\r\nbutton.btn.swal2-styled[disabled] {\r\n  opacity: .4;\r\n}\r\n\r\nsvg.otpIcon {\r\n  width: 80%;\r\n  height: 80%;\r\n  margin-left: 15px;\r\n}\r\nsvg.otpIcon path, svg.otpIcon circle{\r\n  fill: #00BF00\r\n}\r\n\r\ninput.swal2-input.customFocus:focus {\r\n  border: none;\r\n  outline: none;\r\n  box-shadow: none;\r\n  border-style: solid;\r\n  border-width: 1px;\r\n  border-color: #eaeaea;\r\n  border-style: solid;\r\n  border-width: 1px;\r\n  border-color: #eaeaea;\r\n}\r\n\r\ndiv#calculateRetirementResult .title {\r\n  width: 100%;\r\n  font-weight: bold;\r\n  font-size: 1.2rem;\r\n  text-align: center;\r\n  color: #0e4e41;\r\n  margin-top: 1rem;\r\n  margin-bottom: 0.5rem;\r\n  line-height: 1.2;\r\n}\r\n\r\ndiv:where(.swal2-container) button:where(.swal2-styled).swal2-cancel:focus {\r\n  box-shadow: none !important;\r\n}\r\n\r\ndiv.input-field select {\r\n  box-shadow: none;\r\n  transition: box-shadow .3s,border .3s;\r\n  position: relative;\r\n  cursor: pointer;\r\n  border: 2px solid #808896;\r\n  outline: none;\r\n  height: 3rem;\r\n  line-height: 3rem;\r\n  width: 100%;\r\n  font-size: 16px;\r\n  margin: 0 0 8px;\r\n  padding: 0;\r\n  display: block;\r\n  user-select: none;\r\n  z-index: 1;\r\n  padding-left: 10px;\r\n  border-style: solid;\r\n  border-width: 1px;\r\n  border-color: #eaeaea;\r\n  border-radius: 8px;\r\n  background-color: white;\r\n  padding-right: 10px;\r\n  box-sizing: border-box;\r\n  font-weight: 400;\r\n  font-family: Ping AR + LT!important;\r\n  color: #00004E;\r\n}\r\n\r\np#validationMsg {\r\n   color: #ff5858;\r\n}\r\np#UIDValidationMsg {\r\n  color: #ff5858;\r\n  height: 2rem;\r\n  text-align: center;\r\n}\r\n\r\n.list {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  width: 100%;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  -webkit-box-pack: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n}\r\n\r\n@media screen and (max-width: 992px) {\r\n  .list {\r\n    -webkit-box-pack: start;\r\n    -ms-flex-pack: start;\r\n    justify-content: flex-start;\r\n  }\r\n}\r\n\r\n.list__item {\r\n  padding: 10px;\r\n  -webkit-padding-start: 48px;\r\n  padding-inline-start: 48px;\r\n  margin-bottom: 16px;\r\n  min-height: 48px;\r\n  border-radius: 48px;\r\n  -webkit-transition: 0.2s;\r\n  transition: 0.2s;\r\n  position: relative;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  font-size: 14px;\r\n  background: #00004E;\r\n}\r\n\r\n.list__label {\r\n  border-color: rgba(0, 0, 0, 0);\r\n  border-radius: 48px;\r\n  width: 100%;\r\n  height: 48px;\r\n  top: 0;\r\n  inset-inline-start: 0;\r\n  display: block;\r\n  position: absolute;\r\n  -webkit-transition: all 0.4s ease-in-out;\r\n  transition: all 0.4s ease-in-out;\r\n  z-index: 11;\r\n  height: 100%;\r\n}\r\n\r\n.list__label::before {\r\n  content: \"\";\r\n  width: 28px;\r\n  height: 28px;\r\n  background: #d1d1d1;\r\n  border-radius: 50%;\r\n  position: absolute;\r\n  inset-inline-start: 10px;\r\n  z-index: 11;\r\n  -webkit-transition: 0.4s;\r\n  transition: 0.4s;\r\n  line-height: 39px;\r\n  text-align: center;\r\n  font-size: 22px;\r\n  top: 50%;\r\n  margin-top: -14px;\r\n}\r\n\r\n.list__label .svg {\r\n  position: absolute;\r\n  inset-inline-start: 10px;\r\n  z-index: 111;\r\n  width: 28px;\r\n  height: 28px;\r\n  display: none;\r\n  -webkit-transition: 0.6s ease-in-out;\r\n  transition: 0.6s ease-in-out;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  -webkit-box-pack: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  font-size: 19px;\r\n  color: #00BF00;\r\n  top: 50%;\r\n  margin-top: -14px;\r\n}\r\n\r\n.list__label::before {\r\n  background: #fff;\r\n  width: 28px;\r\n  height: 28px;\r\n  inset-inline-start: 10px;\r\n  border-radius: 50%;\r\n  top: 50%;\r\n  margin-top: -14px;\r\n  border-color: rgba(0, 0, 0, 0);\r\n}\r\n\r\n.list__label .svg {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n}\r\n\r\n\r\n\r\n.list__item .list__title {\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  position: relative;\r\n  color: #fff;\r\n  z-index: 11;\r\n  line-height: 1.5;\r\n\r\n  width: 100%;\r\n  height: 100%;\r\n  top: 0;\r\n  display: block;\r\n  -webkit-transition: 0.5s;\r\n  transition: 0.5s;\r\n  z-index: 1;\r\n  border-radius: 30px;\r\n\r\n  opacity: 1;\r\n  display: inline-block;\r\n\r\n  padding-right: 0;\r\n  font-size: 1rem;\r\n}\r\n\r\n/* .journies_background{\r\n  padding: 1rem !important;\r\n  height: 24rem !important;\r\n\r\n} */\r\n.journies_continer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n}\r\n.divider {\r\n  width: 2px;\r\n  max-height: 27.183125rem;\r\n  margin-top: 20px;\r\n  margin-bottom: 20px;\r\n  background-color: rgb(216, 216, 216);\r\n  border-radius: 2px;\r\n}\r\n\r\n.my_top_section h1{\r\n  padding: 0 20px;\r\n  text-align: center;\r\n}\r\n\r\n.business_journey_section{\r\n  .journies_continer.temp-height{\r\n    margin: 2rem 0rem !important;\r\n    width: inherit !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .journies_continer {\r\n    flex-direction: column;\r\n  }\r\n  .journey_card_title{\r\n    height: auto;\r\n  }\r\n\r\n  \r\n\r\n  .divider {\r\n    height:2px;\r\n    width: 50%;\r\n    margin: auto;\r\n    background-color: rgb(216, 216, 216);\r\n  }\r\n\r\n}\r\n\r\n\r\n\r\n.journey_section1 {\r\n  flex: 1 ;\r\n  padding: 20px;\r\n}\r\n\r\n.journey_section2 {\r\n  flex: 2 ;\r\n  padding: 20px;\r\n}\r\n\r\n\r\n/* .journey_card{\r\n  min-width: 23.20875rem; \r\n  min-height: 27.183125rem;\r\n} */\r\n\r\n\r\n.journey_card_title p {\r\n  max-width: 100%;\r\n  white-space: nowrap;\r\n\r\n}\r\n\r\n.red {\r\n  background-color: #FF0020;\r\n}\r\n\r\n.blue {\r\n  background-color: #0064FF;;\r\n}\r\n\r\n\r\n.my_top_section{\r\n  height: fit-content;\r\n  display: flex;\r\n  flex-direction: column;\r\n  /* align-items: center; */\r\n}\r\n.business_journey_section{\r\n  width: inherit !important;\r\n  height: 22rem;  \r\n  align-items: normal;\r\n}\r\n.my_card {\r\n  flex: 1;\r\n    padding: 0 24px;\r\n\r\n}\r\n\r\n.homescreen_banner {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n/* .slider{\r\n  position: relative;\r\n  display: flex;\r\n  overflow-x: auto;\r\n  scroll-snap-type: x mandatory;\r\n  scroll-behavior: smooth;\r\n}\r\n\r\n.slider .list{\r\n  position: absolute;\r\n  width: max-content;\r\n  height: 100%;\r\n  left: 0;\r\n  top: 0;\r\n  display: flex;\r\n  flex-direction: row;\r\n  transition: 1s;\r\n}\r\n\r\n.slider .list .item{\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.slider .buttons{\r\n  position: absolute;\r\n  top: 45%;\r\n  left: 5%;\r\n  width: 90%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n.slider .buttons button{\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 50%;\r\n  background-color: #fff5;\r\n  color: #fff;\r\n  border: none;\r\n  font-family: monospace;\r\n  font-weight: bold;\r\n}\r\n.slider .dots{\r\n  position: absolute;\r\n  bottom: 10px;\r\n  left: 0;\r\n  color: #fff;\r\n  width: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.slider .dots li{\r\n  list-style: none;\r\n  width: 10px;\r\n  height: 10px;\r\n  background-color: #0e4e41;\r\n  margin: 10px;\r\n  border-radius: 20px;\r\n  transition: 0.5s;\r\n}\r\n.slider .dots li.active{\r\n  width: 30px;\r\n  background-color: #008755;\r\n}\r\n@media screen and (max-width: 768px){\r\n  .slider{\r\n      height: 400px;\r\n  }\r\n  .temp-height{\r\n    width: 100% !important;\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n.swiper-show-wrapper{\r\n  position: relative;\r\n  width: 100%;\r\n  margin: 0 auto;\r\n}\r\n \r\n.swiper-show-slider {\r\n  display: flex;\r\n  overflow-x: auto;\r\n  scroll-snap-type: x mandatory;\r\n  scroll-behavior: smooth;\r\n  box-shadow: 0 1.5rem 3 rem -0.75rem hsla(0, 0%, 0%, 0.25);\r\n}\r\n \r\n.swiper-show-item{\r\n  flex: 1 0 100%;\r\n  scroll-snap-align: start;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  aspect-ratio: 16/9;\r\n}\r\n \r\n.swiper-show-nav {\r\n  display: flex;\r\n  column-gap: 1rem;\r\n  position: relative;\r\n  bottom: 1.25rem;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  z-index: 1;\r\n}\r\n \r\n.swiper-show-nav a {\r\n  width: 0.5rem;\r\n  height: 0.5rem;\r\n  border-radius: 50%;\r\n  background-color: #0e4e41;\r\n  opacity: 0.75;\r\n  transition: opacity ease 250ms;\r\n}\r\n \r\n.swiper-show-nav a:hover {\r\n  opacity: 1;\r\n} */\r\n\r\n\r\n.swiper-pagination-bullet {\r\n opacity: 1;\r\n  background-color: #00BF00;\r\n  width: 0.75rem;\r\n  height: 0.75rem;\r\n  border-radius: 1.25rem;\r\n  transition: 0.5s ease;\r\n}\r\n\r\n.swiper-pagination-bullet-active {\r\n  background-color: #00BF00;\r\n  width: 2rem;\r\n}\r\n\r\n\r\n.swiper-pagination-bullet-slider {\r\n  background-color: white !important; \r\n    width: max-content !important;\r\n    border-radius: 0.25rem !important; \r\n    left: 50% !important; \r\n    transform: translateX(-50%) !important; \r\n    box-shadow: 0 1px 3px 1px hsla(0, 0%, 0%, 0.25) !important; \r\n    padding: 0 0.25rem;\r\n}\r\n\r\n\r\n.swiper_banner_04 {\r\n  content: url(\"../images/web-banner-04.svg\");\r\n}\r\n.swiper_banner_05 {\r\n  content: url(\"../images/web-banner-02.svg\");\r\n}\r\n.swiper_banner_06 {\r\n  content: url(\"../images/web-banner-06.svg\");\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n.text-top-j4s7 {\r\n  width: 100%;\r\n  padding-bottom: 2rem;\r\n}\r\n.text-bottom-j4s7 {\r\n  width: 100%;\r\n  padding-top: 2rem;\r\n}\r\n\r\n.newsletter{\r\n  width: 200px;\r\n}\r\n\r\n\r\n.hint-img {\r\n  content: url(\"../images/lx-hint.svg\");\r\n}\r\n\r\n.eligibility .container{\r\n  padding-top: 2rem;\r\n  padding-bottom: 2rem;\r\n}\r\n\r\n.eligibility-container{\r\n  margin: auto;\r\n  background-color: #F1F6E0;\r\n  border: 1px solid #ACD02A;\r\n  border-radius: 1rem;\r\n  padding: 1.25rem;\r\n\r\n  font-size: 1.5rem;\r\n  color: #004d41;\r\n  font-weight: 500;\r\n}\r\n\r\n.eligibility-container .eligibility-body {\r\n  font-size: 1.25rem;\r\n  color: #1F2020;\r\n  font-weight: 400;\r\n}\r\n\r\n.introduction-video, .workshop-video {\r\n  background-color: #E5E7EA;\r\n}\r\n.workshop-video{\r\n  position: relative;\r\n  padding: 0;  \r\n  z-index: 2;\r\n}\r\n.container-area {\r\n  background-color: white;\r\n  border-radius: 1rem;\r\n  padding: 3rem 1.25rem;\r\n}\r\n.container-area-journies{\r\n  padding: 0rem;\r\n}\r\n.journies_content{\r\n  background: #fff;\r\n  border-radius: 2rem;\r\n  padding: 1rem;\r\n}\r\n/* .journies_continer{\r\n  background: #F3F4F5;\r\n} */\r\n.search-sec{\r\n  background-color: #F7F8F8;\r\n}\r\n.search-sec .container{\r\n  padding-top: 2rem;\r\n  padding-bottom: 2rem;\r\n}\r\n.search-container {\r\n  margin: auto;\r\n  background-image: linear-gradient(to right, #76C08F, #338F73);\r\n  border-radius: 1rem;\r\n\r\n  display: flex;\r\n  padding: 3rem 6rem;\r\n}\r\n\r\n.search-btn{\r\n  align-items: center;\r\n  flex: 1;\r\n  display: flex;\r\n  justify-content: center; \r\n}\r\n\r\n\r\n.search-content{\r\n  flex: 2;\r\n}\r\n.search-content div{\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n\r\n.search-text{\r\n  margin-top: 0.75rem;\r\n  font-weight: 700;\r\n  color: white;\r\n  font-size: 1.75rem;\r\n}\r\n\r\n#search{\r\n  background-color: white;\r\n  font-weight: 700;\r\n  color: #004D41;\r\n  font-size: 1rem;\r\n  border-radius: 1rem;\r\n}\r\n\r\n.my_top_section{\r\n  background-color: #F3F4F5;\r\n  border-radius: 1rem;\r\n  width: 33%;\r\n  padding: 0rem 0rem 3.5rem 0;\r\n  /* padding: 1rem;\r\n  margin: 1rem; */\r\n}\r\n\r\n/* .journies-section{\r\n  background-color: #E5E7EA;\r\n} */\r\n\r\n.changes-jur{\r\n  margin-left: 1rem;\r\n  width: 66% ;\r\n}\r\n.changes-jur h1{\r\n  color: #00004E !important;\r\n}\r\n\r\n.elg{\r\n  color: #00004E !important;\r\n}\r\n\r\n\r\n.start-journey-text{\r\n  justify-content: space-between;\r\n  width: 100%;\r\n}\r\n/* .journeyStart{\r\n  padding-right: 0.4rem;\r\n} */\r\n\r\n.info-cards{\r\n  min-height: 6.631875rem;\r\n\r\n  display: flex;\r\n  margin: 0 1rem;\r\n  border-radius: 0.25rem;\r\n  align-items: center;\r\n}\r\n.info-card{\r\n  flex: 1;\r\n\r\n  border-radius: 0.25rem;\r\n  padding: 1rem 1.5rem 1rem;\r\n}\r\n\r\n.info-card .info-hint{\r\n  color: #333371;\r\n  font-size: 1em;\r\n  font-weight: 900;\r\n  text-align: center;\r\n}\r\n\r\n.info-card .info-hint2{\r\n\r\n\r\npadding-top: 0.75rem;\r\n  color: white;\r\n  font-size: 0.875em;\r\n  font-weight: 500;\r\n  text-align: center;\r\n}\r\n\r\n.info-card .info-hint3{\r\n  font-size: 0.9rem;\r\n    color: #BFBFD3;\r\n    text-align: center;\r\n}\r\n.rm-paddint-lr{\r\n  padding-left: 0%;\r\n  padding-right: 0%;\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .swiper_banner_04 {\r\n    content: url(\"../images/mobile_banner_01.svg\");\r\n  }\r\n  .swiper_banner_05 {\r\n    content: url(\"../images/mobile_banner_02.svg\");\r\n  }\r\n  .swiper_banner_06 {\r\n    content: url(\"../images/mobile_banner_03.svg\");\r\n  }\r\n\r\n\r\n  .search-container {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .search-content{\r\n    flex: 2;\r\n    align-items: center;\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-bottom: 0.5rem;\r\n    flex-direction: column;\r\n    text-align: center;\r\n  }\r\n  \r\n.my_top_section{\r\n  width: inherit;\r\n}\r\n  .changes-jur{\r\n    margin-bottom: 1rem;\r\n    margin-left: 0;\r\n  }\r\n  /* .my_top_section{\r\n    width: 100% !important;\r\n    min-width: 22rem;\r\n  } */\r\n  .journies_continer{\r\n    align-items: center;\r\n  }\r\n\r\n  .temp-height{\r\n    height: 30.652375rem !important;\r\n  }\r\n}\r\n\r\n.close-conversational{\r\n  font-size: 2.5rem;\r\n  font-weight: 100;\r\n}\r\n\r\n\r\n.popupModalCloseBtn {\r\n  border: 0 !important;\r\n  background-color: transparent !important;\r\n  top: 0rem;\r\n  right: 1rem;\r\n  cursor: pointer;\r\n\r\n  span {\r\n    padding: 0.75rem;\r\n  }\r\n\r\n  &:hover {\r\n    span {\r\n      font-weight: 600;\r\n    }\r\n  }\r\n}\r\n\r\n.conversational-header{\r\n  border: 0;\r\n}\r\n\r\n\r\nh6 {\r\n  font-size: 1.15rem;\r\n  line-height: 110%;\r\n  margin-top: 0.46rem;\r\n  margin-bottom: 0.46rem;\r\n}\r\n\r\n.category-tabs,.services-tabs,.newQue{\r\n  display: none;\r\n}\r\n\r\n#ServicesModel {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.25);\r\n  z-index: 999999;\r\n  display: none;\r\n\r\n\r\n  .popupModal {\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    margin-top: 150px;\r\n    margin-bottom: 5vh;\r\n    max-height: 100vh;\r\n    min-height: 45vh;\r\n    height: auto;\r\n    width: 50vw;\r\n    background-color: white;\r\n    border-radius: 0.5rem;\r\n    box-shadow: 0 5px 38px -6px rgb(0 0 0 / 5%);\r\n    padding: 1rem;\r\n    padding-top: 0rem;\r\n    text-align: center;\r\n    border: 1px solid #efefef;\r\n    position: relative;\r\n    overflow: hidden;\r\n    animation: fadeIn 0.5s;\r\n\r\n    .close {\r\n      font-size: 2.5rem;\r\n      font-weight: 100;\r\n    }\r\n\r\n    .close:hover {\r\n      font-weight: 100 !important;\r\n    }\r\n\r\n    #popupModalTitle {\r\n      font-weight: 500;\r\n      padding-left: 1rem;\r\n      padding-right: 0rem;\r\n      padding-top: 0.5rem;\r\n      padding-bottom: 1rem;\r\n      width: calc(100%);\r\n      min-height: 2rem;\r\n    }\r\n\r\n    .popupModalCloseBtn {\r\n      position: absolute;\r\n      top: 0rem;\r\n      right: 1rem;\r\n      cursor: pointer;\r\n\r\n      span {\r\n        padding: 0.75rem;\r\n      }\r\n\r\n      &:hover {\r\n        span {\r\n          font-weight: 600;\r\n        }\r\n      }\r\n    }\r\n\r\n    .title-message {\r\n      display: flex;\r\n      flex-direction: column;\r\n      align-items: end;\r\n\r\n      .modalTitle {\r\n        text-align: end;\r\n        padding-bottom: 2rem;\r\n      }\r\n    }\r\n\r\n\r\n\r\n    .messageContainer {\r\n      \r\n      position: absolute;\r\n      top: 1rem;\r\n      right: 3.5rem;\r\n      width: 91%;\r\n      font-size: 0.9rem;\r\n\r\n      display: none; \r\n\r\n      flex-direction: row-reverse;\r\n      padding: 0.5rem;\r\n      border-radius: 0.5rem;\r\n\r\n      animation: fadeIn 1s;\r\n    }\r\n\r\n    .notClearInfo {\r\n      background-color: #EEF6D5;\r\n    }\r\n\r\n    .categoryInfo {\r\n      display: none;\r\n      flex-direction: row-reverse;\r\n      padding: 0.5rem;\r\n      margin-bottom: 3rem;\r\n      border-radius: 0.5rem;\r\n\r\n      animation: fadeIn 1s;\r\n      background-color: #F3EDDA;\r\n\r\n      .note {\r\n        text-align: end;\r\n      }\r\n    }\r\n\r\n    @media screen and (max-width: 768px){\r\n  .slider{\r\n      height: 400px;\r\n  }\r\n  .temp-height{\r\n    width: 100% !important;\r\n  }\r\n}\r\n    .modalHeader {\r\n      display: flex;\r\n      flex-direction: row-reverse;\r\n      justify-content: space-between;\r\n      width: 100%;\r\n    }\r\n\r\n    .role {\r\n      display: none;\r\n      flex-direction: row-reverse;\r\n      justify-content: end;\r\n      align-items: center;\r\n      gap: 0.1rem;\r\n      padding: 1rem 0.5rem;\r\n      cursor: pointer;\r\n\r\n    }\r\n\r\n    .breadCrumb {\r\n      color: #A7A8AA;\r\n    }\r\n\r\n    .breadCrumb-text {\r\n      display: flex;\r\n      flex-direction: row-reverse;\r\n      align-items: center;\r\n    }\r\n\r\n\r\n\r\n\r\n    .contentContainer {\r\n      padding: 5rem 0rem 3rem 0rem;\r\n      display: flex;\r\n      direction: ltr;\r\n      flex-direction: column;\r\n      justify-content: start;\r\n      align-items: end;\r\n    }\r\n\r\n    .modelMessage {\r\n      padding: 1rem;\r\n      background-color: #EEF6D5;\r\n      border-radius: 0rem 0.8rem 0.8rem 0.8rem;\r\n      font-size: 1rem;\r\n      font-weight: bold;\r\n      width: fit-content;\r\n    }\r\n\r\n    .quistion {\r\n      display: flex;\r\n      padding-top: 1rem;\r\n    }\r\n\r\n    .message {\r\n      padding: 0rem 2rem 0rem 2rem;\r\n      margin-top: 1rem;\r\n    }\r\n\r\n    .modalBody {\r\n      min-height: 10rem;\r\n      padding: 2rem 0rem 3rem 0rem;\r\n    }\r\n\r\n    .modalCategory {\r\n      padding-top: 1rem;\r\n      display: flex;\r\n      flex-direction: row-reverse;\r\n      justify-content: end;\r\n      gap: 0.5rem;\r\n      flex-wrap: wrap;\r\n      width: 100%;\r\n    }\r\n\r\n    .category {\r\n      border: none;\r\n      background: #F7F8F8;\r\n      border-radius: 1rem;\r\n      padding: 0.5rem 1rem;\r\n      font-weight: 350;\r\n      cursor: pointer;\r\n      transition: transform 250ms;\r\n      font-family: 'Ping AR + LT', sans-serif;\r\n\r\n      &:hover {\r\n        background-color: #EEF6D5;\r\n        color: #004D41;\r\n        transform: translateY(-3px);\r\n      }\r\n    }\r\n\r\n    .notClear {\r\n      text-align: center;\r\n      font-weight: 500;\r\n      color: #004D41;\r\n      position: absolute;\r\n      bottom: 2rem;\r\n      right: 50%;\r\n      cursor: pointer;\r\n\r\n      &:hover {\r\n        color: #ABD02B;\r\n      }\r\n    }\r\n\r\n    .back-btn {\r\n      width: fit-content;\r\n      display: none;\r\n      flex-direction: row-reverse;\r\n      align-items: center;\r\n      border: none;\r\n      border-radius: 0.5rem;\r\n      background: white;\r\n      padding: 1rem 0rem 1rem 1rem;\r\n      color: #004D41;\r\n      box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);\r\n      position: absolute;\r\n      bottom: 1.5rem;\r\n      right: 2rem;\r\n      cursor: pointer;\r\n\r\n      &:hover {\r\n        color: white;\r\n        background: #00AE9A;\r\n      }\r\n\r\n    }\r\n  }\r\n}\r\n\r\n\r\n.opacity-transtion{\r\n  transition: opacity 0.5s ease-in-out, height 0.5s ease-in-out;\r\n  display: none ;\r\n}\r\n.opacity-transtion.shown{\r\n  opacity: 1;\r\n  display: block ;\r\n}\r\n.opacity-transtion.hidden{\r\n  opacity: 0;\r\n  display: none ;\r\n}\r\n#OTP-tab {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.25);\r\n  z-index: 999999;\r\n\r\n\r\n  .popupModal {\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    margin-top: 150px;\r\n    margin-bottom: 5vh;\r\n    max-height: 100vh;\r\n    height: auto;\r\n    width: 34.1875rem;\r\n    background-color: white;\r\n    border-radius: 0.5rem;\r\n    box-shadow: 0 5px 38px -6px rgb(0 0 0 / 5%);\r\n    padding: 1rem;\r\n    padding-top: 0rem;\r\n    text-align: center;\r\n    border: 1px solid #efefef;\r\n    position: relative;\r\n    overflow: hidden;\r\n    animation: fadeIn 0.5s;\r\n\r\n    .close {\r\n      font-size: 2.5rem;\r\n      font-weight: 100;\r\n    }\r\n\r\n    .close:hover {\r\n      font-weight: 100 !important;\r\n    }\r\n\r\n    #popupModalTitle {\r\n      font-weight: 500;\r\n      padding-left: 1rem;\r\n      padding-right: 0rem;\r\n      padding-top: 0.5rem;\r\n      padding-bottom: 1rem;\r\n      width: calc(100%);\r\n      min-height: 2rem;\r\n    }\r\n    \r\n    .otp-header{\r\n      width: 100%;\r\n      display: flex;\r\n      flex-direction: row;\r\n\r\n      .popupModalCloseBtn {\r\n      \r\n        padding: 1.5rem 0 0 0.625rem;\r\n  \r\n        cursor: pointer;\r\n  \r\n        &:hover {\r\n          span {\r\n            font-weight: 600;\r\n          }\r\n        }\r\n      }\r\n\r\n      .otp-icon-Container {\r\n        padding: 2.187rem 1.187rem 0 0 ;\r\n        flex: 1;\r\n        text-align: right;\r\n      \r\n        width: 100%;\r\n        font-size: 0.9rem;\r\n  \r\n        flex-direction: row-reverse;\r\n        border-radius: 0.5rem;\r\n  \r\n        animation: fadeIn 1s;\r\n      }\r\n    }\r\n    \r\n\r\n    .otp-send-tab{\r\n      padding-top: 1.25rem;\r\n      \r\n      display: flex;\r\n      flex-direction: row-reverse;\r\n      justify-content: end;\r\n      gap: 0.5rem;\r\n      flex-wrap: wrap;\r\n      width: 100%;\r\n\r\n      \r\n      .tab-span{\r\n        width: 100%;\r\n        padding-bottom: 2rem;\r\n        color: #1F2020;\r\n        font-weight: 500;\r\n        font-size: 1.5em;\r\n        text-align: right;\r\n      }\r\n      \r\n      .new-otp-resend {\r\n        width: 100%; \r\n        height: 2rem;\r\n        color: #1F2020;\r\n        font-weight: 400;\r\n        font-size: 1.25em;\r\n        text-align: center;\r\n      }\r\n      .new-otp-resend\r\n      \r\n      .new-otp-resend-shown{\r\n        cursor: pointer;\r\n        color: #004D41 ;\r\n        text-decoration: underline;\r\n      }\r\n    }\r\n\r\n    \r\n    .contentContainer {\r\n      padding: 0rem 1.25rem 2.125rem;\r\n      display: flex;\r\n      direction: ltr;\r\n      flex-direction: column;\r\n      justify-content: start;\r\n      align-items: end;\r\n    }\r\n\r\n    .modalBody {\r\n      min-height: 10rem;\r\n      padding: 0rem;\r\n    }\r\n\r\n    .otpContainer{\r\n      width: 100%;\r\n      display: flex;\r\n      flex-direction: row;\r\n      justify-content: space-between;\r\n      margin-bottom: 1.5rem;\r\n    }\r\n\r\n    .input-field{\r\n      width: 23.157%;\r\n      \r\n    }\r\n.input-field input {\r\n  border: none;\r\n  border-bottom: 1px solid #9e9e9e;\r\n  outline: none;\r\n  height: 6.1875rem;\r\n  width: 100%;\r\n  margin: 0 0 8px;\r\n  padding: 0;\r\n  box-shadow: none;\r\n  padding-left: 10px;\r\n  border-style: solid;\r\n  border-width: 1px;\r\n  border-color: #eaeaea;\r\n  border-radius: 0.75rem;\r\n  background-color: #fcfcfc;\r\n  padding-right: 10px;\r\n  box-sizing: border-box;\r\n  font-weight: 400;\r\n  font-family: Ping AR + LT!important;\r\n  text-align: center;\r\n  color: #1F2020;\r\n  font-size: 2em;\r\n}\r\n\r\n  }\r\n\r\n} \r\n/* @media (max-width: 600px){\r\n  .opacity-transtion.shown{\r\n    opacity: 1;\r\n    display: flex ;\r\n  }\r\n  #OTP-tab {\r\n  .popupModal {\r\n    align-self: flex-end;\r\n    margin: 0;\r\n    width: 100vw;\r\n    border-radius: 0.5rem 0.5rem 0 0;\r\n\r\n    .otp-send-tab{\r\n      .new-otp-resend {\r\n        width: 100%;\r\n        color: #1F2020;\r\n        font-weight: 400;\r\n        font-size: 1.25em;\r\n        text-align: center;\r\n        padding-bottom: 3rem;\r\n      }\r\n    }\r\n\r\n    .input-field{\r\n      width: 23.157%;\r\n      \r\n    }\r\n.input-field input {\r\n  border: none;\r\n  border-bottom: 1px solid #9e9e9e;\r\n  outline: none;\r\n  height: 6.1875rem;\r\n  width: 100%;\r\n  margin: 0 0 8px;\r\n  padding: 0;\r\n  box-shadow: none;\r\n  padding-left: 10px;\r\n  border-style: solid;\r\n  border-width: 1px;\r\n  border-color: #eaeaea;\r\n  border-radius: 0.75rem;\r\n  background-color: #fcfcfc;\r\n  padding-right: 10px;\r\n  box-sizing: border-box;\r\n  font-weight: 400;\r\n  font-family: Ping AR + LT!important;\r\n  text-align: center;\r\n  color: #1F2020;\r\n  font-size: 2em;\r\n}\r\n\r\n  }\r\n}\r\n} */\r\n\r\n\r\n.conection-latter{\r\n  max-height: fit-content;\r\n}\r\n.conection-latter-txt{\r\n  font-weight: 500;\r\n  font-size: 2em;\r\n  color: #00004E;\r\n  max-height: fit-content;\r\n\r\n}\r\n.modalFade {\r\n  animation: fadeIn 0.3s;\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .journeys {\r\n    padding-right: 2rem;\r\n    padding-left: 2rem;\r\n  }\r\n}\r\n\r\n@keyframes fadeIn {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 767px){\r\n\r\n  .temp-height{\r\n    width: 100% !important;\r\n  }\r\n}\r\n\r\n.journey-sections-titles{\r\n  margin-top: 2.687rem !important;\r\n  margin-bottom: 1.875rem !important;\r\n}\r\n\r\n\r\n.jur-button-cont{\r\n  height: 5rem;\r\n  position: relative;\r\n  width: 80%;\r\n  right: 2.5rem;\r\n}\r\n\r\n\r\n.cont-height{\r\n  height: fit-content !important;\r\n}\r\n@media (min-width: 576px) {\r\n  .journies_continer{\r\n    height: 59.76175rem;\r\n  }\r\n  .article-card figure {\r\n    min-height: 13.318125rem;\r\n  }\r\n  \r\n}\r\n\r\n@media (max-width: 768px){\r\n  .calc-btn{\r\n    width: 100% !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px){\r\n  \r\n  .journies_continer{\r\n    height: 60.652375rem;\r\n  }\r\n  .cont-height{\r\n    height: fit-content !important;\r\n  }\r\n\r\n  .article-card figure {\r\n    min-height: 17.5rem;\r\n  }\r\n\r\n  .info-cards{\r\n    min-height: 6.631875rem;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .journies_continer{\r\n    height: 26.5rem;\r\n  }\r\n  .article-card figure {\r\n    min-height: 7rem;\r\n  }\r\n  .info-cards{\r\n    min-height: 9rem;\r\n  }\r\n}\r\n\r\n\r\n@media (min-width: 1200px){\r\n  .journies_continer{\r\n    height: 26rem;\r\n  }\r\n  .article-card figure {\r\n    min-height: 9rem;\r\n  }\r\n  .info-cards{\r\n    min-height: 6.631875rem;\r\n  }\r\n}\r\n\r\n@media (min-width: 1400px){\r\n  .journies_continer{\r\n    height: 28rem;\r\n  }\r\n  .article-card figure {\r\n    /* min-height: 10rem; */\r\n    min-height: 12rem;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
